const tokens = {
  "borderThickness": {
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "buttonSize": {
    "16": 16,
    "20": 20,
    "24": 24,
    "32": 32,
    "40": 40,
    "48": 48,
    "56": 56
  },
  "color": {
    "blackAlpha": {
      "50": "#0000000D",
      "100": "#0000001A",
      "200": "#00000033",
      "300": "#0000004D",
      "400": "#00000066",
      "500": "#00000080",
      "600": "#00000099",
      "700": "#000000B3",
      "800": "#000000CC",
      "900": "#000000E6",
      "1000": "#000000"
    },
    "blue": {
      "25": "#F5F9FF",
      "50": "#E5EFFF",
      "75": "#D9E7FF",
      "100": "#CCDFFF",
      "200": "#99C0FF",
      "300": "#68A2FF",
      "350": "#408AFF",
      "400": "#3381FF",
      "450": "#277BFF",
      "475": "#106CFF",
      "500": "#0062FF",
      "600": "#004ECC",
      "700": "#0044B2",
      "800": "#003B99",
      "900": "#003180",
      "950": "#002766",
      "975": "#001D4C"
    },
    "calendar": {
      "cyan": {
        "25": "#F9FAFB",
        "50": "#C3EAF5",
        "75": "#AFE4F2",
        "100": "#9BDEEE",
        "200": "#72D0E7",
        "300": "#48C3DF",
        "400": "#20B6D9",
        "500": "#06A5C9",
        "600": "#088DAD",
        "700": "#087691",
        "800": "#0A5F75",
        "900": "#0B485A",
        "925": "#0C3C4C",
        "950": "#0D2D3A"
      },
      "fuchsia": {
        "25": "#F9FAFB",
        "50": "#F2D3FC",
        "75": "#EEC4FB",
        "100": "#EBB4F9",
        "200": "#E595F7",
        "300": "#DE76F4",
        "400": "#D757F2",
        "500": "#CA40E5",
        "600": "#BA24D5",
        "700": "#972DA9",
        "800": "#7D248C",
        "900": "#641B6E",
        "925": "#581760",
        "950": "#460F4B"
      },
      "grayBlue": {
        "25": "#F9FAFB",
        "50": "#D4D8EB",
        "75": "#C5CAE4",
        "100": "#B7BDDC",
        "200": "#99A2CD",
        "300": "#7D87BE",
        "400": "#606CAF",
        "500": "#49569C",
        "600": "#3E4883",
        "700": "#323A6A",
        "800": "#262C51",
        "900": "#212748",
        "925": "#15182D",
        "950": "#0D0F1C"
      },
      "green": {
        "25": "#F9FAFB",
        "50": "#C9ECDE",
        "75": "#B4E6CF",
        "100": "#A1DFC2",
        "200": "#7AD3A8",
        "300": "#55C78E",
        "400": "#2DBB74",
        "500": "#14AA5F",
        "600": "#129252",
        "700": "#0E7844",
        "800": "#0B6037",
        "900": "#08482A",
        "925": "#073E25",
        "950": "#052E1C"
      },
      "moss": {
        "25": "#F9FAFB",
        "50": "#D8E7CF",
        "75": "#CDDFBE",
        "100": "#C1D8AD",
        "200": "#A7C787",
        "300": "#8FB965",
        "400": "#74A83E",
        "500": "#619728",
        "600": "#518121",
        "700": "#436C1C",
        "800": "#345616",
        "900": "#254010",
        "925": "#1F370E",
        "950": "#15290A"
      },
      "orange": {
        "25": "#F9FAFB",
        "50": "#F7DACC",
        "75": "#F7CFBB",
        "100": "#F6C2A7",
        "200": "#F4A981",
        "300": "#F2915D",
        "400": "#F07736",
        "500": "#E46320",
        "600": "#C7551C",
        "700": "#A94618",
        "800": "#8D3916",
        "900": "#722C13",
        "925": "#632512",
        "950": "#511C10"
      },
      "rose": {
        "25": "#F9FAFB",
        "50": "#F9D2DE",
        "75": "#F9C1D0",
        "100": "#F8B1C4",
        "200": "#F890AA",
        "300": "#F77291",
        "400": "#F65077",
        "500": "#E93862",
        "600": "#CC3056",
        "700": "#AE274A",
        "800": "#901D3D",
        "900": "#711431",
        "925": "#65112C",
        "950": "#510B24"
      },
      "violet": {
        "25": "#F9FAFB",
        "50": "#E1D9FD",
        "75": "#D7CAFD",
        "100": "#CCBCFB",
        "200": "#B9A1FA",
        "300": "#A687F8",
        "400": "#926BF7",
        "500": "#8055EC",
        "600": "#7048D1",
        "700": "#603BB5",
        "800": "#502E99",
        "900": "#40217D",
        "925": "#381A6F",
        "950": "#2E125E"
      },
      "yellow": {
        "25": "#F9FAFB",
        "50": "#F6EAC9",
        "75": "#F5E3B3",
        "100": "#F3DC9E",
        "200": "#F1CE75",
        "300": "#EFC04C",
        "400": "#EBB222",
        "500": "#DFA008",
        "600": "#C48A09",
        "700": "#A8730A",
        "800": "#8D5C0C",
        "900": "#72450B",
        "925": "#653A0C",
        "950": "#542C0D"
      }
    },
    "gradient": {
      "earth": {
        "1": "#0D3325",
        "2": "#389864",
        "3": "#D8FF68"
      },
      "jupiter": {
        "1": "#330033",
        "2": "#8D008D",
        "3": "#FFF435"
      },
      "mars": {
        "1": "#360E44",
        "2": "#BA3C71",
        "3": "#FFA37B"
      },
      "mercury": {
        "1": "#B81F56",
        "2": "#E07B32",
        "3": "#EDDC82"
      },
      "moon": {
        "1": "#161E21",
        "2": "#516573",
        "3": "#EAEAEA"
      },
      "neptune": {
        "1": "#000E57",
        "2": "#0087B4",
        "3": "#2CFFA7"
      },
      "pluto": {
        "1": "#0D2700",
        "2": "#B17C16",
        "3": "#FFE5A2"
      },
      "saturn": {
        "1": "#000F2B",
        "2": "#2B778E",
        "3": "#FFFCA8"
      },
      "uranus": {
        "1": "#000744",
        "2": "#4A54B2",
        "3": "#C3E2FE"
      },
      "venus": {
        "1": "#170035",
        "2": "#541CB0",
        "3": "#D3A8FF"
      }
    },
    "green": {
      "25": "#F7FDF9",
      "50": "#EAFAF0",
      "100": "#D6F5E1",
      "200": "#ADEBC4",
      "300": "#84E1A6",
      "400": "#46D27A",
      "500": "#2FC063",
      "600": "#28A455",
      "700": "#23904B",
      "800": "#1E7B40",
      "900": "#196735",
      "950": "#14522B",
      "975": "#0F3E20"
    },
    "grey": {
      "25": "#FAFCFF",
      "50": "#F5F7F9",
      "75": "#EFF2F6",
      "100": "#EBEDF0",
      "150": "#E0E3E8",
      "200": "#D6DBE4",
      "250": "#CCD2DD",
      "300": "#C4CBD6",
      "400": "#A9B0BC",
      "500": "#8F909E",
      "600": "#666A73",
      "700": "#4E5158",
      "800": "#43464B",
      "900": "#3A3C41",
      "950": "#292A2E",
      "975": "#202124",
      "980": "#161819",
      "990": "#111314",
      "1000": "#000000"
    },
    "peach": {
      "100": "#F7CBA7",
      "200": "#F4BB8C",
      "300": "#F2A970",
      "400": "#FC9549",
      "500": "#FF7008",
      "600": "#DC5D00"
    },
    "pink": {
      "100": "#EFBED0",
      "200": "#EBAEC5",
      "300": "#E590AE",
      "400": "#F179A4",
      "500": "#D9477C",
      "600": "#C03D67"
    },
    "red": {
      "25": "#FFF7F7",
      "50": "#FEE6E6",
      "100": "#FDCECE",
      "200": "#FB9D9D",
      "300": "#FA7979",
      "400": "#F94C4C",
      "500": "#F60909",
      "600": "#C71C1C",
      "700": "#AC0606",
      "800": "#940505",
      "900": "#7B0404",
      "950": "#620404",
      "975": "#4A0303"
    },
    "salad": {
      "100": "#CBFC6F",
      "200": "#BEFC58",
      "300": "#B1F84E",
      "400": "#9CD340",
      "500": "#65A400",
      "600": "#658E29"
    },
    "tiffany": {
      "100": "#89EAFC",
      "200": "#75E7FC",
      "300": "#6AE2FB",
      "400": "#53DBED",
      "500": "#00ACC2",
      "600": "#4295A7"
    },
    "violet": {
      "100": "#C8B4F6",
      "200": "#BBA1F4",
      "300": "#AD8EF2",
      "400": "#B996F5",
      "500": "#9A64F7",
      "600": "#7646EC"
    },
    "whiteAlpha": {
      "50": "#FFFFFF0D",
      "100": "#FFFFFF1A",
      "200": "#FFFFFF33",
      "300": "#FFFFFF4D",
      "400": "#FFFFFF66",
      "500": "#FFFFFF80",
      "600": "#FFFFFF99",
      "700": "#FFFFFFB3",
      "800": "#FFFFFFCC",
      "900": "#FFFFFFE6",
      "1000": "#FFFFFF"
    },
    "yellow": {
      "25": "#FFFCF5",
      "50": "#FFF8E6",
      "100": "#FEF2CC",
      "200": "#FEE59A",
      "300": "#FDD868",
      "400": "#FCC51C",
      "500": "#FDA502",
      "600": "#F79008",
      "700": "#DC6803",
      "800": "#B54708",
      "900": "#93370D",
      "950": "#792E0D",
      "975": "#592007"
    }
  },
  "iconSize": {
    "4": 4,
    "6": 6,
    "8": 8,
    "10": 10,
    "12": 12,
    "14": 14,
    "16": 16,
    "20": 20,
    "24": 24,
    "32": 32,
    "40": 40,
    "48": 48,
    "56": 56,
    "96": 96
  },
  "radius": {
    "2": 2,
    "4": 4,
    "6": 6,
    "8": 8,
    "10": 10,
    "12": 12,
    "16": 16,
    "24": 24,
    "32": 32,
    "48": 48,
    "56": 56,
    "64": 64,
    "72": 72,
    "9999": 9999
  },
  "spacing": {
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "6": 6,
    "7": 7,
    "8": 8,
    "10": 10,
    "11": 11,
    "12": 12,
    "14": 14,
    "15": 15,
    "16": 16,
    "19": 19,
    "24": 24,
    "32": 32,
    "40": 40,
    "48": 48,
    "56": 56,
    "64": 64,
    "72": 72,
    "80": 80,
    "88": 88,
    "96": 96
  },
  "theme": {
    "dark": {
      "avatar": {
        "controls": {
          "close": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 3
            },
            "icon": "delete_small",
            "iconSize": {
              "l": "s",
              "m": "s",
              "s": "s",
              "xl": "s",
              "xs": "xs",
              "xxl": "l",
              "xxxl": "l"
            },
            "size": {
              "l": 16,
              "m": 16,
              "s": 16,
              "xl": 16,
              "xs": 12,
              "xxl": 24,
              "xxxl": 24
            }
          },
          "counter": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 4
            },
            "radius": {
              "l": 8,
              "m": 8,
              "s": 8,
              "xl": 8,
              "xs": 8,
              "xxl": 8,
              "xxxl": 32
            },
            "size": {
              "l": 16,
              "m": 16,
              "s": 12,
              "xl": 16,
              "xs": 12,
              "xxl": 20,
              "xxxl": 24
            },
            "typography": {
              "l": "body2",
              "m": "body2",
              "s": "caption1",
              "xl": "body2",
              "xs": "caption2",
              "xxl": "h6",
              "xxxl": "h5"
            }
          },
          "online": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 5
            },
            "icon": "Fill",
            "iconSize": {
              "l": "xs",
              "m": "xxs",
              "s": "xxs",
              "xl": "xs",
              "xs": "xxxs",
              "xxl": "m",
              "xxxl": "l"
            },
            "size": {
              "l": 8,
              "m": 6,
              "s": 6,
              "xl": 8,
              "xs": 4,
              "xxl": 16,
              "xxxl": 16
            }
          },
          "slot": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 4
            },
            "iconSize": {
              "l": "xs",
              "m": "xs",
              "s": "xs",
              "xl": "s",
              "xs": "xxs",
              "xxl": "l",
              "xxxl": "xl"
            },
            "size": {
              "l": 20,
              "m": 20,
              "s": 20,
              "xl": 24,
              "xs": 16,
              "xxl": 40,
              "xxxl": 48
            }
          }
        },
        "letterCount": {
          "l": 2,
          "m": 2,
          "s": 2,
          "xl": 2,
          "xs": 1,
          "xxl": 2,
          "xxxl": 2
        },
        "size": {
          "avatar": {
            "l": 48,
            "m": 40,
            "s": 32,
            "xl": 56,
            "xs": 24,
            "xxl": 96,
            "xxxl": 128
          },
          "icon": {
            "l": "l",
            "m": "m",
            "s": "s",
            "xl": "xl",
            "xs": "xs",
            "xxl": "xxxxl",
            "xxxl": "xxxxxl"
          }
        },
        "typography": {
          "l": "button1",
          "m": "button2",
          "s": "caption1",
          "xl": "h6",
          "xs": "caption1",
          "xxl": "h2",
          "xxxl": "h2"
        },
        "variant": {
          "rounded": {
            "borderRadius": 50
          },
          "square": {
            "borderRadius": 25
          }
        }
      },
      "avatarV2": {
        "borderRadius": {
          "rounded": {
            "size": {
              "l": 9999,
              "m": 9999,
              "s": 9999,
              "xl": 9999,
              "xs": 9999,
              "xxl": 9999,
              "xxxl": 9999,
              "xxxxl": 9999
            }
          },
          "square": {
            "size": {
              "l": 12,
              "m": 12,
              "s": 8,
              "xl": 16,
              "xs": 6,
              "xxl": 24,
              "xxxl": 32,
              "xxxxl": 72
            }
          }
        },
        "icon": {
          "l": "l",
          "m": "m",
          "s": "s",
          "xl": "xl",
          "xs": "xs",
          "xxl": "xxxl",
          "xxxl": "xxxxl",
          "xxxxl": "xxxxxl"
        },
        "letterCount": {
          "l": 2,
          "m": 2,
          "s": 2,
          "xl": 2,
          "xs": 1,
          "xxl": 2,
          "xxxl": 2,
          "xxxxl": 2
        },
        "size": {
          "l": 48,
          "m": 40,
          "s": 32,
          "xl": 56,
          "xs": 24,
          "xxl": 96,
          "xxxl": 128,
          "xxxxl": 210
        },
        "slot": {
          "border": {
            "l": 2,
            "m": 2,
            "s": 2,
            "xl": 2,
            "xs": 2,
            "xxl": 3,
            "xxxl": 4,
            "xxxxl": 4
          },
          "offset": {
            "l": 6,
            "m": 6,
            "s": 6,
            "xl": 8,
            "xs": 6,
            "xxl": 8,
            "xxxl": 8,
            "xxxxl": 0
          },
          "size": {
            "l": 24,
            "m": 24,
            "s": 20,
            "xl": 32,
            "xs": 18,
            "xxl": 40,
            "xxxl": 48,
            "xxxxl": 56
          },
          "variant": {
            "avatar": {
              "borderRadius": {
                "rounded": {
                  "size": {
                    "l": 9999,
                    "m": 9999,
                    "s": 9999,
                    "xl": 9999,
                    "xs": 9999,
                    "xxl": 9999,
                    "xxxl": 9999
                  }
                },
                "square": {
                  "size": {
                    "l": 8,
                    "m": 8,
                    "s": 8,
                    "xl": 10,
                    "xs": 8,
                    "xxl": 14,
                    "xxxl": 16,
                    "xxxxl": 20
                  }
                }
              },
              "size": {
                "l": "xs",
                "m": "xs",
                "s": "xs",
                "xl": "s",
                "xs": "xs",
                "xxl": "m",
                "xxxl": "l",
                "xxxxl": "xl"
              }
            },
            "badge": {
              "l": "s",
              "m": "s",
              "s": "s",
              "xl": "m",
              "xs": "s",
              "xxl": "m",
              "xxxl": "m",
              "xxxxl": "m"
            },
            "iconImage": {
              "background": {
                "l": 24,
                "m": 24,
                "s": 20,
                "xl": 32,
                "xs": 18,
                "xxl": 40,
                "xxxl": 48,
                "xxxxl": 56
              },
              "icon": {
                "l": "s",
                "m": "s",
                "s": "xs",
                "xl": "m",
                "xs": "xxs",
                "xxl": "l",
                "xxxl": "xl",
                "xxxxl": "xxl"
              }
            },
            "online": {
              "l": "xs",
              "m": "xs",
              "s": "xs",
              "xl": "xs",
              "xs": "xs",
              "xxl": "m",
              "xxxl": "m",
              "xxxxl": "m"
            }
          }
        },
        "typography": {
          "l": "button1",
          "m": "button2",
          "s": "caption1",
          "xl": "h6",
          "xs": "caption2",
          "xxl": "h2",
          "xxxl": "h2",
          "xxxxl": "h1"
        }
      },
      "badge": {
        "borderRadius": {
          "m": 32,
          "s": 32,
          "xs": 32
        },
        "horizontalPadding": {
          "m": 6,
          "s": 4
        },
        "icon": {
          "m": 12,
          "s": 8
        },
        "size": {
          "m": 18,
          "s": 14,
          "xs": 8
        },
        "typography": {
          "m": "caption1",
          "s": "caption2"
        }
      },
      "border": {
        "l": 4,
        "m": 3,
        "s": 2,
        "xl": 5,
        "xs": 1
      },
      "button": {
        "borderRadius": {
          "l": 8,
          "m": 8,
          "s": 8,
          "xl": 12,
          "xs": 6,
          "xxs": 4,
          "xxxs": 4
        },
        "icon": {
          "nonText": {
            "l": "m",
            "m": "m",
            "s": "s",
            "xl": "l",
            "xs": "s",
            "xxs": "s",
            "xxxs": "xs"
          },
          "text": {
            "l": "s",
            "m": "s",
            "s": "xs",
            "xl": "s",
            "xs": "xxxs",
            "xxs": "xxxs",
            "xxxs": "xxxs"
          }
        },
        "size": {
          "l": 48,
          "m": 40,
          "s": 32,
          "xl": 56,
          "xs": 24,
          "xxs": 20,
          "xxxs": 16
        },
        "spacing": {
          "horizontal": {
            "inner": {
              "nonText": {
                "l": 8,
                "m": 8,
                "s": 8,
                "xl": 8,
                "xs": 8,
                "xxs": 4,
                "xxxs": 4
              },
              "text": {
                "l": 8,
                "m": 8,
                "s": 6,
                "xl": 8,
                "xs": 4,
                "xxs": 4,
                "xxxs": 4
              }
            },
            "outer": {
              "l": 16,
              "m": 16,
              "s": 12,
              "xl": 16,
              "xs": 8,
              "xxs": 4,
              "xxxs": 4
            }
          },
          "vertical": {
            "content": {
              "l": 15,
              "m": 11,
              "s": 7,
              "xl": 19,
              "xs": 3,
              "xxs": 1,
              "xxxs": 1
            },
            "icon": {
              "l": 14,
              "m": 10,
              "s": 8,
              "xl": 16,
              "xs": 4,
              "xxs": 2,
              "xxxs": 2
            }
          }
        },
        "typography": {
          "nonText": {
            "l": "button1",
            "m": "button1",
            "s": "button2",
            "xl": "button1",
            "xs": "button2",
            "xxs": "body2",
            "xxxs": "caption2"
          },
          "text": {
            "l": "button1",
            "m": "button1",
            "s": "button2",
            "xl": "button1",
            "xs": "caption2",
            "xxs": "caption2",
            "xxxs": "caption2"
          }
        }
      },
      "buttonGroup": {
        "spacing": {
          "m": 16
        }
      },
      "chip": {
        "borderRadius": {
          "xxs": 4,
          "xxxs": 4
        },
        "icon": {
          "xxs": "s",
          "xxxs": "xs"
        },
        "size": {
          "xxs": 20,
          "xxxs": 16
        },
        "spacing": {
          "gap": {
            "xxs": 4,
            "xxxs": 4
          },
          "horizontal": {
            "default": {
              "xxs": 4,
              "xxxs": 4
            },
            "onlyIcon": {
              "xxs": 2,
              "xxxs": 2
            }
          }
        },
        "typography": {
          "xxs": "body2",
          "xxxs": "caption2"
        }
      },
      "color": {
        "blueElevation1": {
          "accent": "#68A2FF",
          "additional": "#277BFF",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#FAFCFF",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#99C0FF",
          "main": "#003180",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "blueElevation2": {
          "accent": "#68A2FF",
          "additional": "#277BFF",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#FAFCFF",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "hover": "#FFFFFF1A",
          "lowContrast": "#99C0FF",
          "main": "#003B99",
          "status1Content": "#FC9549",
          "status2Content": "#9CD340",
          "status3Content": "#53DBED",
          "status4Content": "#B996F5",
          "status5Content": "#F179A4",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868"
        },
        "brand": {
          "accent": "#FAFCFF",
          "additional": "#68A2FF",
          "contrast": "#FAFCFF",
          "dark": "#0044B2",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "hover": "#FFFFFF33",
          "light": "#68A2FF",
          "lowContrast": "#99C0FF",
          "main": "#0062FF",
          "mainContent": "#0062FF",
          "press": "#FFFFFF1A",
          "successBackground": "#2FC063",
          "successContent": "#46D27A",
          "transparent": "#FFFFFF1A",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868"
        },
        "common": {
          "accent": "#68A2FF",
          "additional": "#666A73",
          "brandBackground": "#0062FF",
          "brandContent": "#0062FF",
          "brandContrast": "#FAFCFF",
          "contrast": "#FAFCFF",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "focus": "#FFFFFF1A",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowAccent": "#FFFFFF33",
          "lowContrast": "#8F909E",
          "press": "#FFFFFF0D",
          "status1Background": "#FC9549",
          "status1Content": "#F2A970",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#AD8EF2",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#E590AE",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "cyanElevation": {
          "accent": "#48C3DF",
          "additional": "#06A5C9",
          "border": "#06A5C9",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#72D0E7",
          "main": "#0D2D3A",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "dionCommon": {
          "accent": "#68A2FF",
          "additional": "#666A73",
          "brandBackground": "#0062FF",
          "brandContent": "#0062FF",
          "brandContrast": "#FAFCFF",
          "contrast": "#FAFCFF",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "focus": "#FFFFFF1A",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowAccent": "#FFFFFF33",
          "lowContrast": "#8F909E",
          "press": "#FFFFFF0D",
          "status1Background": "#FC9549",
          "status1Content": "#F2A970",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#AD8EF2",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#E590AE",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "elevation0": {
          "dark": "#111314",
          "light": "#202124",
          "main": "#111314"
        },
        "elevation1": {
          "dark": "#111314",
          "light": "#292A2E",
          "main": "#161819"
        },
        "elevation2": {
          "dark": "#161819",
          "light": "#3A3C41",
          "main": "#202124"
        },
        "elevation3": {
          "main": "#292A2E"
        },
        "elevationObject": {
          "main": "#161819"
        },
        "error": {
          "contrast": "#FAFCFF",
          "dark": "#F60909",
          "light": "#FA7979",
          "main": "#F94C4C",
          "mainContent": "#FA7979"
        },
        "fuchsiaElevation": {
          "accent": "#DE76F4",
          "additional": "#CA40E5",
          "border": "#CA40E5",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#E595F7",
          "main": "#460F4B",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "gradients": {
          "earth": {
            "color": {
              "1": "#0D3325",
              "2": "#389864",
              "3": "#D8FF68"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "jupiter": {
            "color": {
              "1": "#330033",
              "2": "#8D008D",
              "3": "#FFF435"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "mars": {
            "color": {
              "1": "#360E44",
              "2": "#BA3C71",
              "3": "#FFA37B"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "mercury": {
            "color": {
              "1": "#B81F56",
              "2": "#E07B32",
              "3": "#EDDC82"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "moon": {
            "color": {
              "1": "#161E21",
              "2": "#516573",
              "3": "#EAEAEA"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "neptune": {
            "color": {
              "1": "#000E57",
              "2": "#0087B4",
              "3": "#2CFFA7"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "pluto": {
            "color": {
              "1": "#0D2700",
              "2": "#B17C16",
              "3": "#FFE5A2"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "saturn": {
            "color": {
              "1": "#000F2B",
              "2": "#2B778E",
              "3": "#FFFCA8"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "uranus": {
            "color": {
              "1": "#000744",
              "2": "#4A54B2",
              "3": "#C3E2FE"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "venus": {
            "color": {
              "1": "#170035",
              "2": "#541CB0",
              "3": "#D3A8FF"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          }
        },
        "grayElevation": {
          "accent": "#7D87BE",
          "additional": "#49569C",
          "border": "#49569C",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#99A2CD",
          "main": "#212748",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "greenElevation": {
          "accent": "#55C78E",
          "additional": "#14AA5F",
          "border": "#14AA5F",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#7AD3A8",
          "main": "#052E1C",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "info": {
          "contrast": "#111314",
          "dark": "#3381FF",
          "light": "#99C0FF",
          "main": "#68A2FF",
          "mainContent": "#99C0FF"
        },
        "lines": {
          "border": "#3A3C41",
          "borderAccent": "#68A2FF",
          "divider": "#FFFFFF0D",
          "dividerBright": "#FFFFFF33"
        },
        "mossElevation": {
          "accent": "#8FB965",
          "additional": "#619728",
          "border": "#619728",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#A7C787",
          "main": "#15290A",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "onBrand": {
          "accent": "#3381FF",
          "additional": "#C4CBD6",
          "contrast": "#202124",
          "hover": "#0000000D",
          "lowContrast": "#8F909E",
          "main": "#EBEDF0",
          "press": "#0000001A",
          "transparent": "#0000001A"
        },
        "orangeElevation": {
          "accent": "#F2915D",
          "additional": "#E46320",
          "border": "#E46320",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#F4A981",
          "main": "#511C10",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "roseElevation": {
          "accent": "#F77291",
          "additional": "#E93862",
          "border": "#E93862",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#F890AA",
          "main": "#510B24",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "skyElevation": {
          "accent": "#68A2FF",
          "additional": "#0062FF",
          "border": "#0062FF",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F5F9FF",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#99C0FF",
          "main": "#001D4C",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "static": {
          "dark": "#202124",
          "darkLowContrast": "#00000033",
          "light": "#FAFCFF",
          "lightLowContrast": "#FFFFFF33"
        },
        "staticBlack60": {
          "main": "#00000099"
        },
        "staticBlack80": {
          "main": "#000000CC"
        },
        "status1": {
          "contrast": "#111314",
          "dark": "#FF7008",
          "light": "#F2A970",
          "main": "#FC9549",
          "mainContent": "#F2A970"
        },
        "status2": {
          "contrast": "#111314",
          "dark": "#65A400",
          "light": "#B1F84E",
          "main": "#9CD340",
          "mainContent": "#9CD340"
        },
        "status3": {
          "contrast": "#111314",
          "dark": "#00ACC2",
          "light": "#6AE2FB",
          "main": "#53DBED",
          "mainContent": "#53DBED"
        },
        "status4": {
          "contrast": "#111314",
          "dark": "#9A64F7",
          "light": "#AD8EF2",
          "main": "#B996F5",
          "mainContent": "#AD8EF2"
        },
        "status5": {
          "contrast": "#111314",
          "dark": "#D9477C",
          "light": "#E590AE",
          "main": "#F179A4",
          "mainContent": "#E590AE"
        },
        "success": {
          "contrast": "#111314",
          "dark": "#23904B",
          "light": "#84E1A6",
          "main": "#46D27A",
          "mainContent": "#46D27A"
        },
        "transparent5": {
          "main": "#FFFFFF0D"
        },
        "violetElevation": {
          "accent": "#A687F8",
          "additional": "#8055EC",
          "border": "#8055EC",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#B9A1FA",
          "main": "#2E125E",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        },
        "warning": {
          "contrast": "#111314",
          "dark": "#FDA502",
          "light": "#FEE59A",
          "main": "#FCC51C",
          "mainContent": "#FDD868"
        },
        "whiteboard": {
          "content1": "#FEF2CC",
          "content10": "#408AFF",
          "content11": "#99C0FF",
          "content12": "#6AE2FB",
          "content13": "#111314",
          "content14": "#FFFFFF",
          "content15": "#65A400",
          "content16": "#F94C4C",
          "content17": "#FDA502",
          "content18": "#3381FF",
          "content19": "#9A64F7",
          "content2": "#9CD340",
          "content20": "#FF7008",
          "content21": "#00ACC2",
          "content22": "#28A455",
          "content23": "#D9477C",
          "content24": "#8F909E",
          "content3": "#FDD868",
          "content4": "#84E1A6",
          "content5": "#FC9549",
          "content6": "#FB9D9D",
          "content7": "#FA7979",
          "content8": "#F179A4",
          "content9": "#B996F5"
        },
        "yellowElevation": {
          "accent": "#EFC04C",
          "additional": "#DFA008",
          "border": "#DFA008",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#F9FAFB",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#68A2FF",
          "infoContent": "#99C0FF",
          "infoContrast": "#111314",
          "lowContrast": "#F1CE75",
          "main": "#542C0D",
          "status1Background": "#FC9549",
          "status1Content": "#FC9549",
          "status1Contrast": "#111314",
          "status2Background": "#9CD340",
          "status2Content": "#9CD340",
          "status2Contrast": "#111314",
          "status3Background": "#53DBED",
          "status3Content": "#53DBED",
          "status3Contrast": "#111314",
          "status4Background": "#B996F5",
          "status4Content": "#B996F5",
          "status4Contrast": "#111314",
          "status5Background": "#F179A4",
          "status5Content": "#F179A4",
          "status5Contrast": "#111314",
          "successBackground": "#46D27A",
          "successContent": "#46D27A",
          "successContrast": "#111314",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868",
          "warningContrast": "#111314"
        }
      },
      "dialog": {
        "borderRadius": 16
      },
      "drawer": {
        "borderRadius": {
          "top": 16
        },
        "spacing": {
          "actionsBottomMargin": 56,
          "actionsTopMargin": 24,
          "margin": 24,
          "subtitleTopMargin": 24,
          "titleBottomMargin": 24
        }
      },
      "icon": {
        "size": {
          "l": 24,
          "m": 20,
          "s": 16,
          "xl": 32,
          "xs": 12,
          "xxl": 40,
          "xxs": 10,
          "xxxl": 48,
          "xxxs": 8,
          "xxxxl": 56,
          "xxxxs": 6,
          "xxxxxl": 96,
          "xxxxxs": 4
        }
      },
      "input": {
        "borderRadius": {
          "l": 8,
          "m": 8
        },
        "margin": {
          "l": {
            "bottom": 8,
            "top": 8
          },
          "m": {
            "bottom": 8,
            "top": 8
          }
        },
        "padding": {
          "l": {
            "content": 16,
            "icon": 12
          },
          "m": {
            "content": 12,
            "icon": 8
          }
        },
        "size": {
          "l": 48,
          "m": 40
        },
        "typography": {
          "l": {
            "additional": "caption1",
            "counter": "body2",
            "label": "body2",
            "mainText": "body1",
            "placeholder": "body1"
          },
          "m": {
            "additional": "caption1",
            "counter": "body2",
            "label": "body2",
            "mainText": "body1",
            "placeholder": "body1"
          }
        }
      },
      "placeholder": {
        "maxWidth": 480,
        "minWidth": 200,
        "spacing": {
          "buttonPaddingBottom": 40,
          "contentHorizontalPadding": 24,
          "iconPaddingBottom": 16,
          "paddingHMinPc": 15,
          "paddingHMinPx": 24,
          "subtitlePaddingBottom": 32,
          "titlePaddingBottom": 8
        },
        "subtitleMaxLength": 120,
        "subtitleMaxLines": 5,
        "titleMaxLength": 65,
        "titleMaxLines": 7
      },
      "popup": {
        "size": {
          "m": {
            "maxHeightVh": 90,
            "minHeight": 480,
            "minWidth": 480,
            "width": 720
          },
          "s": {
            "maxHeight": 479,
            "minHeight": 240,
            "minWidth": 200,
            "width": 480
          }
        },
        "spacing": {
          "actionsTopMargin": 32,
          "closeOffset": 8,
          "margin": 32,
          "subtitleTopMargin": 8,
          "titleBottomMargin": 24
        }
      },
      "radio": {
        "borderRadius": 50,
        "size": {
          "content": {
            "m": 8,
            "s": 6
          },
          "m": 24,
          "s": 20
        },
        "typography": {
          "m": "body2",
          "s": "body1"
        }
      },
      "radius": {
        "full": 9999,
        "l": 16,
        "m": 12,
        "none": 0,
        "s": 8,
        "xl": 24,
        "xs": 6,
        "xxl": 32,
        "xxs": 4,
        "xxxl": 48,
        "xxxxl": 56,
        "xxxxxl": 64,
        "xxxxxxl": 72
      },
      "scroll": {
        "size": {
          "m": 6
        },
        "spacing": {
          "sidePadding": 6
        }
      },
      "shadow": {
        "blur": {
          "m": 44
        },
        "color": {
          "m": "#0000001A"
        },
        "positionX": {
          "m": 0
        },
        "positionY": {
          "m": 4
        },
        "spread": {
          "m": 0
        }
      },
      "sidePanel": {
        "spacing": {
          "actionsMargin": 24,
          "margin": 24,
          "titleMargin": 16
        }
      },
      "spacing": {
        "general": {
          "l": 16,
          "m": 12,
          "none": 0,
          "s": 8,
          "xl": 24,
          "xs": 6,
          "xxl": 32,
          "xxs": 4,
          "xxxl": 40,
          "xxxs": 2,
          "xxxxl": 48,
          "xxxxxl": 56
        }
      },
      "switch": {
        "borderRadius": {
          "m": 12
        },
        "size": {
          "m": {
            "root": {
              "height": 21,
              "innerPadding": 2,
              "width": 38
            },
            "thumb": {
              "width": 17
            }
          }
        }
      },
      "table": {
        "size": {
          "m": {
            "body": {
              "height": 56,
              "paddingHorizontal": 16,
              "safePaddingVertical": 18
            },
            "head": {
              "height": 56,
              "paddingHorizontal": 16,
              "safePaddingVertical": 8
            }
          },
          "s": {
            "body": {
              "height": 36,
              "paddingHorizontal": 16,
              "safePaddingVertical": 8
            },
            "head": {
              "height": 36,
              "paddingHorizontal": 16,
              "safePaddingVertical": 6
            }
          }
        }
      }
    },
    "light": {
      "avatar": {
        "controls": {
          "close": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 3
            },
            "icon": "String value",
            "iconSize": {
              "l": "s",
              "m": "s",
              "s": "s",
              "xl": "s",
              "xs": "xs",
              "xxl": "l",
              "xxxl": "l"
            },
            "size": {
              "l": 16,
              "m": 16,
              "s": 16,
              "xl": 16,
              "xs": 12,
              "xxl": 24,
              "xxxl": 24
            }
          },
          "counter": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 4
            },
            "radius": {
              "l": 8,
              "m": 8,
              "s": 8,
              "xl": 8,
              "xs": 8,
              "xxl": 8,
              "xxxl": 32
            },
            "size": {
              "l": 16,
              "m": 16,
              "s": 12,
              "xl": 16,
              "xs": 12,
              "xxl": 20,
              "xxxl": 24
            },
            "typography": {
              "l": "body2",
              "m": "body2",
              "s": "caption1",
              "xl": "body2",
              "xs": "caption2",
              "xxl": "h6",
              "xxxl": "h5"
            }
          },
          "online": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 5
            },
            "icon": "Fill",
            "iconSize": {
              "l": "xs",
              "m": "xxs",
              "s": "xxs",
              "xl": "xs",
              "xs": "xxxs",
              "xxl": "m",
              "xxxl": "l"
            },
            "size": {
              "l": 8,
              "m": 6,
              "s": 6,
              "xl": 8,
              "xs": 4,
              "xxl": 16,
              "xxxl": 16
            }
          },
          "slot": {
            "border": {
              "l": 2,
              "m": 2,
              "s": 2,
              "xl": 2,
              "xs": 2,
              "xxl": 3,
              "xxxl": 4
            },
            "iconSize": {
              "l": "xs",
              "m": "xs",
              "s": "xs",
              "xl": "s",
              "xs": "xxs",
              "xxl": "l",
              "xxxl": "xl"
            },
            "size": {
              "l": 20,
              "m": 20,
              "s": 20,
              "xl": 24,
              "xs": 16,
              "xxl": 40,
              "xxxl": 48
            }
          }
        },
        "letterCount": {
          "l": 2,
          "m": 2,
          "s": 2,
          "xl": 2,
          "xs": 1,
          "xxl": 2,
          "xxxl": 2
        },
        "size": {
          "avatar": {
            "l": 48,
            "m": 40,
            "s": 32,
            "xl": 56,
            "xs": 24,
            "xxl": 96,
            "xxxl": 128
          },
          "icon": {
            "l": "l",
            "m": "m",
            "s": "s",
            "xl": "xl",
            "xs": "xs",
            "xxl": "xxxxl",
            "xxxl": "xxxxxl"
          }
        },
        "typography": {
          "l": "button1",
          "m": "button2",
          "s": "caption1",
          "xl": "h6",
          "xs": "caption1",
          "xxl": "h2",
          "xxxl": "h2"
        },
        "variant": {
          "rounded": {
            "borderRadius": 50
          },
          "square": {
            "borderRadius": 25
          }
        }
      },
      "avatarV2": {
        "borderRadius": {
          "rounded": {
            "size": {
              "l": 9999,
              "m": 9999,
              "s": 9999,
              "xl": 9999,
              "xs": 9999,
              "xxl": 9999,
              "xxxl": 9999,
              "xxxxl": 9999
            }
          },
          "square": {
            "size": {
              "l": 12,
              "m": 12,
              "s": 8,
              "xl": 16,
              "xs": 6,
              "xxl": 24,
              "xxxl": 32,
              "xxxxl": 72
            }
          }
        },
        "icon": {
          "l": "l",
          "m": "m",
          "s": "s",
          "xl": "xl",
          "xs": "xs",
          "xxl": "xxxl",
          "xxxl": "xxxxl",
          "xxxxl": "xxxxxl"
        },
        "letterCount": {
          "l": 2,
          "m": 2,
          "s": 2,
          "xl": 2,
          "xs": 1,
          "xxl": 2,
          "xxxl": 2,
          "xxxxl": 2
        },
        "size": {
          "l": 48,
          "m": 40,
          "s": 32,
          "xl": 56,
          "xs": 24,
          "xxl": 96,
          "xxxl": 128,
          "xxxxl": 210
        },
        "slot": {
          "border": {
            "l": 2,
            "m": 2,
            "s": 2,
            "xl": 2,
            "xs": 2,
            "xxl": 3,
            "xxxl": 4,
            "xxxxl": 4
          },
          "offset": {
            "l": 6,
            "m": 6,
            "s": 6,
            "xl": 8,
            "xs": 6,
            "xxl": 8,
            "xxxl": 8,
            "xxxxl": 0
          },
          "size": {
            "l": 24,
            "m": 24,
            "s": 20,
            "xl": 32,
            "xs": 18,
            "xxl": 40,
            "xxxl": 48,
            "xxxxl": 56
          },
          "variant": {
            "avatar": {
              "borderRadius": {
                "rounded": {
                  "size": {
                    "l": 9999,
                    "m": 9999,
                    "s": 9999,
                    "xl": 9999,
                    "xs": 9999,
                    "xxl": 9999,
                    "xxxl": 9999
                  }
                },
                "square": {
                  "size": {
                    "l": 8,
                    "m": 8,
                    "s": 8,
                    "xl": 10,
                    "xs": 8,
                    "xxl": 14,
                    "xxxl": 16,
                    "xxxxl": 16
                  }
                }
              },
              "size": {
                "l": "xs",
                "m": "xs",
                "s": "xs",
                "xl": "s",
                "xs": "xs",
                "xxl": "m",
                "xxxl": "l",
                "xxxxl": "xl"
              }
            },
            "badge": {
              "l": "s",
              "m": "s",
              "s": "s",
              "xl": "m",
              "xs": "s",
              "xxl": "m",
              "xxxl": "m",
              "xxxxl": "m"
            },
            "iconImage": {
              "background": {
                "l": 24,
                "m": 24,
                "s": 20,
                "xl": 32,
                "xs": 14,
                "xxl": 40,
                "xxxl": 48,
                "xxxxl": 56
              },
              "icon": {
                "l": "s",
                "m": "s",
                "s": "xs",
                "xl": "m",
                "xs": "xxs",
                "xxl": "l",
                "xxxl": "xl",
                "xxxxl": "xxl"
              }
            },
            "online": {
              "l": "xs",
              "m": "xs",
              "s": "xs",
              "xl": "xs",
              "xs": "xs",
              "xxl": "m",
              "xxxl": "m",
              "xxxxl": "m"
            }
          }
        },
        "typography": {
          "l": "button1",
          "m": "button2",
          "s": "caption1",
          "xl": "h6",
          "xs": "caption2",
          "xxl": "h2",
          "xxxl": "h2",
          "xxxxl": "h1"
        }
      },
      "badge": {
        "borderRadius": {
          "m": 32,
          "s": 32,
          "xs": 32
        },
        "horizontalPadding": {
          "m": 6,
          "s": 4
        },
        "icon": {
          "m": 12,
          "s": 8
        },
        "size": {
          "m": 18,
          "s": 14,
          "xs": 8
        },
        "typography": {
          "m": "caption-1",
          "s": "caption2"
        }
      },
      "border": {
        "l": 4,
        "m": 3,
        "s": 2,
        "xl": 5,
        "xs": 1
      },
      "button": {
        "borderRadius": {
          "l": 8,
          "m": 8,
          "s": 8,
          "xl": 12,
          "xs": 6,
          "xxs": 4,
          "xxxs": 4
        },
        "icon": {
          "nonText": {
            "l": "m",
            "m": "m",
            "s": "s",
            "xl": "l",
            "xs": "s",
            "xxs": "s",
            "xxxs": "xs"
          },
          "text": {
            "l": "s",
            "m": "s",
            "s": "xs",
            "xl": "s",
            "xs": "xxxs",
            "xxs": "xxxs",
            "xxxs": "xxxs"
          }
        },
        "size": {
          "l": 48,
          "m": 40,
          "s": 32,
          "xl": 56,
          "xs": 24,
          "xxs": 20,
          "xxxs": 16
        },
        "spacing": {
          "horizontal": {
            "inner": {
              "nonText": {
                "l": 8,
                "m": 8,
                "s": 8,
                "xl": 8,
                "xs": 8,
                "xxs": 4,
                "xxxs": 4
              },
              "text": {
                "l": 8,
                "m": 8,
                "s": 6,
                "xl": 8,
                "xs": 4,
                "xxs": 4,
                "xxxs": 4
              }
            },
            "outer": {
              "l": 16,
              "m": 16,
              "s": 12,
              "xl": 16,
              "xs": 8,
              "xxs": 4,
              "xxxs": 4
            }
          },
          "vertical": {
            "content": {
              "l": 15,
              "m": 11,
              "s": 7,
              "xl": 19,
              "xs": 3,
              "xxs": 1,
              "xxxs": 1
            },
            "icon": {
              "l": 14,
              "m": 10,
              "s": 8,
              "xl": 16,
              "xs": 4,
              "xxs": 2,
              "xxxs": 2
            }
          }
        },
        "typography": {
          "nonText": {
            "l": "button1",
            "m": "button1",
            "s": "button2",
            "xl": "button1",
            "xs": "button2",
            "xxs": "body2",
            "xxxs": "caption2"
          },
          "text": {
            "l": "button1",
            "m": "button1",
            "s": "button2",
            "xl": "button1",
            "xs": "button2",
            "xxs": "caption2",
            "xxxs": "caption2"
          }
        }
      },
      "buttonGroup": {
        "spacing": {
          "m": 16
        }
      },
      "chip": {
        "borderRadius": {
          "xxs": 4,
          "xxxs": 4
        },
        "icon": {
          "xxs": "s",
          "xxxs": "xs"
        },
        "size": {
          "xxs": 20,
          "xxxs": 16
        },
        "spacing": {
          "gap": {
            "xxs": 4,
            "xxxs": 4
          },
          "horizontal": {
            "default": {
              "xxs": 4,
              "xxxs": 4
            },
            "onlyIcon": {
              "xxs": 2,
              "xxxs": 2
            }
          }
        },
        "typography": {
          "xxs": "body2",
          "xxxs": "caption2"
        }
      },
      "color": {
        "blueElevation1": {
          "accent": "#CCDFFF",
          "additional": "#99C0FF",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#FAFCFF",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#FFFFFF1A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#E5EFFF",
          "main": "#0062FF",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "blueElevation2": {
          "accent": "#CCDFFF",
          "additional": "#99C0FF",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#FAFCFF",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "hover": "#FFFFFF1A",
          "lowContrast": "#E5EFFF",
          "main": "#277BFF",
          "status1Content": "#F4BB8C",
          "status2Content": "#BEFC58",
          "status3Content": "#75E7FC",
          "status4Content": "#C8B4F6",
          "status5Content": "#E590AE",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "transparent": "#FFFFFF0D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A"
        },
        "brand": {
          "accent": "#FAFCFF",
          "additional": "#68A2FF",
          "contrast": "#FAFCFF",
          "dark": "#0044B2",
          "disable": "#FFFFFF0D",
          "disableText": "#FFFFFF33",
          "errorBackground": "#F94C4C",
          "errorContent": "#FA7979",
          "hover": "#FFFFFF33",
          "light": "#68A2FF",
          "lowContrast": "#99C0FF",
          "main": "#0062FF",
          "mainContent": "#004ECC",
          "press": "#FFFFFF1A",
          "successBackground": "#2FC063",
          "successContent": "#46D27A",
          "transparent": "#FFFFFF1A",
          "warningBackground": "#FCC51C",
          "warningContent": "#FDD868"
        },
        "common": {
          "accent": "#3381FF",
          "additional": "#A9B0BC",
          "brandBackground": "#0062FF",
          "brandContent": "#004ECC",
          "brandContrast": "#FAFCFF",
          "contrast": "#202124",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#F94C4C",
          "errorContent": "#F94C4C",
          "errorContrast": "#FAFCFF",
          "focus": "#0000001A",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowAccent": "#00000033",
          "lowContrast": "#8F909E",
          "press": "#0000000D",
          "status1Background": "#FF7008",
          "status1Content": "#FF7008",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#65A400",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#00ACC2",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#9A64F7",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#D9477C",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#2FC063",
          "successContent": "#28A455",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FDA502",
          "warningContrast": "#111314"
        },
        "cyanElevation": {
          "accent": "#06A5C9",
          "additional": "#087691",
          "border": "#06A5C9",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#0D2D3A",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#0A5F75",
          "main": "#C3EAF5",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "dionCommon": {
          "accent": "#3381FF",
          "additional": "#A9B0BC",
          "brandBackground": "#0062FF",
          "brandContent": "#004ECC",
          "brandContrast": "#FAFCFF",
          "contrast": "#202124",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#F94C4C",
          "errorContent": "#F94C4C",
          "errorContrast": "#FAFCFF",
          "focus": "#0000001A",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowAccent": "#00000033",
          "lowContrast": "#8F909E",
          "press": "#0000000D",
          "status1Background": "#FF7008",
          "status1Content": "#FF7008",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#65A400",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#00ACC2",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#9A64F7",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#D9477C",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#2FC063",
          "successContent": "#28A455",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FDA502",
          "warningContrast": "#111314"
        },
        "elevation0": {
          "dark": "#EBEDF0",
          "light": "#FAFCFF",
          "main": "#FAFCFF"
        },
        "elevation1": {
          "dark": "#EBEDF0",
          "light": "#FAFCFF",
          "main": "#F5F7F9"
        },
        "elevation2": {
          "dark": "#D6DBE4",
          "light": "#F5F7F9",
          "main": "#EBEDF0"
        },
        "elevation3": {
          "main": "#D6DBE4"
        },
        "elevationObject": {
          "main": "#FAFCFF"
        },
        "error": {
          "contrast": "#FAFCFF",
          "dark": "#F60909",
          "light": "#FA7979",
          "main": "#F94C4C",
          "mainContent": "#F94C4C"
        },
        "fuchsiaElevation": {
          "accent": "#CA40E5",
          "additional": "#972DA9",
          "border": "#CA40E5",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#460F4B",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#7D248C",
          "main": "#F2D3FC",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "gradients": {
          "earth": {
            "color": {
              "1": "#0D3325",
              "2": "#389864",
              "3": "#D8FF68"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "jupiter": {
            "color": {
              "1": "#330033",
              "2": "#8D008D",
              "3": "#FFF435"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "mars": {
            "color": {
              "1": "#360E44",
              "2": "#BA3C71",
              "3": "#FFA37B"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "mercury": {
            "color": {
              "1": "#B81F56",
              "2": "#E07B32",
              "3": "#EDDC82"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "moon": {
            "color": {
              "1": "#161E21",
              "2": "#516573",
              "3": "#EAEAEA"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "neptune": {
            "color": {
              "1": "#000E57",
              "2": "#0087B4",
              "3": "#2CFFA7"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "pluto": {
            "color": {
              "1": "#0D2700",
              "2": "#B17C16",
              "3": "#FFE5A2"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "saturn": {
            "color": {
              "1": "#000F2B",
              "2": "#2B778E",
              "3": "#FFFCA8"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "uranus": {
            "color": {
              "1": "#000744",
              "2": "#4A54B2",
              "3": "#C3E2FE"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          },
          "venus": {
            "color": {
              "1": "#170035",
              "2": "#541CB0",
              "3": "#D3A8FF"
            },
            "left": 100,
            "position": {
              "1": 0,
              "2": 50,
              "3": 100
            },
            "size": 141.4199981689453,
            "top": 100,
            "type": "radial-gradient"
          }
        },
        "grayElevation": {
          "accent": "#49569C",
          "additional": "#323A6A",
          "border": "#49569C",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#0D0F1C",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#262C51",
          "main": "#D4D8EB",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "greenElevation": {
          "accent": "#14AA5F",
          "additional": "#0E7844",
          "border": "#14AA5F",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#052E1C",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#0B6037",
          "main": "#C9ECDE",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "info": {
          "contrast": "#FAFCFF",
          "dark": "#0062FF",
          "light": "#68A2FF",
          "main": "#3381FF",
          "mainContent": "#3381FF"
        },
        "lines": {
          "border": "#D6DBE4",
          "borderAccent": "#68A2FF",
          "divider": "#0000000D",
          "dividerBright": "#00000033"
        },
        "mossElevation": {
          "accent": "#619728",
          "additional": "#436C1C",
          "border": "#619728",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#15290A",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#345616",
          "main": "#D8E7CF",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "onBrand": {
          "accent": "#3381FF",
          "additional": "#666A73",
          "contrast": "#202124",
          "hover": "#0000000D",
          "lowContrast": "#8F909E",
          "main": "#EBEDF0",
          "press": "#0000001A",
          "transparent": "#FFFFFF1A"
        },
        "orangeElevation": {
          "accent": "#E46320",
          "additional": "#A94618",
          "border": "#E46320",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#511C10",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#8D3916",
          "main": "#F7DACC",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "roseElevation": {
          "accent": "#E93862",
          "additional": "#AE274A",
          "border": "#E93862",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#510B24",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#901D3D",
          "main": "#F9D2DE",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "skyElevation": {
          "accent": "#0062FF",
          "additional": "#0044B2",
          "border": "#0062FF",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#001D4C",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#003B99",
          "main": "#E5EFFF",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "static": {
          "dark": "#202124",
          "darkLowContrast": "#00000033",
          "light": "#FAFCFF",
          "lightLowContrast": "#FFFFFF33"
        },
        "staticBlack60": {
          "main": "#00000099"
        },
        "staticBlack80": {
          "main": "#000000CC"
        },
        "status1": {
          "contrast": "#FAFCFF",
          "dark": "#DC5D00",
          "light": "#FC9549",
          "main": "#FF7008",
          "mainContent": "#FF7008"
        },
        "status2": {
          "contrast": "#FAFCFF",
          "dark": "#658E29",
          "light": "#9CD340",
          "main": "#65A400",
          "mainContent": "#65A400"
        },
        "status3": {
          "contrast": "#FAFCFF",
          "dark": "#4295A7",
          "light": "#53DBED",
          "main": "#00ACC2",
          "mainContent": "#00ACC2"
        },
        "status4": {
          "contrast": "#FAFCFF",
          "dark": "#7646EC",
          "light": "#B996F5",
          "main": "#9A64F7",
          "mainContent": "#9A64F7"
        },
        "status5": {
          "contrast": "#FAFCFF",
          "dark": "#C03D67",
          "light": "#F179A4",
          "main": "#D9477C",
          "mainContent": "#D9477C"
        },
        "success": {
          "contrast": "#FAFCFF",
          "dark": "#23904B",
          "light": "#84E1A6",
          "main": "#2FC063",
          "mainContent": "#28A455"
        },
        "transparent5": {
          "main": "#0000000D"
        },
        "violetElevation": {
          "accent": "#8055EC",
          "additional": "#603BB5",
          "border": "#8055EC",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#2E125E",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#502E99",
          "main": "#E1D9FD",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        },
        "warning": {
          "contrast": "#111314",
          "dark": "#F79008",
          "light": "#FDD868",
          "main": "#FDD868",
          "mainContent": "#FDA502"
        },
        "whiteboard": {
          "content1": "#FEF2CC",
          "content10": "#408AFF",
          "content11": "#99C0FF",
          "content12": "#6AE2FB",
          "content13": "#111314",
          "content14": "#FFFFFF",
          "content15": "#65A400",
          "content16": "#F94C4C",
          "content17": "#FDA502",
          "content18": "#3381FF",
          "content19": "#9A64F7",
          "content2": "#9CD340",
          "content20": "#FF7008",
          "content21": "#00ACC2",
          "content22": "#28A455",
          "content23": "#D9477C",
          "content24": "#8F909E",
          "content3": "#FDD868",
          "content4": "#84E1A6",
          "content5": "#FC9549",
          "content6": "#FB9D9D",
          "content7": "#FA7979",
          "content8": "#F179A4",
          "content9": "#B996F5"
        },
        "yellowElevation": {
          "accent": "#DFA008",
          "additional": "#A8730A",
          "border": "#DFA008",
          "brandBackground": "#FAFCFF",
          "brandContent": "#FAFCFF",
          "brandContrast": "#0062FF",
          "contrast": "#542C0D",
          "disable": "#0000000D",
          "disableText": "#00000033",
          "errorBackground": "#FA7979",
          "errorContent": "#FB9D9D",
          "errorContrast": "#FAFCFF",
          "hover": "#0000001A",
          "infoBackground": "#3381FF",
          "infoContent": "#3381FF",
          "infoContrast": "#FAFCFF",
          "lowContrast": "#8D5C0C",
          "main": "#F6EAC9",
          "status1Background": "#FF7008",
          "status1Content": "#F4BB8C",
          "status1Contrast": "#FAFCFF",
          "status2Background": "#65A400",
          "status2Content": "#BEFC58",
          "status2Contrast": "#FAFCFF",
          "status3Background": "#00ACC2",
          "status3Content": "#75E7FC",
          "status3Contrast": "#FAFCFF",
          "status4Background": "#9A64F7",
          "status4Content": "#C8B4F6",
          "status4Contrast": "#FAFCFF",
          "status5Background": "#D9477C",
          "status5Content": "#E590AE",
          "status5Contrast": "#FAFCFF",
          "successBackground": "#84E1A6",
          "successContent": "#ADEBC4",
          "successContrast": "#FAFCFF",
          "transparent": "#0000000D",
          "warningBackground": "#FDD868",
          "warningContent": "#FEE59A",
          "warningContrast": "#111314"
        }
      },
      "dialog": {
        "borderRadius": 16
      },
      "drawer": {
        "borderRadius": {
          "top": 16
        },
        "spacing": {
          "actionsBottomMargin": 56,
          "actionsTopMargin": 24,
          "margin": 24,
          "subtitleTopMargin": 24,
          "titleBottomMargin": 24
        }
      },
      "icon": {
        "size": {
          "l": 24,
          "m": 20,
          "s": 16,
          "xl": 32,
          "xs": 12,
          "xxl": 40,
          "xxs": 10,
          "xxxl": 48,
          "xxxs": 8,
          "xxxxl": 56,
          "xxxxs": 6,
          "xxxxxl": 96,
          "xxxxxs": 4
        }
      },
      "input": {
        "borderRadius": {
          "l": 8,
          "m": 8
        },
        "margin": {
          "l": {
            "bottom": 8,
            "top": 8
          },
          "m": {
            "bottom": 8,
            "top": 8
          }
        },
        "padding": {
          "l": {
            "content": 16,
            "icon": 12
          },
          "m": {
            "content": 12,
            "icon": 8
          }
        },
        "size": {
          "l": 48,
          "m": 40
        },
        "typography": {
          "l": {
            "additional": "caption1",
            "counter": "body2",
            "label": "body2",
            "mainText": "body1",
            "placeholder": "body1"
          },
          "m": {
            "additional": "caption1",
            "counter": "body2",
            "label": "body2",
            "mainText": "body1",
            "placeholder": "body1"
          }
        }
      },
      "placeholder": {
        "maxWidth": 480,
        "minWidth": 200,
        "spacing": {
          "buttonPaddingBottom": 40,
          "contentHorizontalPadding": 24,
          "iconPaddingBottom": 16,
          "paddingHMinPc": 15,
          "paddingHMinPx": 24,
          "subtitlePaddingBottom": 32,
          "titlePaddingBottom": 8
        },
        "subtitleMaxLength": 120,
        "subtitleMaxLines": 5,
        "titleMaxLength": 65,
        "titleMaxLines": 7
      },
      "popup": {
        "size": {
          "m": {
            "maxHeightVh": 90,
            "minHeight": 480,
            "minWidth": 480,
            "width": 720
          },
          "s": {
            "maxHeight": 479,
            "minHeight": 320,
            "minWidth": 200,
            "width": 480
          }
        },
        "spacing": {
          "actionsTopMargin": 32,
          "closeOffset": 8,
          "margin": 32,
          "subtitleTopMargin": 8,
          "titleBottomMargin": 24
        }
      },
      "radio": {
        "borderRadius": 50,
        "size": {
          "content": {
            "m": 8,
            "s": 6
          },
          "m": 24,
          "s": 20
        },
        "typography": {
          "m": "body2",
          "s": "body1"
        }
      },
      "radius": {
        "full": 9999,
        "l": 16,
        "m": 12,
        "none": 0,
        "s": 8,
        "xl": 24,
        "xs": 6,
        "xxl": 32,
        "xxs": 4,
        "xxxl": 48,
        "xxxxl": 56,
        "xxxxxl": 64,
        "xxxxxxl": 72
      },
      "scroll": {
        "size": {
          "m": 6
        },
        "spacing": {
          "sidePadding": 6
        }
      },
      "shadow": {
        "blur": {
          "m": 44
        },
        "color": {
          "m": "#0000001A"
        },
        "positionX": {
          "m": 0
        },
        "positionY": {
          "m": 4
        },
        "spread": {
          "m": 0
        }
      },
      "sidePanel": {
        "spacing": {
          "actionsMargin": 24,
          "margin": 24,
          "titleMargin": 16
        }
      },
      "spacing": {
        "general": {
          "l": 16,
          "m": 12,
          "none": 0,
          "s": 8,
          "xl": 24,
          "xs": 6,
          "xxl": 32,
          "xxs": 4,
          "xxxl": 40,
          "xxxs": 2,
          "xxxxl": 48,
          "xxxxxl": 56
        }
      },
      "switch": {
        "borderRadius": {
          "m": 12
        },
        "size": {
          "m": {
            "root": {
              "height": 21,
              "innerPadding": 2,
              "width": 38
            },
            "thumb": {
              "width": 17
            }
          }
        }
      },
      "table": {
        "size": {
          "m": {
            "body": {
              "height": 56,
              "paddingHorizontal": 16,
              "safePaddingVertical": 18
            },
            "head": {
              "height": 56,
              "paddingHorizontal": 16,
              "safePaddingVertical": 8
            }
          },
          "s": {
            "body": {
              "height": 36,
              "paddingHorizontal": 16,
              "safePaddingVertical": 8
            },
            "head": {
              "height": 36,
              "paddingHorizontal": 16,
              "safePaddingVertical": 6
            }
          }
        }
      }
    }
  },
  "typography": {
    "body1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "22px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "body1Short": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "18px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "body2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "18px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "body2Short": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "14px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "button1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "18px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "button2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "18px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "caption1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "12px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "14px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "caption1Caps": {
      "fontFamily": "VTB Group UI",
      "fontSize": "12px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "14px",
      "textDecoration": "NONE",
      "textTransform": "uppercase"
    },
    "caption2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "10px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "12px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "caption3": {
      "fontFamily": "VTB Group UI",
      "fontSize": "8px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "10px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "h1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "60px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "70px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "h2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "32px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "36px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "h3": {
      "fontFamily": "VTB Group UI",
      "fontSize": "28px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "34px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "h4": {
      "fontFamily": "VTB Group UI",
      "fontSize": "24px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "30px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "h5": {
      "fontFamily": "VTB Group UI",
      "fontSize": "20px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "24px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "h6": {
      "fontFamily": "VTB Group UI",
      "fontSize": "18px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "22px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "subtitle1": {
      "fontFamily": "VTB Group UI",
      "fontSize": "18px",
      "fontWeight": 400,
      "letterSpacing": "0%",
      "lineHeight": "22px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "subtitle2": {
      "fontFamily": "VTB Group UI",
      "fontSize": "16px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "22px",
      "textDecoration": "NONE",
      "textTransform": "none"
    },
    "subtitle3": {
      "fontFamily": "VTB Group UI",
      "fontSize": "14px",
      "fontWeight": 500,
      "letterSpacing": "0%",
      "lineHeight": "18px",
      "textDecoration": "NONE",
      "textTransform": "none"
    }
  }
};
var EThemeGradients = /* @__PURE__ */ ((EThemeGradients2) => {
  EThemeGradients2["NONE"] = "none";
  EThemeGradients2["MARS"] = "mars";
  EThemeGradients2["VENUS"] = "venus";
  EThemeGradients2["NEPTUNE"] = "neptune";
  EThemeGradients2["MERCURY"] = "mercury";
  EThemeGradients2["EARTH"] = "earth";
  EThemeGradients2["URANUS"] = "uranus";
  EThemeGradients2["JUPITER"] = "jupiter";
  EThemeGradients2["MOON"] = "moon";
  EThemeGradients2["SATURN"] = "saturn";
  EThemeGradients2["PLUTO"] = "pluto";
  return EThemeGradients2;
})(EThemeGradients || {});
var EDionColorGroups = /* @__PURE__ */ ((EDionColorGroups2) => {
  EDionColorGroups2["elevation0"] = "elevation0";
  EDionColorGroups2["elevation1"] = "elevation1";
  EDionColorGroups2["elevation2"] = "elevation2";
  EDionColorGroups2["elevation3"] = "elevation3";
  EDionColorGroups2["elevationObject"] = "elevationObject";
  EDionColorGroups2["staticBlack80"] = "staticBlack80";
  EDionColorGroups2["staticBlack60"] = "staticBlack60";
  EDionColorGroups2["brand"] = "brand";
  EDionColorGroups2["success"] = "success";
  EDionColorGroups2["warning"] = "warning";
  EDionColorGroups2["onBrand"] = "onBrand";
  EDionColorGroups2["error"] = "error";
  EDionColorGroups2["info"] = "info";
  EDionColorGroups2["status1"] = "status1";
  EDionColorGroups2["status2"] = "status2";
  EDionColorGroups2["status3"] = "status3";
  EDionColorGroups2["status4"] = "status4";
  EDionColorGroups2["status5"] = "status5";
  EDionColorGroups2["transparent5"] = "transparent5";
  EDionColorGroups2["blueElevation1"] = "blueElevation1";
  EDionColorGroups2["blueElevation2"] = "blueElevation2";
  EDionColorGroups2["yellowElevation"] = "yellowElevation";
  EDionColorGroups2["orangeElevation"] = "orangeElevation";
  EDionColorGroups2["roseElevation"] = "roseElevation";
  EDionColorGroups2["grayElevation"] = "grayElevation";
  EDionColorGroups2["fuchsiaElevation"] = "fuchsiaElevation";
  EDionColorGroups2["violetElevation"] = "violetElevation";
  EDionColorGroups2["skyElevation"] = "skyElevation";
  EDionColorGroups2["cyanElevation"] = "cyanElevation";
  EDionColorGroups2["greenElevation"] = "greenElevation";
  EDionColorGroups2["mossElevation"] = "mossElevation";
  EDionColorGroups2["whiteboard"] = "whiteboard";
  return EDionColorGroups2;
})(EDionColorGroups || {});
var EDionColorNames = /* @__PURE__ */ ((EDionColorNames2) => {
  EDionColorNames2["status5Contrast"] = "status5Contrast";
  EDionColorNames2["status5Background"] = "status5Background";
  EDionColorNames2["status5Content"] = "status5Content";
  EDionColorNames2["status4Contrast"] = "status4Contrast";
  EDionColorNames2["status4Background"] = "status4Background";
  EDionColorNames2["status4Content"] = "status4Content";
  EDionColorNames2["status3Contrast"] = "status3Contrast";
  EDionColorNames2["status3Background"] = "status3Background";
  EDionColorNames2["status3Content"] = "status3Content";
  EDionColorNames2["status2Contrast"] = "status2Contrast";
  EDionColorNames2["status2Background"] = "status2Background";
  EDionColorNames2["status2Content"] = "status2Content";
  EDionColorNames2["status1Contrast"] = "status1Contrast";
  EDionColorNames2["status1Background"] = "status1Background";
  EDionColorNames2["status1Content"] = "status1Content";
  EDionColorNames2["infoContrast"] = "infoContrast";
  EDionColorNames2["infoBackground"] = "infoBackground";
  EDionColorNames2["infoContent"] = "infoContent";
  EDionColorNames2["warningContrast"] = "warningContrast";
  EDionColorNames2["warningBackground"] = "warningBackground";
  EDionColorNames2["warningContent"] = "warningContent";
  EDionColorNames2["successContrast"] = "successContrast";
  EDionColorNames2["successBackground"] = "successBackground";
  EDionColorNames2["successContent"] = "successContent";
  EDionColorNames2["errorContrast"] = "errorContrast";
  EDionColorNames2["errorBackground"] = "errorBackground";
  EDionColorNames2["errorContent"] = "errorContent";
  EDionColorNames2["brandContrast"] = "brandContrast";
  EDionColorNames2["brandBackground"] = "brandBackground";
  EDionColorNames2["brandContent"] = "brandContent";
  EDionColorNames2["disableText"] = "disableText";
  EDionColorNames2["disable"] = "disable";
  EDionColorNames2["transparent"] = "transparent";
  EDionColorNames2["focus"] = "focus";
  EDionColorNames2["press"] = "press";
  EDionColorNames2["hover"] = "hover";
  EDionColorNames2["lowAccent"] = "lowAccent";
  EDionColorNames2["accent"] = "accent";
  EDionColorNames2["additional"] = "additional";
  EDionColorNames2["lowContrast"] = "lowContrast";
  EDionColorNames2["contrast"] = "contrast";
  EDionColorNames2["main"] = "main";
  return EDionColorNames2;
})(EDionColorNames || {});
var EDionColors = /* @__PURE__ */ ((EDionColors2) => {
  EDionColors2["ELEVATION_0_STATUS_5_CONTRAST"] = "elevation0.status5Contrast";
  EDionColors2["ELEVATION_0_STATUS_5_BACKGROUND"] = "elevation0.status5Background";
  EDionColors2["ELEVATION_0_STATUS_5_CONTENT"] = "elevation0.status5Content";
  EDionColors2["ELEVATION_0_STATUS_4_CONTRAST"] = "elevation0.status4Contrast";
  EDionColors2["ELEVATION_0_STATUS_4_BACKGROUND"] = "elevation0.status4Background";
  EDionColors2["ELEVATION_0_STATUS_4_CONTENT"] = "elevation0.status4Content";
  EDionColors2["ELEVATION_0_STATUS_3_CONTRAST"] = "elevation0.status3Contrast";
  EDionColors2["ELEVATION_0_STATUS_3_BACKGROUND"] = "elevation0.status3Background";
  EDionColors2["ELEVATION_0_STATUS_3_CONTENT"] = "elevation0.status3Content";
  EDionColors2["ELEVATION_0_STATUS_2_CONTRAST"] = "elevation0.status2Contrast";
  EDionColors2["ELEVATION_0_STATUS_2_BACKGROUND"] = "elevation0.status2Background";
  EDionColors2["ELEVATION_0_STATUS_2_CONTENT"] = "elevation0.status2Content";
  EDionColors2["ELEVATION_0_STATUS_1_CONTRAST"] = "elevation0.status1Contrast";
  EDionColors2["ELEVATION_0_STATUS_1_BACKGROUND"] = "elevation0.status1Background";
  EDionColors2["ELEVATION_0_STATUS_1_CONTENT"] = "elevation0.status1Content";
  EDionColors2["ELEVATION_0_INFO_CONTRAST"] = "elevation0.infoContrast";
  EDionColors2["ELEVATION_0_INFO_BACKGROUND"] = "elevation0.infoBackground";
  EDionColors2["ELEVATION_0_INFO_CONTENT"] = "elevation0.infoContent";
  EDionColors2["ELEVATION_0_WARNING_CONTRAST"] = "elevation0.warningContrast";
  EDionColors2["ELEVATION_0_WARNING_BACKGROUND"] = "elevation0.warningBackground";
  EDionColors2["ELEVATION_0_WARNING_CONTENT"] = "elevation0.warningContent";
  EDionColors2["ELEVATION_0_SUCCESS_CONTRAST"] = "elevation0.successContrast";
  EDionColors2["ELEVATION_0_SUCCESS_BACKGROUND"] = "elevation0.successBackground";
  EDionColors2["ELEVATION_0_SUCCESS_CONTENT"] = "elevation0.successContent";
  EDionColors2["ELEVATION_0_ERROR_CONTRAST"] = "elevation0.errorContrast";
  EDionColors2["ELEVATION_0_ERROR_BACKGROUND"] = "elevation0.errorBackground";
  EDionColors2["ELEVATION_0_ERROR_CONTENT"] = "elevation0.errorContent";
  EDionColors2["ELEVATION_0_BRAND_CONTRAST"] = "elevation0.brandContrast";
  EDionColors2["ELEVATION_0_BRAND_BACKGROUND"] = "elevation0.brandBackground";
  EDionColors2["ELEVATION_0_BRAND_CONTENT"] = "elevation0.brandContent";
  EDionColors2["ELEVATION_0_DISABLE_TEXT"] = "elevation0.disableText";
  EDionColors2["ELEVATION_0_DISABLE"] = "elevation0.disable";
  EDionColors2["ELEVATION_0_TRANSPARENT"] = "elevation0.transparent";
  EDionColors2["ELEVATION_0_FOCUS"] = "elevation0.focus";
  EDionColors2["ELEVATION_0_PRESS"] = "elevation0.press";
  EDionColors2["ELEVATION_0_HOVER"] = "elevation0.hover";
  EDionColors2["ELEVATION_0_LOW_ACCENT"] = "elevation0.lowAccent";
  EDionColors2["ELEVATION_0_ACCENT"] = "elevation0.accent";
  EDionColors2["ELEVATION_0_ADDITIONAL"] = "elevation0.additional";
  EDionColors2["ELEVATION_0_LOW_CONTRAST"] = "elevation0.lowContrast";
  EDionColors2["ELEVATION_0_CONTRAST"] = "elevation0.contrast";
  EDionColors2["ELEVATION_0_MAIN"] = "elevation0.main";
  EDionColors2["ELEVATION_1_STATUS_5_CONTRAST"] = "elevation1.status5Contrast";
  EDionColors2["ELEVATION_1_STATUS_5_BACKGROUND"] = "elevation1.status5Background";
  EDionColors2["ELEVATION_1_STATUS_5_CONTENT"] = "elevation1.status5Content";
  EDionColors2["ELEVATION_1_STATUS_4_CONTRAST"] = "elevation1.status4Contrast";
  EDionColors2["ELEVATION_1_STATUS_4_BACKGROUND"] = "elevation1.status4Background";
  EDionColors2["ELEVATION_1_STATUS_4_CONTENT"] = "elevation1.status4Content";
  EDionColors2["ELEVATION_1_STATUS_3_CONTRAST"] = "elevation1.status3Contrast";
  EDionColors2["ELEVATION_1_STATUS_3_BACKGROUND"] = "elevation1.status3Background";
  EDionColors2["ELEVATION_1_STATUS_3_CONTENT"] = "elevation1.status3Content";
  EDionColors2["ELEVATION_1_STATUS_2_CONTRAST"] = "elevation1.status2Contrast";
  EDionColors2["ELEVATION_1_STATUS_2_BACKGROUND"] = "elevation1.status2Background";
  EDionColors2["ELEVATION_1_STATUS_2_CONTENT"] = "elevation1.status2Content";
  EDionColors2["ELEVATION_1_STATUS_1_CONTRAST"] = "elevation1.status1Contrast";
  EDionColors2["ELEVATION_1_STATUS_1_BACKGROUND"] = "elevation1.status1Background";
  EDionColors2["ELEVATION_1_STATUS_1_CONTENT"] = "elevation1.status1Content";
  EDionColors2["ELEVATION_1_INFO_CONTRAST"] = "elevation1.infoContrast";
  EDionColors2["ELEVATION_1_INFO_BACKGROUND"] = "elevation1.infoBackground";
  EDionColors2["ELEVATION_1_INFO_CONTENT"] = "elevation1.infoContent";
  EDionColors2["ELEVATION_1_WARNING_CONTRAST"] = "elevation1.warningContrast";
  EDionColors2["ELEVATION_1_WARNING_BACKGROUND"] = "elevation1.warningBackground";
  EDionColors2["ELEVATION_1_WARNING_CONTENT"] = "elevation1.warningContent";
  EDionColors2["ELEVATION_1_SUCCESS_CONTRAST"] = "elevation1.successContrast";
  EDionColors2["ELEVATION_1_SUCCESS_BACKGROUND"] = "elevation1.successBackground";
  EDionColors2["ELEVATION_1_SUCCESS_CONTENT"] = "elevation1.successContent";
  EDionColors2["ELEVATION_1_ERROR_CONTRAST"] = "elevation1.errorContrast";
  EDionColors2["ELEVATION_1_ERROR_BACKGROUND"] = "elevation1.errorBackground";
  EDionColors2["ELEVATION_1_ERROR_CONTENT"] = "elevation1.errorContent";
  EDionColors2["ELEVATION_1_BRAND_CONTRAST"] = "elevation1.brandContrast";
  EDionColors2["ELEVATION_1_BRAND_BACKGROUND"] = "elevation1.brandBackground";
  EDionColors2["ELEVATION_1_BRAND_CONTENT"] = "elevation1.brandContent";
  EDionColors2["ELEVATION_1_DISABLE_TEXT"] = "elevation1.disableText";
  EDionColors2["ELEVATION_1_DISABLE"] = "elevation1.disable";
  EDionColors2["ELEVATION_1_TRANSPARENT"] = "elevation1.transparent";
  EDionColors2["ELEVATION_1_FOCUS"] = "elevation1.focus";
  EDionColors2["ELEVATION_1_PRESS"] = "elevation1.press";
  EDionColors2["ELEVATION_1_HOVER"] = "elevation1.hover";
  EDionColors2["ELEVATION_1_LOW_ACCENT"] = "elevation1.lowAccent";
  EDionColors2["ELEVATION_1_ACCENT"] = "elevation1.accent";
  EDionColors2["ELEVATION_1_ADDITIONAL"] = "elevation1.additional";
  EDionColors2["ELEVATION_1_LOW_CONTRAST"] = "elevation1.lowContrast";
  EDionColors2["ELEVATION_1_CONTRAST"] = "elevation1.contrast";
  EDionColors2["ELEVATION_1_MAIN"] = "elevation1.main";
  EDionColors2["ELEVATION_2_STATUS_5_CONTRAST"] = "elevation2.status5Contrast";
  EDionColors2["ELEVATION_2_STATUS_5_BACKGROUND"] = "elevation2.status5Background";
  EDionColors2["ELEVATION_2_STATUS_5_CONTENT"] = "elevation2.status5Content";
  EDionColors2["ELEVATION_2_STATUS_4_CONTRAST"] = "elevation2.status4Contrast";
  EDionColors2["ELEVATION_2_STATUS_4_BACKGROUND"] = "elevation2.status4Background";
  EDionColors2["ELEVATION_2_STATUS_4_CONTENT"] = "elevation2.status4Content";
  EDionColors2["ELEVATION_2_STATUS_3_CONTRAST"] = "elevation2.status3Contrast";
  EDionColors2["ELEVATION_2_STATUS_3_BACKGROUND"] = "elevation2.status3Background";
  EDionColors2["ELEVATION_2_STATUS_3_CONTENT"] = "elevation2.status3Content";
  EDionColors2["ELEVATION_2_STATUS_2_CONTRAST"] = "elevation2.status2Contrast";
  EDionColors2["ELEVATION_2_STATUS_2_BACKGROUND"] = "elevation2.status2Background";
  EDionColors2["ELEVATION_2_STATUS_2_CONTENT"] = "elevation2.status2Content";
  EDionColors2["ELEVATION_2_STATUS_1_CONTRAST"] = "elevation2.status1Contrast";
  EDionColors2["ELEVATION_2_STATUS_1_BACKGROUND"] = "elevation2.status1Background";
  EDionColors2["ELEVATION_2_STATUS_1_CONTENT"] = "elevation2.status1Content";
  EDionColors2["ELEVATION_2_INFO_CONTRAST"] = "elevation2.infoContrast";
  EDionColors2["ELEVATION_2_INFO_BACKGROUND"] = "elevation2.infoBackground";
  EDionColors2["ELEVATION_2_INFO_CONTENT"] = "elevation2.infoContent";
  EDionColors2["ELEVATION_2_WARNING_CONTRAST"] = "elevation2.warningContrast";
  EDionColors2["ELEVATION_2_WARNING_BACKGROUND"] = "elevation2.warningBackground";
  EDionColors2["ELEVATION_2_WARNING_CONTENT"] = "elevation2.warningContent";
  EDionColors2["ELEVATION_2_SUCCESS_CONTRAST"] = "elevation2.successContrast";
  EDionColors2["ELEVATION_2_SUCCESS_BACKGROUND"] = "elevation2.successBackground";
  EDionColors2["ELEVATION_2_SUCCESS_CONTENT"] = "elevation2.successContent";
  EDionColors2["ELEVATION_2_ERROR_CONTRAST"] = "elevation2.errorContrast";
  EDionColors2["ELEVATION_2_ERROR_BACKGROUND"] = "elevation2.errorBackground";
  EDionColors2["ELEVATION_2_ERROR_CONTENT"] = "elevation2.errorContent";
  EDionColors2["ELEVATION_2_BRAND_CONTRAST"] = "elevation2.brandContrast";
  EDionColors2["ELEVATION_2_BRAND_BACKGROUND"] = "elevation2.brandBackground";
  EDionColors2["ELEVATION_2_BRAND_CONTENT"] = "elevation2.brandContent";
  EDionColors2["ELEVATION_2_DISABLE_TEXT"] = "elevation2.disableText";
  EDionColors2["ELEVATION_2_DISABLE"] = "elevation2.disable";
  EDionColors2["ELEVATION_2_TRANSPARENT"] = "elevation2.transparent";
  EDionColors2["ELEVATION_2_FOCUS"] = "elevation2.focus";
  EDionColors2["ELEVATION_2_PRESS"] = "elevation2.press";
  EDionColors2["ELEVATION_2_HOVER"] = "elevation2.hover";
  EDionColors2["ELEVATION_2_LOW_ACCENT"] = "elevation2.lowAccent";
  EDionColors2["ELEVATION_2_ACCENT"] = "elevation2.accent";
  EDionColors2["ELEVATION_2_ADDITIONAL"] = "elevation2.additional";
  EDionColors2["ELEVATION_2_LOW_CONTRAST"] = "elevation2.lowContrast";
  EDionColors2["ELEVATION_2_CONTRAST"] = "elevation2.contrast";
  EDionColors2["ELEVATION_2_MAIN"] = "elevation2.main";
  EDionColors2["ELEVATION_3_STATUS_5_CONTRAST"] = "elevation3.status5Contrast";
  EDionColors2["ELEVATION_3_STATUS_5_BACKGROUND"] = "elevation3.status5Background";
  EDionColors2["ELEVATION_3_STATUS_5_CONTENT"] = "elevation3.status5Content";
  EDionColors2["ELEVATION_3_STATUS_4_CONTRAST"] = "elevation3.status4Contrast";
  EDionColors2["ELEVATION_3_STATUS_4_BACKGROUND"] = "elevation3.status4Background";
  EDionColors2["ELEVATION_3_STATUS_4_CONTENT"] = "elevation3.status4Content";
  EDionColors2["ELEVATION_3_STATUS_3_CONTRAST"] = "elevation3.status3Contrast";
  EDionColors2["ELEVATION_3_STATUS_3_BACKGROUND"] = "elevation3.status3Background";
  EDionColors2["ELEVATION_3_STATUS_3_CONTENT"] = "elevation3.status3Content";
  EDionColors2["ELEVATION_3_STATUS_2_CONTRAST"] = "elevation3.status2Contrast";
  EDionColors2["ELEVATION_3_STATUS_2_BACKGROUND"] = "elevation3.status2Background";
  EDionColors2["ELEVATION_3_STATUS_2_CONTENT"] = "elevation3.status2Content";
  EDionColors2["ELEVATION_3_STATUS_1_CONTRAST"] = "elevation3.status1Contrast";
  EDionColors2["ELEVATION_3_STATUS_1_BACKGROUND"] = "elevation3.status1Background";
  EDionColors2["ELEVATION_3_STATUS_1_CONTENT"] = "elevation3.status1Content";
  EDionColors2["ELEVATION_3_INFO_CONTRAST"] = "elevation3.infoContrast";
  EDionColors2["ELEVATION_3_INFO_BACKGROUND"] = "elevation3.infoBackground";
  EDionColors2["ELEVATION_3_INFO_CONTENT"] = "elevation3.infoContent";
  EDionColors2["ELEVATION_3_WARNING_CONTRAST"] = "elevation3.warningContrast";
  EDionColors2["ELEVATION_3_WARNING_BACKGROUND"] = "elevation3.warningBackground";
  EDionColors2["ELEVATION_3_WARNING_CONTENT"] = "elevation3.warningContent";
  EDionColors2["ELEVATION_3_SUCCESS_CONTRAST"] = "elevation3.successContrast";
  EDionColors2["ELEVATION_3_SUCCESS_BACKGROUND"] = "elevation3.successBackground";
  EDionColors2["ELEVATION_3_SUCCESS_CONTENT"] = "elevation3.successContent";
  EDionColors2["ELEVATION_3_ERROR_CONTRAST"] = "elevation3.errorContrast";
  EDionColors2["ELEVATION_3_ERROR_BACKGROUND"] = "elevation3.errorBackground";
  EDionColors2["ELEVATION_3_ERROR_CONTENT"] = "elevation3.errorContent";
  EDionColors2["ELEVATION_3_BRAND_CONTRAST"] = "elevation3.brandContrast";
  EDionColors2["ELEVATION_3_BRAND_BACKGROUND"] = "elevation3.brandBackground";
  EDionColors2["ELEVATION_3_BRAND_CONTENT"] = "elevation3.brandContent";
  EDionColors2["ELEVATION_3_DISABLE_TEXT"] = "elevation3.disableText";
  EDionColors2["ELEVATION_3_DISABLE"] = "elevation3.disable";
  EDionColors2["ELEVATION_3_TRANSPARENT"] = "elevation3.transparent";
  EDionColors2["ELEVATION_3_FOCUS"] = "elevation3.focus";
  EDionColors2["ELEVATION_3_PRESS"] = "elevation3.press";
  EDionColors2["ELEVATION_3_HOVER"] = "elevation3.hover";
  EDionColors2["ELEVATION_3_LOW_ACCENT"] = "elevation3.lowAccent";
  EDionColors2["ELEVATION_3_ACCENT"] = "elevation3.accent";
  EDionColors2["ELEVATION_3_ADDITIONAL"] = "elevation3.additional";
  EDionColors2["ELEVATION_3_LOW_CONTRAST"] = "elevation3.lowContrast";
  EDionColors2["ELEVATION_3_CONTRAST"] = "elevation3.contrast";
  EDionColors2["ELEVATION_3_MAIN"] = "elevation3.main";
  EDionColors2["ELEVATION_OBJECT_STATUS_5_CONTRAST"] = "elevationObject.status5Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_5_BACKGROUND"] = "elevationObject.status5Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_5_CONTENT"] = "elevationObject.status5Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_4_CONTRAST"] = "elevationObject.status4Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_4_BACKGROUND"] = "elevationObject.status4Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_4_CONTENT"] = "elevationObject.status4Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_3_CONTRAST"] = "elevationObject.status3Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_3_BACKGROUND"] = "elevationObject.status3Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_3_CONTENT"] = "elevationObject.status3Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_2_CONTRAST"] = "elevationObject.status2Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_2_BACKGROUND"] = "elevationObject.status2Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_2_CONTENT"] = "elevationObject.status2Content";
  EDionColors2["ELEVATION_OBJECT_STATUS_1_CONTRAST"] = "elevationObject.status1Contrast";
  EDionColors2["ELEVATION_OBJECT_STATUS_1_BACKGROUND"] = "elevationObject.status1Background";
  EDionColors2["ELEVATION_OBJECT_STATUS_1_CONTENT"] = "elevationObject.status1Content";
  EDionColors2["ELEVATION_OBJECT_INFO_CONTRAST"] = "elevationObject.infoContrast";
  EDionColors2["ELEVATION_OBJECT_INFO_BACKGROUND"] = "elevationObject.infoBackground";
  EDionColors2["ELEVATION_OBJECT_INFO_CONTENT"] = "elevationObject.infoContent";
  EDionColors2["ELEVATION_OBJECT_WARNING_CONTRAST"] = "elevationObject.warningContrast";
  EDionColors2["ELEVATION_OBJECT_WARNING_BACKGROUND"] = "elevationObject.warningBackground";
  EDionColors2["ELEVATION_OBJECT_WARNING_CONTENT"] = "elevationObject.warningContent";
  EDionColors2["ELEVATION_OBJECT_SUCCESS_CONTRAST"] = "elevationObject.successContrast";
  EDionColors2["ELEVATION_OBJECT_SUCCESS_BACKGROUND"] = "elevationObject.successBackground";
  EDionColors2["ELEVATION_OBJECT_SUCCESS_CONTENT"] = "elevationObject.successContent";
  EDionColors2["ELEVATION_OBJECT_ERROR_CONTRAST"] = "elevationObject.errorContrast";
  EDionColors2["ELEVATION_OBJECT_ERROR_BACKGROUND"] = "elevationObject.errorBackground";
  EDionColors2["ELEVATION_OBJECT_ERROR_CONTENT"] = "elevationObject.errorContent";
  EDionColors2["ELEVATION_OBJECT_BRAND_CONTRAST"] = "elevationObject.brandContrast";
  EDionColors2["ELEVATION_OBJECT_BRAND_BACKGROUND"] = "elevationObject.brandBackground";
  EDionColors2["ELEVATION_OBJECT_BRAND_CONTENT"] = "elevationObject.brandContent";
  EDionColors2["ELEVATION_OBJECT_DISABLE_TEXT"] = "elevationObject.disableText";
  EDionColors2["ELEVATION_OBJECT_DISABLE"] = "elevationObject.disable";
  EDionColors2["ELEVATION_OBJECT_TRANSPARENT"] = "elevationObject.transparent";
  EDionColors2["ELEVATION_OBJECT_FOCUS"] = "elevationObject.focus";
  EDionColors2["ELEVATION_OBJECT_PRESS"] = "elevationObject.press";
  EDionColors2["ELEVATION_OBJECT_HOVER"] = "elevationObject.hover";
  EDionColors2["ELEVATION_OBJECT_LOW_ACCENT"] = "elevationObject.lowAccent";
  EDionColors2["ELEVATION_OBJECT_ACCENT"] = "elevationObject.accent";
  EDionColors2["ELEVATION_OBJECT_ADDITIONAL"] = "elevationObject.additional";
  EDionColors2["ELEVATION_OBJECT_LOW_CONTRAST"] = "elevationObject.lowContrast";
  EDionColors2["ELEVATION_OBJECT_CONTRAST"] = "elevationObject.contrast";
  EDionColors2["ELEVATION_OBJECT_MAIN"] = "elevationObject.main";
  EDionColors2["STATIC_BLACK_80_STATUS_5_CONTRAST"] = "staticBlack80.status5Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_5_BACKGROUND"] = "staticBlack80.status5Background";
  EDionColors2["STATIC_BLACK_80_STATUS_5_CONTENT"] = "staticBlack80.status5Content";
  EDionColors2["STATIC_BLACK_80_STATUS_4_CONTRAST"] = "staticBlack80.status4Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_4_BACKGROUND"] = "staticBlack80.status4Background";
  EDionColors2["STATIC_BLACK_80_STATUS_4_CONTENT"] = "staticBlack80.status4Content";
  EDionColors2["STATIC_BLACK_80_STATUS_3_CONTRAST"] = "staticBlack80.status3Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_3_BACKGROUND"] = "staticBlack80.status3Background";
  EDionColors2["STATIC_BLACK_80_STATUS_3_CONTENT"] = "staticBlack80.status3Content";
  EDionColors2["STATIC_BLACK_80_STATUS_2_CONTRAST"] = "staticBlack80.status2Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_2_BACKGROUND"] = "staticBlack80.status2Background";
  EDionColors2["STATIC_BLACK_80_STATUS_2_CONTENT"] = "staticBlack80.status2Content";
  EDionColors2["STATIC_BLACK_80_STATUS_1_CONTRAST"] = "staticBlack80.status1Contrast";
  EDionColors2["STATIC_BLACK_80_STATUS_1_BACKGROUND"] = "staticBlack80.status1Background";
  EDionColors2["STATIC_BLACK_80_STATUS_1_CONTENT"] = "staticBlack80.status1Content";
  EDionColors2["STATIC_BLACK_80_INFO_CONTRAST"] = "staticBlack80.infoContrast";
  EDionColors2["STATIC_BLACK_80_INFO_BACKGROUND"] = "staticBlack80.infoBackground";
  EDionColors2["STATIC_BLACK_80_INFO_CONTENT"] = "staticBlack80.infoContent";
  EDionColors2["STATIC_BLACK_80_WARNING_CONTRAST"] = "staticBlack80.warningContrast";
  EDionColors2["STATIC_BLACK_80_WARNING_BACKGROUND"] = "staticBlack80.warningBackground";
  EDionColors2["STATIC_BLACK_80_WARNING_CONTENT"] = "staticBlack80.warningContent";
  EDionColors2["STATIC_BLACK_80_SUCCESS_CONTRAST"] = "staticBlack80.successContrast";
  EDionColors2["STATIC_BLACK_80_SUCCESS_BACKGROUND"] = "staticBlack80.successBackground";
  EDionColors2["STATIC_BLACK_80_SUCCESS_CONTENT"] = "staticBlack80.successContent";
  EDionColors2["STATIC_BLACK_80_ERROR_CONTRAST"] = "staticBlack80.errorContrast";
  EDionColors2["STATIC_BLACK_80_ERROR_BACKGROUND"] = "staticBlack80.errorBackground";
  EDionColors2["STATIC_BLACK_80_ERROR_CONTENT"] = "staticBlack80.errorContent";
  EDionColors2["STATIC_BLACK_80_BRAND_CONTRAST"] = "staticBlack80.brandContrast";
  EDionColors2["STATIC_BLACK_80_BRAND_BACKGROUND"] = "staticBlack80.brandBackground";
  EDionColors2["STATIC_BLACK_80_BRAND_CONTENT"] = "staticBlack80.brandContent";
  EDionColors2["STATIC_BLACK_80_DISABLE_TEXT"] = "staticBlack80.disableText";
  EDionColors2["STATIC_BLACK_80_DISABLE"] = "staticBlack80.disable";
  EDionColors2["STATIC_BLACK_80_TRANSPARENT"] = "staticBlack80.transparent";
  EDionColors2["STATIC_BLACK_80_FOCUS"] = "staticBlack80.focus";
  EDionColors2["STATIC_BLACK_80_PRESS"] = "staticBlack80.press";
  EDionColors2["STATIC_BLACK_80_HOVER"] = "staticBlack80.hover";
  EDionColors2["STATIC_BLACK_80_LOW_ACCENT"] = "staticBlack80.lowAccent";
  EDionColors2["STATIC_BLACK_80_ACCENT"] = "staticBlack80.accent";
  EDionColors2["STATIC_BLACK_80_ADDITIONAL"] = "staticBlack80.additional";
  EDionColors2["STATIC_BLACK_80_LOW_CONTRAST"] = "staticBlack80.lowContrast";
  EDionColors2["STATIC_BLACK_80_CONTRAST"] = "staticBlack80.contrast";
  EDionColors2["STATIC_BLACK_80_MAIN"] = "staticBlack80.main";
  EDionColors2["STATIC_BLACK_60_STATUS_5_CONTRAST"] = "staticBlack60.status5Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_5_BACKGROUND"] = "staticBlack60.status5Background";
  EDionColors2["STATIC_BLACK_60_STATUS_5_CONTENT"] = "staticBlack60.status5Content";
  EDionColors2["STATIC_BLACK_60_STATUS_4_CONTRAST"] = "staticBlack60.status4Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_4_BACKGROUND"] = "staticBlack60.status4Background";
  EDionColors2["STATIC_BLACK_60_STATUS_4_CONTENT"] = "staticBlack60.status4Content";
  EDionColors2["STATIC_BLACK_60_STATUS_3_CONTRAST"] = "staticBlack60.status3Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_3_BACKGROUND"] = "staticBlack60.status3Background";
  EDionColors2["STATIC_BLACK_60_STATUS_3_CONTENT"] = "staticBlack60.status3Content";
  EDionColors2["STATIC_BLACK_60_STATUS_2_CONTRAST"] = "staticBlack60.status2Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_2_BACKGROUND"] = "staticBlack60.status2Background";
  EDionColors2["STATIC_BLACK_60_STATUS_2_CONTENT"] = "staticBlack60.status2Content";
  EDionColors2["STATIC_BLACK_60_STATUS_1_CONTRAST"] = "staticBlack60.status1Contrast";
  EDionColors2["STATIC_BLACK_60_STATUS_1_BACKGROUND"] = "staticBlack60.status1Background";
  EDionColors2["STATIC_BLACK_60_STATUS_1_CONTENT"] = "staticBlack60.status1Content";
  EDionColors2["STATIC_BLACK_60_INFO_CONTRAST"] = "staticBlack60.infoContrast";
  EDionColors2["STATIC_BLACK_60_INFO_BACKGROUND"] = "staticBlack60.infoBackground";
  EDionColors2["STATIC_BLACK_60_INFO_CONTENT"] = "staticBlack60.infoContent";
  EDionColors2["STATIC_BLACK_60_WARNING_CONTRAST"] = "staticBlack60.warningContrast";
  EDionColors2["STATIC_BLACK_60_WARNING_BACKGROUND"] = "staticBlack60.warningBackground";
  EDionColors2["STATIC_BLACK_60_WARNING_CONTENT"] = "staticBlack60.warningContent";
  EDionColors2["STATIC_BLACK_60_SUCCESS_CONTRAST"] = "staticBlack60.successContrast";
  EDionColors2["STATIC_BLACK_60_SUCCESS_BACKGROUND"] = "staticBlack60.successBackground";
  EDionColors2["STATIC_BLACK_60_SUCCESS_CONTENT"] = "staticBlack60.successContent";
  EDionColors2["STATIC_BLACK_60_ERROR_CONTRAST"] = "staticBlack60.errorContrast";
  EDionColors2["STATIC_BLACK_60_ERROR_BACKGROUND"] = "staticBlack60.errorBackground";
  EDionColors2["STATIC_BLACK_60_ERROR_CONTENT"] = "staticBlack60.errorContent";
  EDionColors2["STATIC_BLACK_60_BRAND_CONTRAST"] = "staticBlack60.brandContrast";
  EDionColors2["STATIC_BLACK_60_BRAND_BACKGROUND"] = "staticBlack60.brandBackground";
  EDionColors2["STATIC_BLACK_60_BRAND_CONTENT"] = "staticBlack60.brandContent";
  EDionColors2["STATIC_BLACK_60_DISABLE_TEXT"] = "staticBlack60.disableText";
  EDionColors2["STATIC_BLACK_60_DISABLE"] = "staticBlack60.disable";
  EDionColors2["STATIC_BLACK_60_TRANSPARENT"] = "staticBlack60.transparent";
  EDionColors2["STATIC_BLACK_60_FOCUS"] = "staticBlack60.focus";
  EDionColors2["STATIC_BLACK_60_PRESS"] = "staticBlack60.press";
  EDionColors2["STATIC_BLACK_60_HOVER"] = "staticBlack60.hover";
  EDionColors2["STATIC_BLACK_60_LOW_ACCENT"] = "staticBlack60.lowAccent";
  EDionColors2["STATIC_BLACK_60_ACCENT"] = "staticBlack60.accent";
  EDionColors2["STATIC_BLACK_60_ADDITIONAL"] = "staticBlack60.additional";
  EDionColors2["STATIC_BLACK_60_LOW_CONTRAST"] = "staticBlack60.lowContrast";
  EDionColors2["STATIC_BLACK_60_CONTRAST"] = "staticBlack60.contrast";
  EDionColors2["STATIC_BLACK_60_MAIN"] = "staticBlack60.main";
  EDionColors2["BRAND_STATUS_5_CONTRAST"] = "brand.status5Contrast";
  EDionColors2["BRAND_STATUS_5_BACKGROUND"] = "brand.status5Background";
  EDionColors2["BRAND_STATUS_5_CONTENT"] = "brand.status5Content";
  EDionColors2["BRAND_STATUS_4_CONTRAST"] = "brand.status4Contrast";
  EDionColors2["BRAND_STATUS_4_BACKGROUND"] = "brand.status4Background";
  EDionColors2["BRAND_STATUS_4_CONTENT"] = "brand.status4Content";
  EDionColors2["BRAND_STATUS_3_CONTRAST"] = "brand.status3Contrast";
  EDionColors2["BRAND_STATUS_3_BACKGROUND"] = "brand.status3Background";
  EDionColors2["BRAND_STATUS_3_CONTENT"] = "brand.status3Content";
  EDionColors2["BRAND_STATUS_2_CONTRAST"] = "brand.status2Contrast";
  EDionColors2["BRAND_STATUS_2_BACKGROUND"] = "brand.status2Background";
  EDionColors2["BRAND_STATUS_2_CONTENT"] = "brand.status2Content";
  EDionColors2["BRAND_STATUS_1_CONTRAST"] = "brand.status1Contrast";
  EDionColors2["BRAND_STATUS_1_BACKGROUND"] = "brand.status1Background";
  EDionColors2["BRAND_STATUS_1_CONTENT"] = "brand.status1Content";
  EDionColors2["BRAND_INFO_CONTRAST"] = "brand.infoContrast";
  EDionColors2["BRAND_INFO_BACKGROUND"] = "brand.infoBackground";
  EDionColors2["BRAND_INFO_CONTENT"] = "brand.infoContent";
  EDionColors2["BRAND_WARNING_CONTRAST"] = "brand.warningContrast";
  EDionColors2["BRAND_WARNING_BACKGROUND"] = "brand.warningBackground";
  EDionColors2["BRAND_WARNING_CONTENT"] = "brand.warningContent";
  EDionColors2["BRAND_SUCCESS_CONTRAST"] = "brand.successContrast";
  EDionColors2["BRAND_SUCCESS_BACKGROUND"] = "brand.successBackground";
  EDionColors2["BRAND_SUCCESS_CONTENT"] = "brand.successContent";
  EDionColors2["BRAND_ERROR_CONTRAST"] = "brand.errorContrast";
  EDionColors2["BRAND_ERROR_BACKGROUND"] = "brand.errorBackground";
  EDionColors2["BRAND_ERROR_CONTENT"] = "brand.errorContent";
  EDionColors2["BRAND_BRAND_CONTRAST"] = "brand.brandContrast";
  EDionColors2["BRAND_BRAND_BACKGROUND"] = "brand.brandBackground";
  EDionColors2["BRAND_BRAND_CONTENT"] = "brand.brandContent";
  EDionColors2["BRAND_DISABLE_TEXT"] = "brand.disableText";
  EDionColors2["BRAND_DISABLE"] = "brand.disable";
  EDionColors2["BRAND_TRANSPARENT"] = "brand.transparent";
  EDionColors2["BRAND_FOCUS"] = "brand.focus";
  EDionColors2["BRAND_PRESS"] = "brand.press";
  EDionColors2["BRAND_HOVER"] = "brand.hover";
  EDionColors2["BRAND_LOW_ACCENT"] = "brand.lowAccent";
  EDionColors2["BRAND_ACCENT"] = "brand.accent";
  EDionColors2["BRAND_ADDITIONAL"] = "brand.additional";
  EDionColors2["BRAND_LOW_CONTRAST"] = "brand.lowContrast";
  EDionColors2["BRAND_CONTRAST"] = "brand.contrast";
  EDionColors2["BRAND_MAIN"] = "brand.main";
  EDionColors2["SUCCESS_STATUS_5_CONTRAST"] = "success.status5Contrast";
  EDionColors2["SUCCESS_STATUS_5_BACKGROUND"] = "success.status5Background";
  EDionColors2["SUCCESS_STATUS_5_CONTENT"] = "success.status5Content";
  EDionColors2["SUCCESS_STATUS_4_CONTRAST"] = "success.status4Contrast";
  EDionColors2["SUCCESS_STATUS_4_BACKGROUND"] = "success.status4Background";
  EDionColors2["SUCCESS_STATUS_4_CONTENT"] = "success.status4Content";
  EDionColors2["SUCCESS_STATUS_3_CONTRAST"] = "success.status3Contrast";
  EDionColors2["SUCCESS_STATUS_3_BACKGROUND"] = "success.status3Background";
  EDionColors2["SUCCESS_STATUS_3_CONTENT"] = "success.status3Content";
  EDionColors2["SUCCESS_STATUS_2_CONTRAST"] = "success.status2Contrast";
  EDionColors2["SUCCESS_STATUS_2_BACKGROUND"] = "success.status2Background";
  EDionColors2["SUCCESS_STATUS_2_CONTENT"] = "success.status2Content";
  EDionColors2["SUCCESS_STATUS_1_CONTRAST"] = "success.status1Contrast";
  EDionColors2["SUCCESS_STATUS_1_BACKGROUND"] = "success.status1Background";
  EDionColors2["SUCCESS_STATUS_1_CONTENT"] = "success.status1Content";
  EDionColors2["SUCCESS_INFO_CONTRAST"] = "success.infoContrast";
  EDionColors2["SUCCESS_INFO_BACKGROUND"] = "success.infoBackground";
  EDionColors2["SUCCESS_INFO_CONTENT"] = "success.infoContent";
  EDionColors2["SUCCESS_WARNING_CONTRAST"] = "success.warningContrast";
  EDionColors2["SUCCESS_WARNING_BACKGROUND"] = "success.warningBackground";
  EDionColors2["SUCCESS_WARNING_CONTENT"] = "success.warningContent";
  EDionColors2["SUCCESS_SUCCESS_CONTRAST"] = "success.successContrast";
  EDionColors2["SUCCESS_SUCCESS_BACKGROUND"] = "success.successBackground";
  EDionColors2["SUCCESS_SUCCESS_CONTENT"] = "success.successContent";
  EDionColors2["SUCCESS_ERROR_CONTRAST"] = "success.errorContrast";
  EDionColors2["SUCCESS_ERROR_BACKGROUND"] = "success.errorBackground";
  EDionColors2["SUCCESS_ERROR_CONTENT"] = "success.errorContent";
  EDionColors2["SUCCESS_BRAND_CONTRAST"] = "success.brandContrast";
  EDionColors2["SUCCESS_BRAND_BACKGROUND"] = "success.brandBackground";
  EDionColors2["SUCCESS_BRAND_CONTENT"] = "success.brandContent";
  EDionColors2["SUCCESS_DISABLE_TEXT"] = "success.disableText";
  EDionColors2["SUCCESS_DISABLE"] = "success.disable";
  EDionColors2["SUCCESS_TRANSPARENT"] = "success.transparent";
  EDionColors2["SUCCESS_FOCUS"] = "success.focus";
  EDionColors2["SUCCESS_PRESS"] = "success.press";
  EDionColors2["SUCCESS_HOVER"] = "success.hover";
  EDionColors2["SUCCESS_LOW_ACCENT"] = "success.lowAccent";
  EDionColors2["SUCCESS_ACCENT"] = "success.accent";
  EDionColors2["SUCCESS_ADDITIONAL"] = "success.additional";
  EDionColors2["SUCCESS_LOW_CONTRAST"] = "success.lowContrast";
  EDionColors2["SUCCESS_CONTRAST"] = "success.contrast";
  EDionColors2["SUCCESS_MAIN"] = "success.main";
  EDionColors2["WARNING_STATUS_5_CONTRAST"] = "warning.status5Contrast";
  EDionColors2["WARNING_STATUS_5_BACKGROUND"] = "warning.status5Background";
  EDionColors2["WARNING_STATUS_5_CONTENT"] = "warning.status5Content";
  EDionColors2["WARNING_STATUS_4_CONTRAST"] = "warning.status4Contrast";
  EDionColors2["WARNING_STATUS_4_BACKGROUND"] = "warning.status4Background";
  EDionColors2["WARNING_STATUS_4_CONTENT"] = "warning.status4Content";
  EDionColors2["WARNING_STATUS_3_CONTRAST"] = "warning.status3Contrast";
  EDionColors2["WARNING_STATUS_3_BACKGROUND"] = "warning.status3Background";
  EDionColors2["WARNING_STATUS_3_CONTENT"] = "warning.status3Content";
  EDionColors2["WARNING_STATUS_2_CONTRAST"] = "warning.status2Contrast";
  EDionColors2["WARNING_STATUS_2_BACKGROUND"] = "warning.status2Background";
  EDionColors2["WARNING_STATUS_2_CONTENT"] = "warning.status2Content";
  EDionColors2["WARNING_STATUS_1_CONTRAST"] = "warning.status1Contrast";
  EDionColors2["WARNING_STATUS_1_BACKGROUND"] = "warning.status1Background";
  EDionColors2["WARNING_STATUS_1_CONTENT"] = "warning.status1Content";
  EDionColors2["WARNING_INFO_CONTRAST"] = "warning.infoContrast";
  EDionColors2["WARNING_INFO_BACKGROUND"] = "warning.infoBackground";
  EDionColors2["WARNING_INFO_CONTENT"] = "warning.infoContent";
  EDionColors2["WARNING_WARNING_CONTRAST"] = "warning.warningContrast";
  EDionColors2["WARNING_WARNING_BACKGROUND"] = "warning.warningBackground";
  EDionColors2["WARNING_WARNING_CONTENT"] = "warning.warningContent";
  EDionColors2["WARNING_SUCCESS_CONTRAST"] = "warning.successContrast";
  EDionColors2["WARNING_SUCCESS_BACKGROUND"] = "warning.successBackground";
  EDionColors2["WARNING_SUCCESS_CONTENT"] = "warning.successContent";
  EDionColors2["WARNING_ERROR_CONTRAST"] = "warning.errorContrast";
  EDionColors2["WARNING_ERROR_BACKGROUND"] = "warning.errorBackground";
  EDionColors2["WARNING_ERROR_CONTENT"] = "warning.errorContent";
  EDionColors2["WARNING_BRAND_CONTRAST"] = "warning.brandContrast";
  EDionColors2["WARNING_BRAND_BACKGROUND"] = "warning.brandBackground";
  EDionColors2["WARNING_BRAND_CONTENT"] = "warning.brandContent";
  EDionColors2["WARNING_DISABLE_TEXT"] = "warning.disableText";
  EDionColors2["WARNING_DISABLE"] = "warning.disable";
  EDionColors2["WARNING_TRANSPARENT"] = "warning.transparent";
  EDionColors2["WARNING_FOCUS"] = "warning.focus";
  EDionColors2["WARNING_PRESS"] = "warning.press";
  EDionColors2["WARNING_HOVER"] = "warning.hover";
  EDionColors2["WARNING_LOW_ACCENT"] = "warning.lowAccent";
  EDionColors2["WARNING_ACCENT"] = "warning.accent";
  EDionColors2["WARNING_ADDITIONAL"] = "warning.additional";
  EDionColors2["WARNING_LOW_CONTRAST"] = "warning.lowContrast";
  EDionColors2["WARNING_CONTRAST"] = "warning.contrast";
  EDionColors2["WARNING_MAIN"] = "warning.main";
  EDionColors2["ON_BRAND_STATUS_5_CONTRAST"] = "onBrand.status5Contrast";
  EDionColors2["ON_BRAND_STATUS_5_BACKGROUND"] = "onBrand.status5Background";
  EDionColors2["ON_BRAND_STATUS_5_CONTENT"] = "onBrand.status5Content";
  EDionColors2["ON_BRAND_STATUS_4_CONTRAST"] = "onBrand.status4Contrast";
  EDionColors2["ON_BRAND_STATUS_4_BACKGROUND"] = "onBrand.status4Background";
  EDionColors2["ON_BRAND_STATUS_4_CONTENT"] = "onBrand.status4Content";
  EDionColors2["ON_BRAND_STATUS_3_CONTRAST"] = "onBrand.status3Contrast";
  EDionColors2["ON_BRAND_STATUS_3_BACKGROUND"] = "onBrand.status3Background";
  EDionColors2["ON_BRAND_STATUS_3_CONTENT"] = "onBrand.status3Content";
  EDionColors2["ON_BRAND_STATUS_2_CONTRAST"] = "onBrand.status2Contrast";
  EDionColors2["ON_BRAND_STATUS_2_BACKGROUND"] = "onBrand.status2Background";
  EDionColors2["ON_BRAND_STATUS_2_CONTENT"] = "onBrand.status2Content";
  EDionColors2["ON_BRAND_STATUS_1_CONTRAST"] = "onBrand.status1Contrast";
  EDionColors2["ON_BRAND_STATUS_1_BACKGROUND"] = "onBrand.status1Background";
  EDionColors2["ON_BRAND_STATUS_1_CONTENT"] = "onBrand.status1Content";
  EDionColors2["ON_BRAND_INFO_CONTRAST"] = "onBrand.infoContrast";
  EDionColors2["ON_BRAND_INFO_BACKGROUND"] = "onBrand.infoBackground";
  EDionColors2["ON_BRAND_INFO_CONTENT"] = "onBrand.infoContent";
  EDionColors2["ON_BRAND_WARNING_CONTRAST"] = "onBrand.warningContrast";
  EDionColors2["ON_BRAND_WARNING_BACKGROUND"] = "onBrand.warningBackground";
  EDionColors2["ON_BRAND_WARNING_CONTENT"] = "onBrand.warningContent";
  EDionColors2["ON_BRAND_SUCCESS_CONTRAST"] = "onBrand.successContrast";
  EDionColors2["ON_BRAND_SUCCESS_BACKGROUND"] = "onBrand.successBackground";
  EDionColors2["ON_BRAND_SUCCESS_CONTENT"] = "onBrand.successContent";
  EDionColors2["ON_BRAND_ERROR_CONTRAST"] = "onBrand.errorContrast";
  EDionColors2["ON_BRAND_ERROR_BACKGROUND"] = "onBrand.errorBackground";
  EDionColors2["ON_BRAND_ERROR_CONTENT"] = "onBrand.errorContent";
  EDionColors2["ON_BRAND_BRAND_CONTRAST"] = "onBrand.brandContrast";
  EDionColors2["ON_BRAND_BRAND_BACKGROUND"] = "onBrand.brandBackground";
  EDionColors2["ON_BRAND_BRAND_CONTENT"] = "onBrand.brandContent";
  EDionColors2["ON_BRAND_DISABLE_TEXT"] = "onBrand.disableText";
  EDionColors2["ON_BRAND_DISABLE"] = "onBrand.disable";
  EDionColors2["ON_BRAND_TRANSPARENT"] = "onBrand.transparent";
  EDionColors2["ON_BRAND_FOCUS"] = "onBrand.focus";
  EDionColors2["ON_BRAND_PRESS"] = "onBrand.press";
  EDionColors2["ON_BRAND_HOVER"] = "onBrand.hover";
  EDionColors2["ON_BRAND_LOW_ACCENT"] = "onBrand.lowAccent";
  EDionColors2["ON_BRAND_ACCENT"] = "onBrand.accent";
  EDionColors2["ON_BRAND_ADDITIONAL"] = "onBrand.additional";
  EDionColors2["ON_BRAND_LOW_CONTRAST"] = "onBrand.lowContrast";
  EDionColors2["ON_BRAND_CONTRAST"] = "onBrand.contrast";
  EDionColors2["ON_BRAND_MAIN"] = "onBrand.main";
  EDionColors2["ERROR_STATUS_5_CONTRAST"] = "error.status5Contrast";
  EDionColors2["ERROR_STATUS_5_BACKGROUND"] = "error.status5Background";
  EDionColors2["ERROR_STATUS_5_CONTENT"] = "error.status5Content";
  EDionColors2["ERROR_STATUS_4_CONTRAST"] = "error.status4Contrast";
  EDionColors2["ERROR_STATUS_4_BACKGROUND"] = "error.status4Background";
  EDionColors2["ERROR_STATUS_4_CONTENT"] = "error.status4Content";
  EDionColors2["ERROR_STATUS_3_CONTRAST"] = "error.status3Contrast";
  EDionColors2["ERROR_STATUS_3_BACKGROUND"] = "error.status3Background";
  EDionColors2["ERROR_STATUS_3_CONTENT"] = "error.status3Content";
  EDionColors2["ERROR_STATUS_2_CONTRAST"] = "error.status2Contrast";
  EDionColors2["ERROR_STATUS_2_BACKGROUND"] = "error.status2Background";
  EDionColors2["ERROR_STATUS_2_CONTENT"] = "error.status2Content";
  EDionColors2["ERROR_STATUS_1_CONTRAST"] = "error.status1Contrast";
  EDionColors2["ERROR_STATUS_1_BACKGROUND"] = "error.status1Background";
  EDionColors2["ERROR_STATUS_1_CONTENT"] = "error.status1Content";
  EDionColors2["ERROR_INFO_CONTRAST"] = "error.infoContrast";
  EDionColors2["ERROR_INFO_BACKGROUND"] = "error.infoBackground";
  EDionColors2["ERROR_INFO_CONTENT"] = "error.infoContent";
  EDionColors2["ERROR_WARNING_CONTRAST"] = "error.warningContrast";
  EDionColors2["ERROR_WARNING_BACKGROUND"] = "error.warningBackground";
  EDionColors2["ERROR_WARNING_CONTENT"] = "error.warningContent";
  EDionColors2["ERROR_SUCCESS_CONTRAST"] = "error.successContrast";
  EDionColors2["ERROR_SUCCESS_BACKGROUND"] = "error.successBackground";
  EDionColors2["ERROR_SUCCESS_CONTENT"] = "error.successContent";
  EDionColors2["ERROR_ERROR_CONTRAST"] = "error.errorContrast";
  EDionColors2["ERROR_ERROR_BACKGROUND"] = "error.errorBackground";
  EDionColors2["ERROR_ERROR_CONTENT"] = "error.errorContent";
  EDionColors2["ERROR_BRAND_CONTRAST"] = "error.brandContrast";
  EDionColors2["ERROR_BRAND_BACKGROUND"] = "error.brandBackground";
  EDionColors2["ERROR_BRAND_CONTENT"] = "error.brandContent";
  EDionColors2["ERROR_DISABLE_TEXT"] = "error.disableText";
  EDionColors2["ERROR_DISABLE"] = "error.disable";
  EDionColors2["ERROR_TRANSPARENT"] = "error.transparent";
  EDionColors2["ERROR_FOCUS"] = "error.focus";
  EDionColors2["ERROR_PRESS"] = "error.press";
  EDionColors2["ERROR_HOVER"] = "error.hover";
  EDionColors2["ERROR_LOW_ACCENT"] = "error.lowAccent";
  EDionColors2["ERROR_ACCENT"] = "error.accent";
  EDionColors2["ERROR_ADDITIONAL"] = "error.additional";
  EDionColors2["ERROR_LOW_CONTRAST"] = "error.lowContrast";
  EDionColors2["ERROR_CONTRAST"] = "error.contrast";
  EDionColors2["ERROR_MAIN"] = "error.main";
  EDionColors2["INFO_STATUS_5_CONTRAST"] = "info.status5Contrast";
  EDionColors2["INFO_STATUS_5_BACKGROUND"] = "info.status5Background";
  EDionColors2["INFO_STATUS_5_CONTENT"] = "info.status5Content";
  EDionColors2["INFO_STATUS_4_CONTRAST"] = "info.status4Contrast";
  EDionColors2["INFO_STATUS_4_BACKGROUND"] = "info.status4Background";
  EDionColors2["INFO_STATUS_4_CONTENT"] = "info.status4Content";
  EDionColors2["INFO_STATUS_3_CONTRAST"] = "info.status3Contrast";
  EDionColors2["INFO_STATUS_3_BACKGROUND"] = "info.status3Background";
  EDionColors2["INFO_STATUS_3_CONTENT"] = "info.status3Content";
  EDionColors2["INFO_STATUS_2_CONTRAST"] = "info.status2Contrast";
  EDionColors2["INFO_STATUS_2_BACKGROUND"] = "info.status2Background";
  EDionColors2["INFO_STATUS_2_CONTENT"] = "info.status2Content";
  EDionColors2["INFO_STATUS_1_CONTRAST"] = "info.status1Contrast";
  EDionColors2["INFO_STATUS_1_BACKGROUND"] = "info.status1Background";
  EDionColors2["INFO_STATUS_1_CONTENT"] = "info.status1Content";
  EDionColors2["INFO_INFO_CONTRAST"] = "info.infoContrast";
  EDionColors2["INFO_INFO_BACKGROUND"] = "info.infoBackground";
  EDionColors2["INFO_INFO_CONTENT"] = "info.infoContent";
  EDionColors2["INFO_WARNING_CONTRAST"] = "info.warningContrast";
  EDionColors2["INFO_WARNING_BACKGROUND"] = "info.warningBackground";
  EDionColors2["INFO_WARNING_CONTENT"] = "info.warningContent";
  EDionColors2["INFO_SUCCESS_CONTRAST"] = "info.successContrast";
  EDionColors2["INFO_SUCCESS_BACKGROUND"] = "info.successBackground";
  EDionColors2["INFO_SUCCESS_CONTENT"] = "info.successContent";
  EDionColors2["INFO_ERROR_CONTRAST"] = "info.errorContrast";
  EDionColors2["INFO_ERROR_BACKGROUND"] = "info.errorBackground";
  EDionColors2["INFO_ERROR_CONTENT"] = "info.errorContent";
  EDionColors2["INFO_BRAND_CONTRAST"] = "info.brandContrast";
  EDionColors2["INFO_BRAND_BACKGROUND"] = "info.brandBackground";
  EDionColors2["INFO_BRAND_CONTENT"] = "info.brandContent";
  EDionColors2["INFO_DISABLE_TEXT"] = "info.disableText";
  EDionColors2["INFO_DISABLE"] = "info.disable";
  EDionColors2["INFO_TRANSPARENT"] = "info.transparent";
  EDionColors2["INFO_FOCUS"] = "info.focus";
  EDionColors2["INFO_PRESS"] = "info.press";
  EDionColors2["INFO_HOVER"] = "info.hover";
  EDionColors2["INFO_LOW_ACCENT"] = "info.lowAccent";
  EDionColors2["INFO_ACCENT"] = "info.accent";
  EDionColors2["INFO_ADDITIONAL"] = "info.additional";
  EDionColors2["INFO_LOW_CONTRAST"] = "info.lowContrast";
  EDionColors2["INFO_CONTRAST"] = "info.contrast";
  EDionColors2["INFO_MAIN"] = "info.main";
  EDionColors2["STATUS_1_STATUS_5_CONTRAST"] = "status1.status5Contrast";
  EDionColors2["STATUS_1_STATUS_5_BACKGROUND"] = "status1.status5Background";
  EDionColors2["STATUS_1_STATUS_5_CONTENT"] = "status1.status5Content";
  EDionColors2["STATUS_1_STATUS_4_CONTRAST"] = "status1.status4Contrast";
  EDionColors2["STATUS_1_STATUS_4_BACKGROUND"] = "status1.status4Background";
  EDionColors2["STATUS_1_STATUS_4_CONTENT"] = "status1.status4Content";
  EDionColors2["STATUS_1_STATUS_3_CONTRAST"] = "status1.status3Contrast";
  EDionColors2["STATUS_1_STATUS_3_BACKGROUND"] = "status1.status3Background";
  EDionColors2["STATUS_1_STATUS_3_CONTENT"] = "status1.status3Content";
  EDionColors2["STATUS_1_STATUS_2_CONTRAST"] = "status1.status2Contrast";
  EDionColors2["STATUS_1_STATUS_2_BACKGROUND"] = "status1.status2Background";
  EDionColors2["STATUS_1_STATUS_2_CONTENT"] = "status1.status2Content";
  EDionColors2["STATUS_1_STATUS_1_CONTRAST"] = "status1.status1Contrast";
  EDionColors2["STATUS_1_STATUS_1_BACKGROUND"] = "status1.status1Background";
  EDionColors2["STATUS_1_STATUS_1_CONTENT"] = "status1.status1Content";
  EDionColors2["STATUS_1_INFO_CONTRAST"] = "status1.infoContrast";
  EDionColors2["STATUS_1_INFO_BACKGROUND"] = "status1.infoBackground";
  EDionColors2["STATUS_1_INFO_CONTENT"] = "status1.infoContent";
  EDionColors2["STATUS_1_WARNING_CONTRAST"] = "status1.warningContrast";
  EDionColors2["STATUS_1_WARNING_BACKGROUND"] = "status1.warningBackground";
  EDionColors2["STATUS_1_WARNING_CONTENT"] = "status1.warningContent";
  EDionColors2["STATUS_1_SUCCESS_CONTRAST"] = "status1.successContrast";
  EDionColors2["STATUS_1_SUCCESS_BACKGROUND"] = "status1.successBackground";
  EDionColors2["STATUS_1_SUCCESS_CONTENT"] = "status1.successContent";
  EDionColors2["STATUS_1_ERROR_CONTRAST"] = "status1.errorContrast";
  EDionColors2["STATUS_1_ERROR_BACKGROUND"] = "status1.errorBackground";
  EDionColors2["STATUS_1_ERROR_CONTENT"] = "status1.errorContent";
  EDionColors2["STATUS_1_BRAND_CONTRAST"] = "status1.brandContrast";
  EDionColors2["STATUS_1_BRAND_BACKGROUND"] = "status1.brandBackground";
  EDionColors2["STATUS_1_BRAND_CONTENT"] = "status1.brandContent";
  EDionColors2["STATUS_1_DISABLE_TEXT"] = "status1.disableText";
  EDionColors2["STATUS_1_DISABLE"] = "status1.disable";
  EDionColors2["STATUS_1_TRANSPARENT"] = "status1.transparent";
  EDionColors2["STATUS_1_FOCUS"] = "status1.focus";
  EDionColors2["STATUS_1_PRESS"] = "status1.press";
  EDionColors2["STATUS_1_HOVER"] = "status1.hover";
  EDionColors2["STATUS_1_LOW_ACCENT"] = "status1.lowAccent";
  EDionColors2["STATUS_1_ACCENT"] = "status1.accent";
  EDionColors2["STATUS_1_ADDITIONAL"] = "status1.additional";
  EDionColors2["STATUS_1_LOW_CONTRAST"] = "status1.lowContrast";
  EDionColors2["STATUS_1_CONTRAST"] = "status1.contrast";
  EDionColors2["STATUS_1_MAIN"] = "status1.main";
  EDionColors2["STATUS_2_STATUS_5_CONTRAST"] = "status2.status5Contrast";
  EDionColors2["STATUS_2_STATUS_5_BACKGROUND"] = "status2.status5Background";
  EDionColors2["STATUS_2_STATUS_5_CONTENT"] = "status2.status5Content";
  EDionColors2["STATUS_2_STATUS_4_CONTRAST"] = "status2.status4Contrast";
  EDionColors2["STATUS_2_STATUS_4_BACKGROUND"] = "status2.status4Background";
  EDionColors2["STATUS_2_STATUS_4_CONTENT"] = "status2.status4Content";
  EDionColors2["STATUS_2_STATUS_3_CONTRAST"] = "status2.status3Contrast";
  EDionColors2["STATUS_2_STATUS_3_BACKGROUND"] = "status2.status3Background";
  EDionColors2["STATUS_2_STATUS_3_CONTENT"] = "status2.status3Content";
  EDionColors2["STATUS_2_STATUS_2_CONTRAST"] = "status2.status2Contrast";
  EDionColors2["STATUS_2_STATUS_2_BACKGROUND"] = "status2.status2Background";
  EDionColors2["STATUS_2_STATUS_2_CONTENT"] = "status2.status2Content";
  EDionColors2["STATUS_2_STATUS_1_CONTRAST"] = "status2.status1Contrast";
  EDionColors2["STATUS_2_STATUS_1_BACKGROUND"] = "status2.status1Background";
  EDionColors2["STATUS_2_STATUS_1_CONTENT"] = "status2.status1Content";
  EDionColors2["STATUS_2_INFO_CONTRAST"] = "status2.infoContrast";
  EDionColors2["STATUS_2_INFO_BACKGROUND"] = "status2.infoBackground";
  EDionColors2["STATUS_2_INFO_CONTENT"] = "status2.infoContent";
  EDionColors2["STATUS_2_WARNING_CONTRAST"] = "status2.warningContrast";
  EDionColors2["STATUS_2_WARNING_BACKGROUND"] = "status2.warningBackground";
  EDionColors2["STATUS_2_WARNING_CONTENT"] = "status2.warningContent";
  EDionColors2["STATUS_2_SUCCESS_CONTRAST"] = "status2.successContrast";
  EDionColors2["STATUS_2_SUCCESS_BACKGROUND"] = "status2.successBackground";
  EDionColors2["STATUS_2_SUCCESS_CONTENT"] = "status2.successContent";
  EDionColors2["STATUS_2_ERROR_CONTRAST"] = "status2.errorContrast";
  EDionColors2["STATUS_2_ERROR_BACKGROUND"] = "status2.errorBackground";
  EDionColors2["STATUS_2_ERROR_CONTENT"] = "status2.errorContent";
  EDionColors2["STATUS_2_BRAND_CONTRAST"] = "status2.brandContrast";
  EDionColors2["STATUS_2_BRAND_BACKGROUND"] = "status2.brandBackground";
  EDionColors2["STATUS_2_BRAND_CONTENT"] = "status2.brandContent";
  EDionColors2["STATUS_2_DISABLE_TEXT"] = "status2.disableText";
  EDionColors2["STATUS_2_DISABLE"] = "status2.disable";
  EDionColors2["STATUS_2_TRANSPARENT"] = "status2.transparent";
  EDionColors2["STATUS_2_FOCUS"] = "status2.focus";
  EDionColors2["STATUS_2_PRESS"] = "status2.press";
  EDionColors2["STATUS_2_HOVER"] = "status2.hover";
  EDionColors2["STATUS_2_LOW_ACCENT"] = "status2.lowAccent";
  EDionColors2["STATUS_2_ACCENT"] = "status2.accent";
  EDionColors2["STATUS_2_ADDITIONAL"] = "status2.additional";
  EDionColors2["STATUS_2_LOW_CONTRAST"] = "status2.lowContrast";
  EDionColors2["STATUS_2_CONTRAST"] = "status2.contrast";
  EDionColors2["STATUS_2_MAIN"] = "status2.main";
  EDionColors2["STATUS_3_STATUS_5_CONTRAST"] = "status3.status5Contrast";
  EDionColors2["STATUS_3_STATUS_5_BACKGROUND"] = "status3.status5Background";
  EDionColors2["STATUS_3_STATUS_5_CONTENT"] = "status3.status5Content";
  EDionColors2["STATUS_3_STATUS_4_CONTRAST"] = "status3.status4Contrast";
  EDionColors2["STATUS_3_STATUS_4_BACKGROUND"] = "status3.status4Background";
  EDionColors2["STATUS_3_STATUS_4_CONTENT"] = "status3.status4Content";
  EDionColors2["STATUS_3_STATUS_3_CONTRAST"] = "status3.status3Contrast";
  EDionColors2["STATUS_3_STATUS_3_BACKGROUND"] = "status3.status3Background";
  EDionColors2["STATUS_3_STATUS_3_CONTENT"] = "status3.status3Content";
  EDionColors2["STATUS_3_STATUS_2_CONTRAST"] = "status3.status2Contrast";
  EDionColors2["STATUS_3_STATUS_2_BACKGROUND"] = "status3.status2Background";
  EDionColors2["STATUS_3_STATUS_2_CONTENT"] = "status3.status2Content";
  EDionColors2["STATUS_3_STATUS_1_CONTRAST"] = "status3.status1Contrast";
  EDionColors2["STATUS_3_STATUS_1_BACKGROUND"] = "status3.status1Background";
  EDionColors2["STATUS_3_STATUS_1_CONTENT"] = "status3.status1Content";
  EDionColors2["STATUS_3_INFO_CONTRAST"] = "status3.infoContrast";
  EDionColors2["STATUS_3_INFO_BACKGROUND"] = "status3.infoBackground";
  EDionColors2["STATUS_3_INFO_CONTENT"] = "status3.infoContent";
  EDionColors2["STATUS_3_WARNING_CONTRAST"] = "status3.warningContrast";
  EDionColors2["STATUS_3_WARNING_BACKGROUND"] = "status3.warningBackground";
  EDionColors2["STATUS_3_WARNING_CONTENT"] = "status3.warningContent";
  EDionColors2["STATUS_3_SUCCESS_CONTRAST"] = "status3.successContrast";
  EDionColors2["STATUS_3_SUCCESS_BACKGROUND"] = "status3.successBackground";
  EDionColors2["STATUS_3_SUCCESS_CONTENT"] = "status3.successContent";
  EDionColors2["STATUS_3_ERROR_CONTRAST"] = "status3.errorContrast";
  EDionColors2["STATUS_3_ERROR_BACKGROUND"] = "status3.errorBackground";
  EDionColors2["STATUS_3_ERROR_CONTENT"] = "status3.errorContent";
  EDionColors2["STATUS_3_BRAND_CONTRAST"] = "status3.brandContrast";
  EDionColors2["STATUS_3_BRAND_BACKGROUND"] = "status3.brandBackground";
  EDionColors2["STATUS_3_BRAND_CONTENT"] = "status3.brandContent";
  EDionColors2["STATUS_3_DISABLE_TEXT"] = "status3.disableText";
  EDionColors2["STATUS_3_DISABLE"] = "status3.disable";
  EDionColors2["STATUS_3_TRANSPARENT"] = "status3.transparent";
  EDionColors2["STATUS_3_FOCUS"] = "status3.focus";
  EDionColors2["STATUS_3_PRESS"] = "status3.press";
  EDionColors2["STATUS_3_HOVER"] = "status3.hover";
  EDionColors2["STATUS_3_LOW_ACCENT"] = "status3.lowAccent";
  EDionColors2["STATUS_3_ACCENT"] = "status3.accent";
  EDionColors2["STATUS_3_ADDITIONAL"] = "status3.additional";
  EDionColors2["STATUS_3_LOW_CONTRAST"] = "status3.lowContrast";
  EDionColors2["STATUS_3_CONTRAST"] = "status3.contrast";
  EDionColors2["STATUS_3_MAIN"] = "status3.main";
  EDionColors2["STATUS_4_STATUS_5_CONTRAST"] = "status4.status5Contrast";
  EDionColors2["STATUS_4_STATUS_5_BACKGROUND"] = "status4.status5Background";
  EDionColors2["STATUS_4_STATUS_5_CONTENT"] = "status4.status5Content";
  EDionColors2["STATUS_4_STATUS_4_CONTRAST"] = "status4.status4Contrast";
  EDionColors2["STATUS_4_STATUS_4_BACKGROUND"] = "status4.status4Background";
  EDionColors2["STATUS_4_STATUS_4_CONTENT"] = "status4.status4Content";
  EDionColors2["STATUS_4_STATUS_3_CONTRAST"] = "status4.status3Contrast";
  EDionColors2["STATUS_4_STATUS_3_BACKGROUND"] = "status4.status3Background";
  EDionColors2["STATUS_4_STATUS_3_CONTENT"] = "status4.status3Content";
  EDionColors2["STATUS_4_STATUS_2_CONTRAST"] = "status4.status2Contrast";
  EDionColors2["STATUS_4_STATUS_2_BACKGROUND"] = "status4.status2Background";
  EDionColors2["STATUS_4_STATUS_2_CONTENT"] = "status4.status2Content";
  EDionColors2["STATUS_4_STATUS_1_CONTRAST"] = "status4.status1Contrast";
  EDionColors2["STATUS_4_STATUS_1_BACKGROUND"] = "status4.status1Background";
  EDionColors2["STATUS_4_STATUS_1_CONTENT"] = "status4.status1Content";
  EDionColors2["STATUS_4_INFO_CONTRAST"] = "status4.infoContrast";
  EDionColors2["STATUS_4_INFO_BACKGROUND"] = "status4.infoBackground";
  EDionColors2["STATUS_4_INFO_CONTENT"] = "status4.infoContent";
  EDionColors2["STATUS_4_WARNING_CONTRAST"] = "status4.warningContrast";
  EDionColors2["STATUS_4_WARNING_BACKGROUND"] = "status4.warningBackground";
  EDionColors2["STATUS_4_WARNING_CONTENT"] = "status4.warningContent";
  EDionColors2["STATUS_4_SUCCESS_CONTRAST"] = "status4.successContrast";
  EDionColors2["STATUS_4_SUCCESS_BACKGROUND"] = "status4.successBackground";
  EDionColors2["STATUS_4_SUCCESS_CONTENT"] = "status4.successContent";
  EDionColors2["STATUS_4_ERROR_CONTRAST"] = "status4.errorContrast";
  EDionColors2["STATUS_4_ERROR_BACKGROUND"] = "status4.errorBackground";
  EDionColors2["STATUS_4_ERROR_CONTENT"] = "status4.errorContent";
  EDionColors2["STATUS_4_BRAND_CONTRAST"] = "status4.brandContrast";
  EDionColors2["STATUS_4_BRAND_BACKGROUND"] = "status4.brandBackground";
  EDionColors2["STATUS_4_BRAND_CONTENT"] = "status4.brandContent";
  EDionColors2["STATUS_4_DISABLE_TEXT"] = "status4.disableText";
  EDionColors2["STATUS_4_DISABLE"] = "status4.disable";
  EDionColors2["STATUS_4_TRANSPARENT"] = "status4.transparent";
  EDionColors2["STATUS_4_FOCUS"] = "status4.focus";
  EDionColors2["STATUS_4_PRESS"] = "status4.press";
  EDionColors2["STATUS_4_HOVER"] = "status4.hover";
  EDionColors2["STATUS_4_LOW_ACCENT"] = "status4.lowAccent";
  EDionColors2["STATUS_4_ACCENT"] = "status4.accent";
  EDionColors2["STATUS_4_ADDITIONAL"] = "status4.additional";
  EDionColors2["STATUS_4_LOW_CONTRAST"] = "status4.lowContrast";
  EDionColors2["STATUS_4_CONTRAST"] = "status4.contrast";
  EDionColors2["STATUS_4_MAIN"] = "status4.main";
  EDionColors2["STATUS_5_STATUS_5_CONTRAST"] = "status5.status5Contrast";
  EDionColors2["STATUS_5_STATUS_5_BACKGROUND"] = "status5.status5Background";
  EDionColors2["STATUS_5_STATUS_5_CONTENT"] = "status5.status5Content";
  EDionColors2["STATUS_5_STATUS_4_CONTRAST"] = "status5.status4Contrast";
  EDionColors2["STATUS_5_STATUS_4_BACKGROUND"] = "status5.status4Background";
  EDionColors2["STATUS_5_STATUS_4_CONTENT"] = "status5.status4Content";
  EDionColors2["STATUS_5_STATUS_3_CONTRAST"] = "status5.status3Contrast";
  EDionColors2["STATUS_5_STATUS_3_BACKGROUND"] = "status5.status3Background";
  EDionColors2["STATUS_5_STATUS_3_CONTENT"] = "status5.status3Content";
  EDionColors2["STATUS_5_STATUS_2_CONTRAST"] = "status5.status2Contrast";
  EDionColors2["STATUS_5_STATUS_2_BACKGROUND"] = "status5.status2Background";
  EDionColors2["STATUS_5_STATUS_2_CONTENT"] = "status5.status2Content";
  EDionColors2["STATUS_5_STATUS_1_CONTRAST"] = "status5.status1Contrast";
  EDionColors2["STATUS_5_STATUS_1_BACKGROUND"] = "status5.status1Background";
  EDionColors2["STATUS_5_STATUS_1_CONTENT"] = "status5.status1Content";
  EDionColors2["STATUS_5_INFO_CONTRAST"] = "status5.infoContrast";
  EDionColors2["STATUS_5_INFO_BACKGROUND"] = "status5.infoBackground";
  EDionColors2["STATUS_5_INFO_CONTENT"] = "status5.infoContent";
  EDionColors2["STATUS_5_WARNING_CONTRAST"] = "status5.warningContrast";
  EDionColors2["STATUS_5_WARNING_BACKGROUND"] = "status5.warningBackground";
  EDionColors2["STATUS_5_WARNING_CONTENT"] = "status5.warningContent";
  EDionColors2["STATUS_5_SUCCESS_CONTRAST"] = "status5.successContrast";
  EDionColors2["STATUS_5_SUCCESS_BACKGROUND"] = "status5.successBackground";
  EDionColors2["STATUS_5_SUCCESS_CONTENT"] = "status5.successContent";
  EDionColors2["STATUS_5_ERROR_CONTRAST"] = "status5.errorContrast";
  EDionColors2["STATUS_5_ERROR_BACKGROUND"] = "status5.errorBackground";
  EDionColors2["STATUS_5_ERROR_CONTENT"] = "status5.errorContent";
  EDionColors2["STATUS_5_BRAND_CONTRAST"] = "status5.brandContrast";
  EDionColors2["STATUS_5_BRAND_BACKGROUND"] = "status5.brandBackground";
  EDionColors2["STATUS_5_BRAND_CONTENT"] = "status5.brandContent";
  EDionColors2["STATUS_5_DISABLE_TEXT"] = "status5.disableText";
  EDionColors2["STATUS_5_DISABLE"] = "status5.disable";
  EDionColors2["STATUS_5_TRANSPARENT"] = "status5.transparent";
  EDionColors2["STATUS_5_FOCUS"] = "status5.focus";
  EDionColors2["STATUS_5_PRESS"] = "status5.press";
  EDionColors2["STATUS_5_HOVER"] = "status5.hover";
  EDionColors2["STATUS_5_LOW_ACCENT"] = "status5.lowAccent";
  EDionColors2["STATUS_5_ACCENT"] = "status5.accent";
  EDionColors2["STATUS_5_ADDITIONAL"] = "status5.additional";
  EDionColors2["STATUS_5_LOW_CONTRAST"] = "status5.lowContrast";
  EDionColors2["STATUS_5_CONTRAST"] = "status5.contrast";
  EDionColors2["STATUS_5_MAIN"] = "status5.main";
  EDionColors2["TRANSPARENT_5_STATUS_5_CONTRAST"] = "transparent5.status5Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_5_BACKGROUND"] = "transparent5.status5Background";
  EDionColors2["TRANSPARENT_5_STATUS_5_CONTENT"] = "transparent5.status5Content";
  EDionColors2["TRANSPARENT_5_STATUS_4_CONTRAST"] = "transparent5.status4Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_4_BACKGROUND"] = "transparent5.status4Background";
  EDionColors2["TRANSPARENT_5_STATUS_4_CONTENT"] = "transparent5.status4Content";
  EDionColors2["TRANSPARENT_5_STATUS_3_CONTRAST"] = "transparent5.status3Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_3_BACKGROUND"] = "transparent5.status3Background";
  EDionColors2["TRANSPARENT_5_STATUS_3_CONTENT"] = "transparent5.status3Content";
  EDionColors2["TRANSPARENT_5_STATUS_2_CONTRAST"] = "transparent5.status2Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_2_BACKGROUND"] = "transparent5.status2Background";
  EDionColors2["TRANSPARENT_5_STATUS_2_CONTENT"] = "transparent5.status2Content";
  EDionColors2["TRANSPARENT_5_STATUS_1_CONTRAST"] = "transparent5.status1Contrast";
  EDionColors2["TRANSPARENT_5_STATUS_1_BACKGROUND"] = "transparent5.status1Background";
  EDionColors2["TRANSPARENT_5_STATUS_1_CONTENT"] = "transparent5.status1Content";
  EDionColors2["TRANSPARENT_5_INFO_CONTRAST"] = "transparent5.infoContrast";
  EDionColors2["TRANSPARENT_5_INFO_BACKGROUND"] = "transparent5.infoBackground";
  EDionColors2["TRANSPARENT_5_INFO_CONTENT"] = "transparent5.infoContent";
  EDionColors2["TRANSPARENT_5_WARNING_CONTRAST"] = "transparent5.warningContrast";
  EDionColors2["TRANSPARENT_5_WARNING_BACKGROUND"] = "transparent5.warningBackground";
  EDionColors2["TRANSPARENT_5_WARNING_CONTENT"] = "transparent5.warningContent";
  EDionColors2["TRANSPARENT_5_SUCCESS_CONTRAST"] = "transparent5.successContrast";
  EDionColors2["TRANSPARENT_5_SUCCESS_BACKGROUND"] = "transparent5.successBackground";
  EDionColors2["TRANSPARENT_5_SUCCESS_CONTENT"] = "transparent5.successContent";
  EDionColors2["TRANSPARENT_5_ERROR_CONTRAST"] = "transparent5.errorContrast";
  EDionColors2["TRANSPARENT_5_ERROR_BACKGROUND"] = "transparent5.errorBackground";
  EDionColors2["TRANSPARENT_5_ERROR_CONTENT"] = "transparent5.errorContent";
  EDionColors2["TRANSPARENT_5_BRAND_CONTRAST"] = "transparent5.brandContrast";
  EDionColors2["TRANSPARENT_5_BRAND_BACKGROUND"] = "transparent5.brandBackground";
  EDionColors2["TRANSPARENT_5_BRAND_CONTENT"] = "transparent5.brandContent";
  EDionColors2["TRANSPARENT_5_DISABLE_TEXT"] = "transparent5.disableText";
  EDionColors2["TRANSPARENT_5_DISABLE"] = "transparent5.disable";
  EDionColors2["TRANSPARENT_5_TRANSPARENT"] = "transparent5.transparent";
  EDionColors2["TRANSPARENT_5_FOCUS"] = "transparent5.focus";
  EDionColors2["TRANSPARENT_5_PRESS"] = "transparent5.press";
  EDionColors2["TRANSPARENT_5_HOVER"] = "transparent5.hover";
  EDionColors2["TRANSPARENT_5_LOW_ACCENT"] = "transparent5.lowAccent";
  EDionColors2["TRANSPARENT_5_ACCENT"] = "transparent5.accent";
  EDionColors2["TRANSPARENT_5_ADDITIONAL"] = "transparent5.additional";
  EDionColors2["TRANSPARENT_5_LOW_CONTRAST"] = "transparent5.lowContrast";
  EDionColors2["TRANSPARENT_5_CONTRAST"] = "transparent5.contrast";
  EDionColors2["TRANSPARENT_5_MAIN"] = "transparent5.main";
  EDionColors2["BLUE_ELEVATION_1_STATUS_5_CONTRAST"] = "blueElevation1.status5Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_5_BACKGROUND"] = "blueElevation1.status5Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_5_CONTENT"] = "blueElevation1.status5Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_4_CONTRAST"] = "blueElevation1.status4Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_4_BACKGROUND"] = "blueElevation1.status4Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_4_CONTENT"] = "blueElevation1.status4Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_3_CONTRAST"] = "blueElevation1.status3Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_3_BACKGROUND"] = "blueElevation1.status3Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_3_CONTENT"] = "blueElevation1.status3Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_2_CONTRAST"] = "blueElevation1.status2Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_2_BACKGROUND"] = "blueElevation1.status2Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_2_CONTENT"] = "blueElevation1.status2Content";
  EDionColors2["BLUE_ELEVATION_1_STATUS_1_CONTRAST"] = "blueElevation1.status1Contrast";
  EDionColors2["BLUE_ELEVATION_1_STATUS_1_BACKGROUND"] = "blueElevation1.status1Background";
  EDionColors2["BLUE_ELEVATION_1_STATUS_1_CONTENT"] = "blueElevation1.status1Content";
  EDionColors2["BLUE_ELEVATION_1_INFO_CONTRAST"] = "blueElevation1.infoContrast";
  EDionColors2["BLUE_ELEVATION_1_INFO_BACKGROUND"] = "blueElevation1.infoBackground";
  EDionColors2["BLUE_ELEVATION_1_INFO_CONTENT"] = "blueElevation1.infoContent";
  EDionColors2["BLUE_ELEVATION_1_WARNING_CONTRAST"] = "blueElevation1.warningContrast";
  EDionColors2["BLUE_ELEVATION_1_WARNING_BACKGROUND"] = "blueElevation1.warningBackground";
  EDionColors2["BLUE_ELEVATION_1_WARNING_CONTENT"] = "blueElevation1.warningContent";
  EDionColors2["BLUE_ELEVATION_1_SUCCESS_CONTRAST"] = "blueElevation1.successContrast";
  EDionColors2["BLUE_ELEVATION_1_SUCCESS_BACKGROUND"] = "blueElevation1.successBackground";
  EDionColors2["BLUE_ELEVATION_1_SUCCESS_CONTENT"] = "blueElevation1.successContent";
  EDionColors2["BLUE_ELEVATION_1_ERROR_CONTRAST"] = "blueElevation1.errorContrast";
  EDionColors2["BLUE_ELEVATION_1_ERROR_BACKGROUND"] = "blueElevation1.errorBackground";
  EDionColors2["BLUE_ELEVATION_1_ERROR_CONTENT"] = "blueElevation1.errorContent";
  EDionColors2["BLUE_ELEVATION_1_BRAND_CONTRAST"] = "blueElevation1.brandContrast";
  EDionColors2["BLUE_ELEVATION_1_BRAND_BACKGROUND"] = "blueElevation1.brandBackground";
  EDionColors2["BLUE_ELEVATION_1_BRAND_CONTENT"] = "blueElevation1.brandContent";
  EDionColors2["BLUE_ELEVATION_1_DISABLE_TEXT"] = "blueElevation1.disableText";
  EDionColors2["BLUE_ELEVATION_1_DISABLE"] = "blueElevation1.disable";
  EDionColors2["BLUE_ELEVATION_1_TRANSPARENT"] = "blueElevation1.transparent";
  EDionColors2["BLUE_ELEVATION_1_FOCUS"] = "blueElevation1.focus";
  EDionColors2["BLUE_ELEVATION_1_PRESS"] = "blueElevation1.press";
  EDionColors2["BLUE_ELEVATION_1_HOVER"] = "blueElevation1.hover";
  EDionColors2["BLUE_ELEVATION_1_LOW_ACCENT"] = "blueElevation1.lowAccent";
  EDionColors2["BLUE_ELEVATION_1_ACCENT"] = "blueElevation1.accent";
  EDionColors2["BLUE_ELEVATION_1_ADDITIONAL"] = "blueElevation1.additional";
  EDionColors2["BLUE_ELEVATION_1_LOW_CONTRAST"] = "blueElevation1.lowContrast";
  EDionColors2["BLUE_ELEVATION_1_CONTRAST"] = "blueElevation1.contrast";
  EDionColors2["BLUE_ELEVATION_1_MAIN"] = "blueElevation1.main";
  EDionColors2["BLUE_ELEVATION_2_STATUS_5_CONTRAST"] = "blueElevation2.status5Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_5_BACKGROUND"] = "blueElevation2.status5Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_5_CONTENT"] = "blueElevation2.status5Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_4_CONTRAST"] = "blueElevation2.status4Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_4_BACKGROUND"] = "blueElevation2.status4Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_4_CONTENT"] = "blueElevation2.status4Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_3_CONTRAST"] = "blueElevation2.status3Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_3_BACKGROUND"] = "blueElevation2.status3Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_3_CONTENT"] = "blueElevation2.status3Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_2_CONTRAST"] = "blueElevation2.status2Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_2_BACKGROUND"] = "blueElevation2.status2Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_2_CONTENT"] = "blueElevation2.status2Content";
  EDionColors2["BLUE_ELEVATION_2_STATUS_1_CONTRAST"] = "blueElevation2.status1Contrast";
  EDionColors2["BLUE_ELEVATION_2_STATUS_1_BACKGROUND"] = "blueElevation2.status1Background";
  EDionColors2["BLUE_ELEVATION_2_STATUS_1_CONTENT"] = "blueElevation2.status1Content";
  EDionColors2["BLUE_ELEVATION_2_INFO_CONTRAST"] = "blueElevation2.infoContrast";
  EDionColors2["BLUE_ELEVATION_2_INFO_BACKGROUND"] = "blueElevation2.infoBackground";
  EDionColors2["BLUE_ELEVATION_2_INFO_CONTENT"] = "blueElevation2.infoContent";
  EDionColors2["BLUE_ELEVATION_2_WARNING_CONTRAST"] = "blueElevation2.warningContrast";
  EDionColors2["BLUE_ELEVATION_2_WARNING_BACKGROUND"] = "blueElevation2.warningBackground";
  EDionColors2["BLUE_ELEVATION_2_WARNING_CONTENT"] = "blueElevation2.warningContent";
  EDionColors2["BLUE_ELEVATION_2_SUCCESS_CONTRAST"] = "blueElevation2.successContrast";
  EDionColors2["BLUE_ELEVATION_2_SUCCESS_BACKGROUND"] = "blueElevation2.successBackground";
  EDionColors2["BLUE_ELEVATION_2_SUCCESS_CONTENT"] = "blueElevation2.successContent";
  EDionColors2["BLUE_ELEVATION_2_ERROR_CONTRAST"] = "blueElevation2.errorContrast";
  EDionColors2["BLUE_ELEVATION_2_ERROR_BACKGROUND"] = "blueElevation2.errorBackground";
  EDionColors2["BLUE_ELEVATION_2_ERROR_CONTENT"] = "blueElevation2.errorContent";
  EDionColors2["BLUE_ELEVATION_2_BRAND_CONTRAST"] = "blueElevation2.brandContrast";
  EDionColors2["BLUE_ELEVATION_2_BRAND_BACKGROUND"] = "blueElevation2.brandBackground";
  EDionColors2["BLUE_ELEVATION_2_BRAND_CONTENT"] = "blueElevation2.brandContent";
  EDionColors2["BLUE_ELEVATION_2_DISABLE_TEXT"] = "blueElevation2.disableText";
  EDionColors2["BLUE_ELEVATION_2_DISABLE"] = "blueElevation2.disable";
  EDionColors2["BLUE_ELEVATION_2_TRANSPARENT"] = "blueElevation2.transparent";
  EDionColors2["BLUE_ELEVATION_2_FOCUS"] = "blueElevation2.focus";
  EDionColors2["BLUE_ELEVATION_2_PRESS"] = "blueElevation2.press";
  EDionColors2["BLUE_ELEVATION_2_HOVER"] = "blueElevation2.hover";
  EDionColors2["BLUE_ELEVATION_2_LOW_ACCENT"] = "blueElevation2.lowAccent";
  EDionColors2["BLUE_ELEVATION_2_ACCENT"] = "blueElevation2.accent";
  EDionColors2["BLUE_ELEVATION_2_ADDITIONAL"] = "blueElevation2.additional";
  EDionColors2["BLUE_ELEVATION_2_LOW_CONTRAST"] = "blueElevation2.lowContrast";
  EDionColors2["BLUE_ELEVATION_2_CONTRAST"] = "blueElevation2.contrast";
  EDionColors2["BLUE_ELEVATION_2_MAIN"] = "blueElevation2.main";
  EDionColors2["YELLOW_ELEVATION_STATUS_5_CONTRAST"] = "yellowElevation.status5Contrast";
  EDionColors2["YELLOW_ELEVATION_STATUS_5_BACKGROUND"] = "yellowElevation.status5Background";
  EDionColors2["YELLOW_ELEVATION_STATUS_5_CONTENT"] = "yellowElevation.status5Content";
  EDionColors2["YELLOW_ELEVATION_STATUS_4_CONTRAST"] = "yellowElevation.status4Contrast";
  EDionColors2["YELLOW_ELEVATION_STATUS_4_BACKGROUND"] = "yellowElevation.status4Background";
  EDionColors2["YELLOW_ELEVATION_STATUS_4_CONTENT"] = "yellowElevation.status4Content";
  EDionColors2["YELLOW_ELEVATION_STATUS_3_CONTRAST"] = "yellowElevation.status3Contrast";
  EDionColors2["YELLOW_ELEVATION_STATUS_3_BACKGROUND"] = "yellowElevation.status3Background";
  EDionColors2["YELLOW_ELEVATION_STATUS_3_CONTENT"] = "yellowElevation.status3Content";
  EDionColors2["YELLOW_ELEVATION_STATUS_2_CONTRAST"] = "yellowElevation.status2Contrast";
  EDionColors2["YELLOW_ELEVATION_STATUS_2_BACKGROUND"] = "yellowElevation.status2Background";
  EDionColors2["YELLOW_ELEVATION_STATUS_2_CONTENT"] = "yellowElevation.status2Content";
  EDionColors2["YELLOW_ELEVATION_STATUS_1_CONTRAST"] = "yellowElevation.status1Contrast";
  EDionColors2["YELLOW_ELEVATION_STATUS_1_BACKGROUND"] = "yellowElevation.status1Background";
  EDionColors2["YELLOW_ELEVATION_STATUS_1_CONTENT"] = "yellowElevation.status1Content";
  EDionColors2["YELLOW_ELEVATION_INFO_CONTRAST"] = "yellowElevation.infoContrast";
  EDionColors2["YELLOW_ELEVATION_INFO_BACKGROUND"] = "yellowElevation.infoBackground";
  EDionColors2["YELLOW_ELEVATION_INFO_CONTENT"] = "yellowElevation.infoContent";
  EDionColors2["YELLOW_ELEVATION_WARNING_CONTRAST"] = "yellowElevation.warningContrast";
  EDionColors2["YELLOW_ELEVATION_WARNING_BACKGROUND"] = "yellowElevation.warningBackground";
  EDionColors2["YELLOW_ELEVATION_WARNING_CONTENT"] = "yellowElevation.warningContent";
  EDionColors2["YELLOW_ELEVATION_SUCCESS_CONTRAST"] = "yellowElevation.successContrast";
  EDionColors2["YELLOW_ELEVATION_SUCCESS_BACKGROUND"] = "yellowElevation.successBackground";
  EDionColors2["YELLOW_ELEVATION_SUCCESS_CONTENT"] = "yellowElevation.successContent";
  EDionColors2["YELLOW_ELEVATION_ERROR_CONTRAST"] = "yellowElevation.errorContrast";
  EDionColors2["YELLOW_ELEVATION_ERROR_BACKGROUND"] = "yellowElevation.errorBackground";
  EDionColors2["YELLOW_ELEVATION_ERROR_CONTENT"] = "yellowElevation.errorContent";
  EDionColors2["YELLOW_ELEVATION_BRAND_CONTRAST"] = "yellowElevation.brandContrast";
  EDionColors2["YELLOW_ELEVATION_BRAND_BACKGROUND"] = "yellowElevation.brandBackground";
  EDionColors2["YELLOW_ELEVATION_BRAND_CONTENT"] = "yellowElevation.brandContent";
  EDionColors2["YELLOW_ELEVATION_DISABLE_TEXT"] = "yellowElevation.disableText";
  EDionColors2["YELLOW_ELEVATION_DISABLE"] = "yellowElevation.disable";
  EDionColors2["YELLOW_ELEVATION_TRANSPARENT"] = "yellowElevation.transparent";
  EDionColors2["YELLOW_ELEVATION_FOCUS"] = "yellowElevation.focus";
  EDionColors2["YELLOW_ELEVATION_PRESS"] = "yellowElevation.press";
  EDionColors2["YELLOW_ELEVATION_HOVER"] = "yellowElevation.hover";
  EDionColors2["YELLOW_ELEVATION_LOW_ACCENT"] = "yellowElevation.lowAccent";
  EDionColors2["YELLOW_ELEVATION_ACCENT"] = "yellowElevation.accent";
  EDionColors2["YELLOW_ELEVATION_ADDITIONAL"] = "yellowElevation.additional";
  EDionColors2["YELLOW_ELEVATION_LOW_CONTRAST"] = "yellowElevation.lowContrast";
  EDionColors2["YELLOW_ELEVATION_CONTRAST"] = "yellowElevation.contrast";
  EDionColors2["YELLOW_ELEVATION_MAIN"] = "yellowElevation.main";
  EDionColors2["ORANGE_ELEVATION_STATUS_5_CONTRAST"] = "orangeElevation.status5Contrast";
  EDionColors2["ORANGE_ELEVATION_STATUS_5_BACKGROUND"] = "orangeElevation.status5Background";
  EDionColors2["ORANGE_ELEVATION_STATUS_5_CONTENT"] = "orangeElevation.status5Content";
  EDionColors2["ORANGE_ELEVATION_STATUS_4_CONTRAST"] = "orangeElevation.status4Contrast";
  EDionColors2["ORANGE_ELEVATION_STATUS_4_BACKGROUND"] = "orangeElevation.status4Background";
  EDionColors2["ORANGE_ELEVATION_STATUS_4_CONTENT"] = "orangeElevation.status4Content";
  EDionColors2["ORANGE_ELEVATION_STATUS_3_CONTRAST"] = "orangeElevation.status3Contrast";
  EDionColors2["ORANGE_ELEVATION_STATUS_3_BACKGROUND"] = "orangeElevation.status3Background";
  EDionColors2["ORANGE_ELEVATION_STATUS_3_CONTENT"] = "orangeElevation.status3Content";
  EDionColors2["ORANGE_ELEVATION_STATUS_2_CONTRAST"] = "orangeElevation.status2Contrast";
  EDionColors2["ORANGE_ELEVATION_STATUS_2_BACKGROUND"] = "orangeElevation.status2Background";
  EDionColors2["ORANGE_ELEVATION_STATUS_2_CONTENT"] = "orangeElevation.status2Content";
  EDionColors2["ORANGE_ELEVATION_STATUS_1_CONTRAST"] = "orangeElevation.status1Contrast";
  EDionColors2["ORANGE_ELEVATION_STATUS_1_BACKGROUND"] = "orangeElevation.status1Background";
  EDionColors2["ORANGE_ELEVATION_STATUS_1_CONTENT"] = "orangeElevation.status1Content";
  EDionColors2["ORANGE_ELEVATION_INFO_CONTRAST"] = "orangeElevation.infoContrast";
  EDionColors2["ORANGE_ELEVATION_INFO_BACKGROUND"] = "orangeElevation.infoBackground";
  EDionColors2["ORANGE_ELEVATION_INFO_CONTENT"] = "orangeElevation.infoContent";
  EDionColors2["ORANGE_ELEVATION_WARNING_CONTRAST"] = "orangeElevation.warningContrast";
  EDionColors2["ORANGE_ELEVATION_WARNING_BACKGROUND"] = "orangeElevation.warningBackground";
  EDionColors2["ORANGE_ELEVATION_WARNING_CONTENT"] = "orangeElevation.warningContent";
  EDionColors2["ORANGE_ELEVATION_SUCCESS_CONTRAST"] = "orangeElevation.successContrast";
  EDionColors2["ORANGE_ELEVATION_SUCCESS_BACKGROUND"] = "orangeElevation.successBackground";
  EDionColors2["ORANGE_ELEVATION_SUCCESS_CONTENT"] = "orangeElevation.successContent";
  EDionColors2["ORANGE_ELEVATION_ERROR_CONTRAST"] = "orangeElevation.errorContrast";
  EDionColors2["ORANGE_ELEVATION_ERROR_BACKGROUND"] = "orangeElevation.errorBackground";
  EDionColors2["ORANGE_ELEVATION_ERROR_CONTENT"] = "orangeElevation.errorContent";
  EDionColors2["ORANGE_ELEVATION_BRAND_CONTRAST"] = "orangeElevation.brandContrast";
  EDionColors2["ORANGE_ELEVATION_BRAND_BACKGROUND"] = "orangeElevation.brandBackground";
  EDionColors2["ORANGE_ELEVATION_BRAND_CONTENT"] = "orangeElevation.brandContent";
  EDionColors2["ORANGE_ELEVATION_DISABLE_TEXT"] = "orangeElevation.disableText";
  EDionColors2["ORANGE_ELEVATION_DISABLE"] = "orangeElevation.disable";
  EDionColors2["ORANGE_ELEVATION_TRANSPARENT"] = "orangeElevation.transparent";
  EDionColors2["ORANGE_ELEVATION_FOCUS"] = "orangeElevation.focus";
  EDionColors2["ORANGE_ELEVATION_PRESS"] = "orangeElevation.press";
  EDionColors2["ORANGE_ELEVATION_HOVER"] = "orangeElevation.hover";
  EDionColors2["ORANGE_ELEVATION_LOW_ACCENT"] = "orangeElevation.lowAccent";
  EDionColors2["ORANGE_ELEVATION_ACCENT"] = "orangeElevation.accent";
  EDionColors2["ORANGE_ELEVATION_ADDITIONAL"] = "orangeElevation.additional";
  EDionColors2["ORANGE_ELEVATION_LOW_CONTRAST"] = "orangeElevation.lowContrast";
  EDionColors2["ORANGE_ELEVATION_CONTRAST"] = "orangeElevation.contrast";
  EDionColors2["ORANGE_ELEVATION_MAIN"] = "orangeElevation.main";
  EDionColors2["ROSE_ELEVATION_STATUS_5_CONTRAST"] = "roseElevation.status5Contrast";
  EDionColors2["ROSE_ELEVATION_STATUS_5_BACKGROUND"] = "roseElevation.status5Background";
  EDionColors2["ROSE_ELEVATION_STATUS_5_CONTENT"] = "roseElevation.status5Content";
  EDionColors2["ROSE_ELEVATION_STATUS_4_CONTRAST"] = "roseElevation.status4Contrast";
  EDionColors2["ROSE_ELEVATION_STATUS_4_BACKGROUND"] = "roseElevation.status4Background";
  EDionColors2["ROSE_ELEVATION_STATUS_4_CONTENT"] = "roseElevation.status4Content";
  EDionColors2["ROSE_ELEVATION_STATUS_3_CONTRAST"] = "roseElevation.status3Contrast";
  EDionColors2["ROSE_ELEVATION_STATUS_3_BACKGROUND"] = "roseElevation.status3Background";
  EDionColors2["ROSE_ELEVATION_STATUS_3_CONTENT"] = "roseElevation.status3Content";
  EDionColors2["ROSE_ELEVATION_STATUS_2_CONTRAST"] = "roseElevation.status2Contrast";
  EDionColors2["ROSE_ELEVATION_STATUS_2_BACKGROUND"] = "roseElevation.status2Background";
  EDionColors2["ROSE_ELEVATION_STATUS_2_CONTENT"] = "roseElevation.status2Content";
  EDionColors2["ROSE_ELEVATION_STATUS_1_CONTRAST"] = "roseElevation.status1Contrast";
  EDionColors2["ROSE_ELEVATION_STATUS_1_BACKGROUND"] = "roseElevation.status1Background";
  EDionColors2["ROSE_ELEVATION_STATUS_1_CONTENT"] = "roseElevation.status1Content";
  EDionColors2["ROSE_ELEVATION_INFO_CONTRAST"] = "roseElevation.infoContrast";
  EDionColors2["ROSE_ELEVATION_INFO_BACKGROUND"] = "roseElevation.infoBackground";
  EDionColors2["ROSE_ELEVATION_INFO_CONTENT"] = "roseElevation.infoContent";
  EDionColors2["ROSE_ELEVATION_WARNING_CONTRAST"] = "roseElevation.warningContrast";
  EDionColors2["ROSE_ELEVATION_WARNING_BACKGROUND"] = "roseElevation.warningBackground";
  EDionColors2["ROSE_ELEVATION_WARNING_CONTENT"] = "roseElevation.warningContent";
  EDionColors2["ROSE_ELEVATION_SUCCESS_CONTRAST"] = "roseElevation.successContrast";
  EDionColors2["ROSE_ELEVATION_SUCCESS_BACKGROUND"] = "roseElevation.successBackground";
  EDionColors2["ROSE_ELEVATION_SUCCESS_CONTENT"] = "roseElevation.successContent";
  EDionColors2["ROSE_ELEVATION_ERROR_CONTRAST"] = "roseElevation.errorContrast";
  EDionColors2["ROSE_ELEVATION_ERROR_BACKGROUND"] = "roseElevation.errorBackground";
  EDionColors2["ROSE_ELEVATION_ERROR_CONTENT"] = "roseElevation.errorContent";
  EDionColors2["ROSE_ELEVATION_BRAND_CONTRAST"] = "roseElevation.brandContrast";
  EDionColors2["ROSE_ELEVATION_BRAND_BACKGROUND"] = "roseElevation.brandBackground";
  EDionColors2["ROSE_ELEVATION_BRAND_CONTENT"] = "roseElevation.brandContent";
  EDionColors2["ROSE_ELEVATION_DISABLE_TEXT"] = "roseElevation.disableText";
  EDionColors2["ROSE_ELEVATION_DISABLE"] = "roseElevation.disable";
  EDionColors2["ROSE_ELEVATION_TRANSPARENT"] = "roseElevation.transparent";
  EDionColors2["ROSE_ELEVATION_FOCUS"] = "roseElevation.focus";
  EDionColors2["ROSE_ELEVATION_PRESS"] = "roseElevation.press";
  EDionColors2["ROSE_ELEVATION_HOVER"] = "roseElevation.hover";
  EDionColors2["ROSE_ELEVATION_LOW_ACCENT"] = "roseElevation.lowAccent";
  EDionColors2["ROSE_ELEVATION_ACCENT"] = "roseElevation.accent";
  EDionColors2["ROSE_ELEVATION_ADDITIONAL"] = "roseElevation.additional";
  EDionColors2["ROSE_ELEVATION_LOW_CONTRAST"] = "roseElevation.lowContrast";
  EDionColors2["ROSE_ELEVATION_CONTRAST"] = "roseElevation.contrast";
  EDionColors2["ROSE_ELEVATION_MAIN"] = "roseElevation.main";
  EDionColors2["GRAY_ELEVATION_STATUS_5_CONTRAST"] = "grayElevation.status5Contrast";
  EDionColors2["GRAY_ELEVATION_STATUS_5_BACKGROUND"] = "grayElevation.status5Background";
  EDionColors2["GRAY_ELEVATION_STATUS_5_CONTENT"] = "grayElevation.status5Content";
  EDionColors2["GRAY_ELEVATION_STATUS_4_CONTRAST"] = "grayElevation.status4Contrast";
  EDionColors2["GRAY_ELEVATION_STATUS_4_BACKGROUND"] = "grayElevation.status4Background";
  EDionColors2["GRAY_ELEVATION_STATUS_4_CONTENT"] = "grayElevation.status4Content";
  EDionColors2["GRAY_ELEVATION_STATUS_3_CONTRAST"] = "grayElevation.status3Contrast";
  EDionColors2["GRAY_ELEVATION_STATUS_3_BACKGROUND"] = "grayElevation.status3Background";
  EDionColors2["GRAY_ELEVATION_STATUS_3_CONTENT"] = "grayElevation.status3Content";
  EDionColors2["GRAY_ELEVATION_STATUS_2_CONTRAST"] = "grayElevation.status2Contrast";
  EDionColors2["GRAY_ELEVATION_STATUS_2_BACKGROUND"] = "grayElevation.status2Background";
  EDionColors2["GRAY_ELEVATION_STATUS_2_CONTENT"] = "grayElevation.status2Content";
  EDionColors2["GRAY_ELEVATION_STATUS_1_CONTRAST"] = "grayElevation.status1Contrast";
  EDionColors2["GRAY_ELEVATION_STATUS_1_BACKGROUND"] = "grayElevation.status1Background";
  EDionColors2["GRAY_ELEVATION_STATUS_1_CONTENT"] = "grayElevation.status1Content";
  EDionColors2["GRAY_ELEVATION_INFO_CONTRAST"] = "grayElevation.infoContrast";
  EDionColors2["GRAY_ELEVATION_INFO_BACKGROUND"] = "grayElevation.infoBackground";
  EDionColors2["GRAY_ELEVATION_INFO_CONTENT"] = "grayElevation.infoContent";
  EDionColors2["GRAY_ELEVATION_WARNING_CONTRAST"] = "grayElevation.warningContrast";
  EDionColors2["GRAY_ELEVATION_WARNING_BACKGROUND"] = "grayElevation.warningBackground";
  EDionColors2["GRAY_ELEVATION_WARNING_CONTENT"] = "grayElevation.warningContent";
  EDionColors2["GRAY_ELEVATION_SUCCESS_CONTRAST"] = "grayElevation.successContrast";
  EDionColors2["GRAY_ELEVATION_SUCCESS_BACKGROUND"] = "grayElevation.successBackground";
  EDionColors2["GRAY_ELEVATION_SUCCESS_CONTENT"] = "grayElevation.successContent";
  EDionColors2["GRAY_ELEVATION_ERROR_CONTRAST"] = "grayElevation.errorContrast";
  EDionColors2["GRAY_ELEVATION_ERROR_BACKGROUND"] = "grayElevation.errorBackground";
  EDionColors2["GRAY_ELEVATION_ERROR_CONTENT"] = "grayElevation.errorContent";
  EDionColors2["GRAY_ELEVATION_BRAND_CONTRAST"] = "grayElevation.brandContrast";
  EDionColors2["GRAY_ELEVATION_BRAND_BACKGROUND"] = "grayElevation.brandBackground";
  EDionColors2["GRAY_ELEVATION_BRAND_CONTENT"] = "grayElevation.brandContent";
  EDionColors2["GRAY_ELEVATION_DISABLE_TEXT"] = "grayElevation.disableText";
  EDionColors2["GRAY_ELEVATION_DISABLE"] = "grayElevation.disable";
  EDionColors2["GRAY_ELEVATION_TRANSPARENT"] = "grayElevation.transparent";
  EDionColors2["GRAY_ELEVATION_FOCUS"] = "grayElevation.focus";
  EDionColors2["GRAY_ELEVATION_PRESS"] = "grayElevation.press";
  EDionColors2["GRAY_ELEVATION_HOVER"] = "grayElevation.hover";
  EDionColors2["GRAY_ELEVATION_LOW_ACCENT"] = "grayElevation.lowAccent";
  EDionColors2["GRAY_ELEVATION_ACCENT"] = "grayElevation.accent";
  EDionColors2["GRAY_ELEVATION_ADDITIONAL"] = "grayElevation.additional";
  EDionColors2["GRAY_ELEVATION_LOW_CONTRAST"] = "grayElevation.lowContrast";
  EDionColors2["GRAY_ELEVATION_CONTRAST"] = "grayElevation.contrast";
  EDionColors2["GRAY_ELEVATION_MAIN"] = "grayElevation.main";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_5_CONTRAST"] = "fuchsiaElevation.status5Contrast";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_5_BACKGROUND"] = "fuchsiaElevation.status5Background";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_5_CONTENT"] = "fuchsiaElevation.status5Content";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_4_CONTRAST"] = "fuchsiaElevation.status4Contrast";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_4_BACKGROUND"] = "fuchsiaElevation.status4Background";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_4_CONTENT"] = "fuchsiaElevation.status4Content";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_3_CONTRAST"] = "fuchsiaElevation.status3Contrast";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_3_BACKGROUND"] = "fuchsiaElevation.status3Background";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_3_CONTENT"] = "fuchsiaElevation.status3Content";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_2_CONTRAST"] = "fuchsiaElevation.status2Contrast";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_2_BACKGROUND"] = "fuchsiaElevation.status2Background";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_2_CONTENT"] = "fuchsiaElevation.status2Content";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_1_CONTRAST"] = "fuchsiaElevation.status1Contrast";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_1_BACKGROUND"] = "fuchsiaElevation.status1Background";
  EDionColors2["FUCHSIA_ELEVATION_STATUS_1_CONTENT"] = "fuchsiaElevation.status1Content";
  EDionColors2["FUCHSIA_ELEVATION_INFO_CONTRAST"] = "fuchsiaElevation.infoContrast";
  EDionColors2["FUCHSIA_ELEVATION_INFO_BACKGROUND"] = "fuchsiaElevation.infoBackground";
  EDionColors2["FUCHSIA_ELEVATION_INFO_CONTENT"] = "fuchsiaElevation.infoContent";
  EDionColors2["FUCHSIA_ELEVATION_WARNING_CONTRAST"] = "fuchsiaElevation.warningContrast";
  EDionColors2["FUCHSIA_ELEVATION_WARNING_BACKGROUND"] = "fuchsiaElevation.warningBackground";
  EDionColors2["FUCHSIA_ELEVATION_WARNING_CONTENT"] = "fuchsiaElevation.warningContent";
  EDionColors2["FUCHSIA_ELEVATION_SUCCESS_CONTRAST"] = "fuchsiaElevation.successContrast";
  EDionColors2["FUCHSIA_ELEVATION_SUCCESS_BACKGROUND"] = "fuchsiaElevation.successBackground";
  EDionColors2["FUCHSIA_ELEVATION_SUCCESS_CONTENT"] = "fuchsiaElevation.successContent";
  EDionColors2["FUCHSIA_ELEVATION_ERROR_CONTRAST"] = "fuchsiaElevation.errorContrast";
  EDionColors2["FUCHSIA_ELEVATION_ERROR_BACKGROUND"] = "fuchsiaElevation.errorBackground";
  EDionColors2["FUCHSIA_ELEVATION_ERROR_CONTENT"] = "fuchsiaElevation.errorContent";
  EDionColors2["FUCHSIA_ELEVATION_BRAND_CONTRAST"] = "fuchsiaElevation.brandContrast";
  EDionColors2["FUCHSIA_ELEVATION_BRAND_BACKGROUND"] = "fuchsiaElevation.brandBackground";
  EDionColors2["FUCHSIA_ELEVATION_BRAND_CONTENT"] = "fuchsiaElevation.brandContent";
  EDionColors2["FUCHSIA_ELEVATION_DISABLE_TEXT"] = "fuchsiaElevation.disableText";
  EDionColors2["FUCHSIA_ELEVATION_DISABLE"] = "fuchsiaElevation.disable";
  EDionColors2["FUCHSIA_ELEVATION_TRANSPARENT"] = "fuchsiaElevation.transparent";
  EDionColors2["FUCHSIA_ELEVATION_FOCUS"] = "fuchsiaElevation.focus";
  EDionColors2["FUCHSIA_ELEVATION_PRESS"] = "fuchsiaElevation.press";
  EDionColors2["FUCHSIA_ELEVATION_HOVER"] = "fuchsiaElevation.hover";
  EDionColors2["FUCHSIA_ELEVATION_LOW_ACCENT"] = "fuchsiaElevation.lowAccent";
  EDionColors2["FUCHSIA_ELEVATION_ACCENT"] = "fuchsiaElevation.accent";
  EDionColors2["FUCHSIA_ELEVATION_ADDITIONAL"] = "fuchsiaElevation.additional";
  EDionColors2["FUCHSIA_ELEVATION_LOW_CONTRAST"] = "fuchsiaElevation.lowContrast";
  EDionColors2["FUCHSIA_ELEVATION_CONTRAST"] = "fuchsiaElevation.contrast";
  EDionColors2["FUCHSIA_ELEVATION_MAIN"] = "fuchsiaElevation.main";
  EDionColors2["VIOLET_ELEVATION_STATUS_5_CONTRAST"] = "violetElevation.status5Contrast";
  EDionColors2["VIOLET_ELEVATION_STATUS_5_BACKGROUND"] = "violetElevation.status5Background";
  EDionColors2["VIOLET_ELEVATION_STATUS_5_CONTENT"] = "violetElevation.status5Content";
  EDionColors2["VIOLET_ELEVATION_STATUS_4_CONTRAST"] = "violetElevation.status4Contrast";
  EDionColors2["VIOLET_ELEVATION_STATUS_4_BACKGROUND"] = "violetElevation.status4Background";
  EDionColors2["VIOLET_ELEVATION_STATUS_4_CONTENT"] = "violetElevation.status4Content";
  EDionColors2["VIOLET_ELEVATION_STATUS_3_CONTRAST"] = "violetElevation.status3Contrast";
  EDionColors2["VIOLET_ELEVATION_STATUS_3_BACKGROUND"] = "violetElevation.status3Background";
  EDionColors2["VIOLET_ELEVATION_STATUS_3_CONTENT"] = "violetElevation.status3Content";
  EDionColors2["VIOLET_ELEVATION_STATUS_2_CONTRAST"] = "violetElevation.status2Contrast";
  EDionColors2["VIOLET_ELEVATION_STATUS_2_BACKGROUND"] = "violetElevation.status2Background";
  EDionColors2["VIOLET_ELEVATION_STATUS_2_CONTENT"] = "violetElevation.status2Content";
  EDionColors2["VIOLET_ELEVATION_STATUS_1_CONTRAST"] = "violetElevation.status1Contrast";
  EDionColors2["VIOLET_ELEVATION_STATUS_1_BACKGROUND"] = "violetElevation.status1Background";
  EDionColors2["VIOLET_ELEVATION_STATUS_1_CONTENT"] = "violetElevation.status1Content";
  EDionColors2["VIOLET_ELEVATION_INFO_CONTRAST"] = "violetElevation.infoContrast";
  EDionColors2["VIOLET_ELEVATION_INFO_BACKGROUND"] = "violetElevation.infoBackground";
  EDionColors2["VIOLET_ELEVATION_INFO_CONTENT"] = "violetElevation.infoContent";
  EDionColors2["VIOLET_ELEVATION_WARNING_CONTRAST"] = "violetElevation.warningContrast";
  EDionColors2["VIOLET_ELEVATION_WARNING_BACKGROUND"] = "violetElevation.warningBackground";
  EDionColors2["VIOLET_ELEVATION_WARNING_CONTENT"] = "violetElevation.warningContent";
  EDionColors2["VIOLET_ELEVATION_SUCCESS_CONTRAST"] = "violetElevation.successContrast";
  EDionColors2["VIOLET_ELEVATION_SUCCESS_BACKGROUND"] = "violetElevation.successBackground";
  EDionColors2["VIOLET_ELEVATION_SUCCESS_CONTENT"] = "violetElevation.successContent";
  EDionColors2["VIOLET_ELEVATION_ERROR_CONTRAST"] = "violetElevation.errorContrast";
  EDionColors2["VIOLET_ELEVATION_ERROR_BACKGROUND"] = "violetElevation.errorBackground";
  EDionColors2["VIOLET_ELEVATION_ERROR_CONTENT"] = "violetElevation.errorContent";
  EDionColors2["VIOLET_ELEVATION_BRAND_CONTRAST"] = "violetElevation.brandContrast";
  EDionColors2["VIOLET_ELEVATION_BRAND_BACKGROUND"] = "violetElevation.brandBackground";
  EDionColors2["VIOLET_ELEVATION_BRAND_CONTENT"] = "violetElevation.brandContent";
  EDionColors2["VIOLET_ELEVATION_DISABLE_TEXT"] = "violetElevation.disableText";
  EDionColors2["VIOLET_ELEVATION_DISABLE"] = "violetElevation.disable";
  EDionColors2["VIOLET_ELEVATION_TRANSPARENT"] = "violetElevation.transparent";
  EDionColors2["VIOLET_ELEVATION_FOCUS"] = "violetElevation.focus";
  EDionColors2["VIOLET_ELEVATION_PRESS"] = "violetElevation.press";
  EDionColors2["VIOLET_ELEVATION_HOVER"] = "violetElevation.hover";
  EDionColors2["VIOLET_ELEVATION_LOW_ACCENT"] = "violetElevation.lowAccent";
  EDionColors2["VIOLET_ELEVATION_ACCENT"] = "violetElevation.accent";
  EDionColors2["VIOLET_ELEVATION_ADDITIONAL"] = "violetElevation.additional";
  EDionColors2["VIOLET_ELEVATION_LOW_CONTRAST"] = "violetElevation.lowContrast";
  EDionColors2["VIOLET_ELEVATION_CONTRAST"] = "violetElevation.contrast";
  EDionColors2["VIOLET_ELEVATION_MAIN"] = "violetElevation.main";
  EDionColors2["SKY_ELEVATION_STATUS_5_CONTRAST"] = "skyElevation.status5Contrast";
  EDionColors2["SKY_ELEVATION_STATUS_5_BACKGROUND"] = "skyElevation.status5Background";
  EDionColors2["SKY_ELEVATION_STATUS_5_CONTENT"] = "skyElevation.status5Content";
  EDionColors2["SKY_ELEVATION_STATUS_4_CONTRAST"] = "skyElevation.status4Contrast";
  EDionColors2["SKY_ELEVATION_STATUS_4_BACKGROUND"] = "skyElevation.status4Background";
  EDionColors2["SKY_ELEVATION_STATUS_4_CONTENT"] = "skyElevation.status4Content";
  EDionColors2["SKY_ELEVATION_STATUS_3_CONTRAST"] = "skyElevation.status3Contrast";
  EDionColors2["SKY_ELEVATION_STATUS_3_BACKGROUND"] = "skyElevation.status3Background";
  EDionColors2["SKY_ELEVATION_STATUS_3_CONTENT"] = "skyElevation.status3Content";
  EDionColors2["SKY_ELEVATION_STATUS_2_CONTRAST"] = "skyElevation.status2Contrast";
  EDionColors2["SKY_ELEVATION_STATUS_2_BACKGROUND"] = "skyElevation.status2Background";
  EDionColors2["SKY_ELEVATION_STATUS_2_CONTENT"] = "skyElevation.status2Content";
  EDionColors2["SKY_ELEVATION_STATUS_1_CONTRAST"] = "skyElevation.status1Contrast";
  EDionColors2["SKY_ELEVATION_STATUS_1_BACKGROUND"] = "skyElevation.status1Background";
  EDionColors2["SKY_ELEVATION_STATUS_1_CONTENT"] = "skyElevation.status1Content";
  EDionColors2["SKY_ELEVATION_INFO_CONTRAST"] = "skyElevation.infoContrast";
  EDionColors2["SKY_ELEVATION_INFO_BACKGROUND"] = "skyElevation.infoBackground";
  EDionColors2["SKY_ELEVATION_INFO_CONTENT"] = "skyElevation.infoContent";
  EDionColors2["SKY_ELEVATION_WARNING_CONTRAST"] = "skyElevation.warningContrast";
  EDionColors2["SKY_ELEVATION_WARNING_BACKGROUND"] = "skyElevation.warningBackground";
  EDionColors2["SKY_ELEVATION_WARNING_CONTENT"] = "skyElevation.warningContent";
  EDionColors2["SKY_ELEVATION_SUCCESS_CONTRAST"] = "skyElevation.successContrast";
  EDionColors2["SKY_ELEVATION_SUCCESS_BACKGROUND"] = "skyElevation.successBackground";
  EDionColors2["SKY_ELEVATION_SUCCESS_CONTENT"] = "skyElevation.successContent";
  EDionColors2["SKY_ELEVATION_ERROR_CONTRAST"] = "skyElevation.errorContrast";
  EDionColors2["SKY_ELEVATION_ERROR_BACKGROUND"] = "skyElevation.errorBackground";
  EDionColors2["SKY_ELEVATION_ERROR_CONTENT"] = "skyElevation.errorContent";
  EDionColors2["SKY_ELEVATION_BRAND_CONTRAST"] = "skyElevation.brandContrast";
  EDionColors2["SKY_ELEVATION_BRAND_BACKGROUND"] = "skyElevation.brandBackground";
  EDionColors2["SKY_ELEVATION_BRAND_CONTENT"] = "skyElevation.brandContent";
  EDionColors2["SKY_ELEVATION_DISABLE_TEXT"] = "skyElevation.disableText";
  EDionColors2["SKY_ELEVATION_DISABLE"] = "skyElevation.disable";
  EDionColors2["SKY_ELEVATION_TRANSPARENT"] = "skyElevation.transparent";
  EDionColors2["SKY_ELEVATION_FOCUS"] = "skyElevation.focus";
  EDionColors2["SKY_ELEVATION_PRESS"] = "skyElevation.press";
  EDionColors2["SKY_ELEVATION_HOVER"] = "skyElevation.hover";
  EDionColors2["SKY_ELEVATION_LOW_ACCENT"] = "skyElevation.lowAccent";
  EDionColors2["SKY_ELEVATION_ACCENT"] = "skyElevation.accent";
  EDionColors2["SKY_ELEVATION_ADDITIONAL"] = "skyElevation.additional";
  EDionColors2["SKY_ELEVATION_LOW_CONTRAST"] = "skyElevation.lowContrast";
  EDionColors2["SKY_ELEVATION_CONTRAST"] = "skyElevation.contrast";
  EDionColors2["SKY_ELEVATION_MAIN"] = "skyElevation.main";
  EDionColors2["CYAN_ELEVATION_STATUS_5_CONTRAST"] = "cyanElevation.status5Contrast";
  EDionColors2["CYAN_ELEVATION_STATUS_5_BACKGROUND"] = "cyanElevation.status5Background";
  EDionColors2["CYAN_ELEVATION_STATUS_5_CONTENT"] = "cyanElevation.status5Content";
  EDionColors2["CYAN_ELEVATION_STATUS_4_CONTRAST"] = "cyanElevation.status4Contrast";
  EDionColors2["CYAN_ELEVATION_STATUS_4_BACKGROUND"] = "cyanElevation.status4Background";
  EDionColors2["CYAN_ELEVATION_STATUS_4_CONTENT"] = "cyanElevation.status4Content";
  EDionColors2["CYAN_ELEVATION_STATUS_3_CONTRAST"] = "cyanElevation.status3Contrast";
  EDionColors2["CYAN_ELEVATION_STATUS_3_BACKGROUND"] = "cyanElevation.status3Background";
  EDionColors2["CYAN_ELEVATION_STATUS_3_CONTENT"] = "cyanElevation.status3Content";
  EDionColors2["CYAN_ELEVATION_STATUS_2_CONTRAST"] = "cyanElevation.status2Contrast";
  EDionColors2["CYAN_ELEVATION_STATUS_2_BACKGROUND"] = "cyanElevation.status2Background";
  EDionColors2["CYAN_ELEVATION_STATUS_2_CONTENT"] = "cyanElevation.status2Content";
  EDionColors2["CYAN_ELEVATION_STATUS_1_CONTRAST"] = "cyanElevation.status1Contrast";
  EDionColors2["CYAN_ELEVATION_STATUS_1_BACKGROUND"] = "cyanElevation.status1Background";
  EDionColors2["CYAN_ELEVATION_STATUS_1_CONTENT"] = "cyanElevation.status1Content";
  EDionColors2["CYAN_ELEVATION_INFO_CONTRAST"] = "cyanElevation.infoContrast";
  EDionColors2["CYAN_ELEVATION_INFO_BACKGROUND"] = "cyanElevation.infoBackground";
  EDionColors2["CYAN_ELEVATION_INFO_CONTENT"] = "cyanElevation.infoContent";
  EDionColors2["CYAN_ELEVATION_WARNING_CONTRAST"] = "cyanElevation.warningContrast";
  EDionColors2["CYAN_ELEVATION_WARNING_BACKGROUND"] = "cyanElevation.warningBackground";
  EDionColors2["CYAN_ELEVATION_WARNING_CONTENT"] = "cyanElevation.warningContent";
  EDionColors2["CYAN_ELEVATION_SUCCESS_CONTRAST"] = "cyanElevation.successContrast";
  EDionColors2["CYAN_ELEVATION_SUCCESS_BACKGROUND"] = "cyanElevation.successBackground";
  EDionColors2["CYAN_ELEVATION_SUCCESS_CONTENT"] = "cyanElevation.successContent";
  EDionColors2["CYAN_ELEVATION_ERROR_CONTRAST"] = "cyanElevation.errorContrast";
  EDionColors2["CYAN_ELEVATION_ERROR_BACKGROUND"] = "cyanElevation.errorBackground";
  EDionColors2["CYAN_ELEVATION_ERROR_CONTENT"] = "cyanElevation.errorContent";
  EDionColors2["CYAN_ELEVATION_BRAND_CONTRAST"] = "cyanElevation.brandContrast";
  EDionColors2["CYAN_ELEVATION_BRAND_BACKGROUND"] = "cyanElevation.brandBackground";
  EDionColors2["CYAN_ELEVATION_BRAND_CONTENT"] = "cyanElevation.brandContent";
  EDionColors2["CYAN_ELEVATION_DISABLE_TEXT"] = "cyanElevation.disableText";
  EDionColors2["CYAN_ELEVATION_DISABLE"] = "cyanElevation.disable";
  EDionColors2["CYAN_ELEVATION_TRANSPARENT"] = "cyanElevation.transparent";
  EDionColors2["CYAN_ELEVATION_FOCUS"] = "cyanElevation.focus";
  EDionColors2["CYAN_ELEVATION_PRESS"] = "cyanElevation.press";
  EDionColors2["CYAN_ELEVATION_HOVER"] = "cyanElevation.hover";
  EDionColors2["CYAN_ELEVATION_LOW_ACCENT"] = "cyanElevation.lowAccent";
  EDionColors2["CYAN_ELEVATION_ACCENT"] = "cyanElevation.accent";
  EDionColors2["CYAN_ELEVATION_ADDITIONAL"] = "cyanElevation.additional";
  EDionColors2["CYAN_ELEVATION_LOW_CONTRAST"] = "cyanElevation.lowContrast";
  EDionColors2["CYAN_ELEVATION_CONTRAST"] = "cyanElevation.contrast";
  EDionColors2["CYAN_ELEVATION_MAIN"] = "cyanElevation.main";
  EDionColors2["GREEN_ELEVATION_STATUS_5_CONTRAST"] = "greenElevation.status5Contrast";
  EDionColors2["GREEN_ELEVATION_STATUS_5_BACKGROUND"] = "greenElevation.status5Background";
  EDionColors2["GREEN_ELEVATION_STATUS_5_CONTENT"] = "greenElevation.status5Content";
  EDionColors2["GREEN_ELEVATION_STATUS_4_CONTRAST"] = "greenElevation.status4Contrast";
  EDionColors2["GREEN_ELEVATION_STATUS_4_BACKGROUND"] = "greenElevation.status4Background";
  EDionColors2["GREEN_ELEVATION_STATUS_4_CONTENT"] = "greenElevation.status4Content";
  EDionColors2["GREEN_ELEVATION_STATUS_3_CONTRAST"] = "greenElevation.status3Contrast";
  EDionColors2["GREEN_ELEVATION_STATUS_3_BACKGROUND"] = "greenElevation.status3Background";
  EDionColors2["GREEN_ELEVATION_STATUS_3_CONTENT"] = "greenElevation.status3Content";
  EDionColors2["GREEN_ELEVATION_STATUS_2_CONTRAST"] = "greenElevation.status2Contrast";
  EDionColors2["GREEN_ELEVATION_STATUS_2_BACKGROUND"] = "greenElevation.status2Background";
  EDionColors2["GREEN_ELEVATION_STATUS_2_CONTENT"] = "greenElevation.status2Content";
  EDionColors2["GREEN_ELEVATION_STATUS_1_CONTRAST"] = "greenElevation.status1Contrast";
  EDionColors2["GREEN_ELEVATION_STATUS_1_BACKGROUND"] = "greenElevation.status1Background";
  EDionColors2["GREEN_ELEVATION_STATUS_1_CONTENT"] = "greenElevation.status1Content";
  EDionColors2["GREEN_ELEVATION_INFO_CONTRAST"] = "greenElevation.infoContrast";
  EDionColors2["GREEN_ELEVATION_INFO_BACKGROUND"] = "greenElevation.infoBackground";
  EDionColors2["GREEN_ELEVATION_INFO_CONTENT"] = "greenElevation.infoContent";
  EDionColors2["GREEN_ELEVATION_WARNING_CONTRAST"] = "greenElevation.warningContrast";
  EDionColors2["GREEN_ELEVATION_WARNING_BACKGROUND"] = "greenElevation.warningBackground";
  EDionColors2["GREEN_ELEVATION_WARNING_CONTENT"] = "greenElevation.warningContent";
  EDionColors2["GREEN_ELEVATION_SUCCESS_CONTRAST"] = "greenElevation.successContrast";
  EDionColors2["GREEN_ELEVATION_SUCCESS_BACKGROUND"] = "greenElevation.successBackground";
  EDionColors2["GREEN_ELEVATION_SUCCESS_CONTENT"] = "greenElevation.successContent";
  EDionColors2["GREEN_ELEVATION_ERROR_CONTRAST"] = "greenElevation.errorContrast";
  EDionColors2["GREEN_ELEVATION_ERROR_BACKGROUND"] = "greenElevation.errorBackground";
  EDionColors2["GREEN_ELEVATION_ERROR_CONTENT"] = "greenElevation.errorContent";
  EDionColors2["GREEN_ELEVATION_BRAND_CONTRAST"] = "greenElevation.brandContrast";
  EDionColors2["GREEN_ELEVATION_BRAND_BACKGROUND"] = "greenElevation.brandBackground";
  EDionColors2["GREEN_ELEVATION_BRAND_CONTENT"] = "greenElevation.brandContent";
  EDionColors2["GREEN_ELEVATION_DISABLE_TEXT"] = "greenElevation.disableText";
  EDionColors2["GREEN_ELEVATION_DISABLE"] = "greenElevation.disable";
  EDionColors2["GREEN_ELEVATION_TRANSPARENT"] = "greenElevation.transparent";
  EDionColors2["GREEN_ELEVATION_FOCUS"] = "greenElevation.focus";
  EDionColors2["GREEN_ELEVATION_PRESS"] = "greenElevation.press";
  EDionColors2["GREEN_ELEVATION_HOVER"] = "greenElevation.hover";
  EDionColors2["GREEN_ELEVATION_LOW_ACCENT"] = "greenElevation.lowAccent";
  EDionColors2["GREEN_ELEVATION_ACCENT"] = "greenElevation.accent";
  EDionColors2["GREEN_ELEVATION_ADDITIONAL"] = "greenElevation.additional";
  EDionColors2["GREEN_ELEVATION_LOW_CONTRAST"] = "greenElevation.lowContrast";
  EDionColors2["GREEN_ELEVATION_CONTRAST"] = "greenElevation.contrast";
  EDionColors2["GREEN_ELEVATION_MAIN"] = "greenElevation.main";
  EDionColors2["MOSS_ELEVATION_STATUS_5_CONTRAST"] = "mossElevation.status5Contrast";
  EDionColors2["MOSS_ELEVATION_STATUS_5_BACKGROUND"] = "mossElevation.status5Background";
  EDionColors2["MOSS_ELEVATION_STATUS_5_CONTENT"] = "mossElevation.status5Content";
  EDionColors2["MOSS_ELEVATION_STATUS_4_CONTRAST"] = "mossElevation.status4Contrast";
  EDionColors2["MOSS_ELEVATION_STATUS_4_BACKGROUND"] = "mossElevation.status4Background";
  EDionColors2["MOSS_ELEVATION_STATUS_4_CONTENT"] = "mossElevation.status4Content";
  EDionColors2["MOSS_ELEVATION_STATUS_3_CONTRAST"] = "mossElevation.status3Contrast";
  EDionColors2["MOSS_ELEVATION_STATUS_3_BACKGROUND"] = "mossElevation.status3Background";
  EDionColors2["MOSS_ELEVATION_STATUS_3_CONTENT"] = "mossElevation.status3Content";
  EDionColors2["MOSS_ELEVATION_STATUS_2_CONTRAST"] = "mossElevation.status2Contrast";
  EDionColors2["MOSS_ELEVATION_STATUS_2_BACKGROUND"] = "mossElevation.status2Background";
  EDionColors2["MOSS_ELEVATION_STATUS_2_CONTENT"] = "mossElevation.status2Content";
  EDionColors2["MOSS_ELEVATION_STATUS_1_CONTRAST"] = "mossElevation.status1Contrast";
  EDionColors2["MOSS_ELEVATION_STATUS_1_BACKGROUND"] = "mossElevation.status1Background";
  EDionColors2["MOSS_ELEVATION_STATUS_1_CONTENT"] = "mossElevation.status1Content";
  EDionColors2["MOSS_ELEVATION_INFO_CONTRAST"] = "mossElevation.infoContrast";
  EDionColors2["MOSS_ELEVATION_INFO_BACKGROUND"] = "mossElevation.infoBackground";
  EDionColors2["MOSS_ELEVATION_INFO_CONTENT"] = "mossElevation.infoContent";
  EDionColors2["MOSS_ELEVATION_WARNING_CONTRAST"] = "mossElevation.warningContrast";
  EDionColors2["MOSS_ELEVATION_WARNING_BACKGROUND"] = "mossElevation.warningBackground";
  EDionColors2["MOSS_ELEVATION_WARNING_CONTENT"] = "mossElevation.warningContent";
  EDionColors2["MOSS_ELEVATION_SUCCESS_CONTRAST"] = "mossElevation.successContrast";
  EDionColors2["MOSS_ELEVATION_SUCCESS_BACKGROUND"] = "mossElevation.successBackground";
  EDionColors2["MOSS_ELEVATION_SUCCESS_CONTENT"] = "mossElevation.successContent";
  EDionColors2["MOSS_ELEVATION_ERROR_CONTRAST"] = "mossElevation.errorContrast";
  EDionColors2["MOSS_ELEVATION_ERROR_BACKGROUND"] = "mossElevation.errorBackground";
  EDionColors2["MOSS_ELEVATION_ERROR_CONTENT"] = "mossElevation.errorContent";
  EDionColors2["MOSS_ELEVATION_BRAND_CONTRAST"] = "mossElevation.brandContrast";
  EDionColors2["MOSS_ELEVATION_BRAND_BACKGROUND"] = "mossElevation.brandBackground";
  EDionColors2["MOSS_ELEVATION_BRAND_CONTENT"] = "mossElevation.brandContent";
  EDionColors2["MOSS_ELEVATION_DISABLE_TEXT"] = "mossElevation.disableText";
  EDionColors2["MOSS_ELEVATION_DISABLE"] = "mossElevation.disable";
  EDionColors2["MOSS_ELEVATION_TRANSPARENT"] = "mossElevation.transparent";
  EDionColors2["MOSS_ELEVATION_FOCUS"] = "mossElevation.focus";
  EDionColors2["MOSS_ELEVATION_PRESS"] = "mossElevation.press";
  EDionColors2["MOSS_ELEVATION_HOVER"] = "mossElevation.hover";
  EDionColors2["MOSS_ELEVATION_LOW_ACCENT"] = "mossElevation.lowAccent";
  EDionColors2["MOSS_ELEVATION_ACCENT"] = "mossElevation.accent";
  EDionColors2["MOSS_ELEVATION_ADDITIONAL"] = "mossElevation.additional";
  EDionColors2["MOSS_ELEVATION_LOW_CONTRAST"] = "mossElevation.lowContrast";
  EDionColors2["MOSS_ELEVATION_CONTRAST"] = "mossElevation.contrast";
  EDionColors2["MOSS_ELEVATION_MAIN"] = "mossElevation.main";
  EDionColors2["WHITEBOARD_STATUS_5_CONTRAST"] = "whiteboard.status5Contrast";
  EDionColors2["WHITEBOARD_STATUS_5_BACKGROUND"] = "whiteboard.status5Background";
  EDionColors2["WHITEBOARD_STATUS_5_CONTENT"] = "whiteboard.status5Content";
  EDionColors2["WHITEBOARD_STATUS_4_CONTRAST"] = "whiteboard.status4Contrast";
  EDionColors2["WHITEBOARD_STATUS_4_BACKGROUND"] = "whiteboard.status4Background";
  EDionColors2["WHITEBOARD_STATUS_4_CONTENT"] = "whiteboard.status4Content";
  EDionColors2["WHITEBOARD_STATUS_3_CONTRAST"] = "whiteboard.status3Contrast";
  EDionColors2["WHITEBOARD_STATUS_3_BACKGROUND"] = "whiteboard.status3Background";
  EDionColors2["WHITEBOARD_STATUS_3_CONTENT"] = "whiteboard.status3Content";
  EDionColors2["WHITEBOARD_STATUS_2_CONTRAST"] = "whiteboard.status2Contrast";
  EDionColors2["WHITEBOARD_STATUS_2_BACKGROUND"] = "whiteboard.status2Background";
  EDionColors2["WHITEBOARD_STATUS_2_CONTENT"] = "whiteboard.status2Content";
  EDionColors2["WHITEBOARD_STATUS_1_CONTRAST"] = "whiteboard.status1Contrast";
  EDionColors2["WHITEBOARD_STATUS_1_BACKGROUND"] = "whiteboard.status1Background";
  EDionColors2["WHITEBOARD_STATUS_1_CONTENT"] = "whiteboard.status1Content";
  EDionColors2["WHITEBOARD_INFO_CONTRAST"] = "whiteboard.infoContrast";
  EDionColors2["WHITEBOARD_INFO_BACKGROUND"] = "whiteboard.infoBackground";
  EDionColors2["WHITEBOARD_INFO_CONTENT"] = "whiteboard.infoContent";
  EDionColors2["WHITEBOARD_WARNING_CONTRAST"] = "whiteboard.warningContrast";
  EDionColors2["WHITEBOARD_WARNING_BACKGROUND"] = "whiteboard.warningBackground";
  EDionColors2["WHITEBOARD_WARNING_CONTENT"] = "whiteboard.warningContent";
  EDionColors2["WHITEBOARD_SUCCESS_CONTRAST"] = "whiteboard.successContrast";
  EDionColors2["WHITEBOARD_SUCCESS_BACKGROUND"] = "whiteboard.successBackground";
  EDionColors2["WHITEBOARD_SUCCESS_CONTENT"] = "whiteboard.successContent";
  EDionColors2["WHITEBOARD_ERROR_CONTRAST"] = "whiteboard.errorContrast";
  EDionColors2["WHITEBOARD_ERROR_BACKGROUND"] = "whiteboard.errorBackground";
  EDionColors2["WHITEBOARD_ERROR_CONTENT"] = "whiteboard.errorContent";
  EDionColors2["WHITEBOARD_BRAND_CONTRAST"] = "whiteboard.brandContrast";
  EDionColors2["WHITEBOARD_BRAND_BACKGROUND"] = "whiteboard.brandBackground";
  EDionColors2["WHITEBOARD_BRAND_CONTENT"] = "whiteboard.brandContent";
  EDionColors2["WHITEBOARD_DISABLE_TEXT"] = "whiteboard.disableText";
  EDionColors2["WHITEBOARD_DISABLE"] = "whiteboard.disable";
  EDionColors2["WHITEBOARD_TRANSPARENT"] = "whiteboard.transparent";
  EDionColors2["WHITEBOARD_FOCUS"] = "whiteboard.focus";
  EDionColors2["WHITEBOARD_PRESS"] = "whiteboard.press";
  EDionColors2["WHITEBOARD_HOVER"] = "whiteboard.hover";
  EDionColors2["WHITEBOARD_LOW_ACCENT"] = "whiteboard.lowAccent";
  EDionColors2["WHITEBOARD_ACCENT"] = "whiteboard.accent";
  EDionColors2["WHITEBOARD_ADDITIONAL"] = "whiteboard.additional";
  EDionColors2["WHITEBOARD_LOW_CONTRAST"] = "whiteboard.lowContrast";
  EDionColors2["WHITEBOARD_CONTRAST"] = "whiteboard.contrast";
  EDionColors2["WHITEBOARD_MAIN"] = "whiteboard.main";
  return EDionColors2;
})(EDionColors || {});
var EDionButtonSizes = /* @__PURE__ */ ((EDionButtonSizes2) => {
  EDionButtonSizes2["XL"] = "xl";
  EDionButtonSizes2["L"] = "l";
  EDionButtonSizes2["M"] = "m";
  EDionButtonSizes2["S"] = "s";
  EDionButtonSizes2["XS"] = "xs";
  EDionButtonSizes2["XXS"] = "xxs";
  EDionButtonSizes2["XXXS"] = "xxxs";
  return EDionButtonSizes2;
})(EDionButtonSizes || {});
var tokens_default = tokens;
export {
  EDionButtonSizes,
  EDionColorGroups,
  EDionColorNames,
  EDionColors,
  EThemeGradients,
  tokens_default as default
};
